export const menu = [
  {
    id: 1,
    title: "main",
    listItems: [
      {
        id: 1,
        title: "Homepage",
        url: "/",
        icon: "home.svg",
      },
    ],
  },
  {
    id: 2,
    title: "lists",
    listItems: [
      {
        id: 1,
        title: "Doctors",
        url: "/doctors",
        icon: "user.svg",
      },
      {
        id: 2,
        title: "Patients",
        url: "/patients",
        icon: "patients.svg",
      },
      {
        id: 3,
        title: "Appointments",
        url: "/appointments",
        icon: "appointment.svg",
      },
    ],
  },
  {
    id: 3,
    title: "general",
    listItems: [
      {
        id: 1,
        title: "Blogs",
        url: "/blogs",
        icon: "post.svg",
      },
      {
        id: 2,
        title: "Messages",
        url: "/messages",
        icon: "note.svg",
      },
      {
        id: 4,
        title: "Admins",
        url: "/admins",
        icon: "admin.svg",
      },
    ],
  },
  {
    id: 4,
    title: "Maintenance",
    listItems: [
      {
        id: 1,
        title: "Settings",
        url: "/",
        icon: "setting.svg",
      },
      {
        id: 2,
        title: "Profile",
        url: "/users/1",
        icon: "user.svg",
      },
    ],
  },
];

export const topDealUsers = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/8405873/pexels-photo-8405873.jpeg?auto=compress&cs=tinysrgb&w=1600&lazy=load",
    username: "Elva McDonald",
    email: "elva@gmail.com",
    amount: "3.668",
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=1600",
    username: "Linnie Nelson",
    email: "linnie@gmail.com",
    amount: "3.256",
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=1600",
    username: "Brent Reeves",
    email: "brent@gmail.com",
    amount: "2.998",
  },
  {
    id: 4,
    img: "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=1600",
    username: "Adeline Watson",
    email: "adeline@gmail.com",
    amount: "2.512",
  },
  {
    id: 5,
    img: "https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=1600",
    username: "Juan Harrington",
    email: "juan@gmail.com",
    amount: "2.134",
  },
  {
    id: 6,
    img: "https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=1600",
    username: "Augusta McGee",
    email: "augusta@gmail.com",
    amount: "1.932",
  },
  {
    id: 7,
    img: "https://images.pexels.com/photos/874158/pexels-photo-874158.jpeg?auto=compress&cs=tinysrgb&w=1600",
    username: "Angel Thomas",
    email: "angel@gmail.com",
    amount: "1.560",
  },
];

export const chartBoxUser = {
  color: "#8884d8",
  icon: "/userIcon.svg",
  title: "Total Users",
  number: "11.238",
  dataKey: "users",
  percentage: 45,
  chartData: [
    { name: "Sun", users: 400 },
    { name: "Mon", users: 600 },
    { name: "Tue", users: 500 },
    { name: "Wed", users: 700 },
    { name: "Thu", users: 400 },
    { name: "Fri", users: 500 },
    { name: "Sat", users: 450 },
  ],
};

export const chartBoxProduct = {
  color: "skyblue",
  icon: "/productIcon.svg",
  title: "Total Products",
  number: "238",
  dataKey: "products",
  percentage: 21,
  chartData: [
    { name: "Sun", products: 400 },
    { name: "Mon", products: 600 },
    { name: "Tue", products: 500 },
    { name: "Wed", products: 700 },
    { name: "Thu", products: 400 },
    { name: "Fri", products: 500 },
    { name: "Sat", products: 450 },
  ],
};
export const chartBoxRevenue = {
  color: "teal",
  icon: "/revenueIcon.svg",
  title: "Total Revenue",
  number: "$56.432",
  dataKey: "revenue",
  percentage: -12,
  chartData: [
    { name: "Sun", revenue: 400 },
    { name: "Mon", revenue: 600 },
    { name: "Tue", revenue: 500 },
    { name: "Wed", revenue: 700 },
    { name: "Thu", revenue: 400 },
    { name: "Fri", revenue: 500 },
    { name: "Sat", revenue: 450 },
  ],
};
export const chartBoxConversion = {
  color: "gold",
  icon: "/conversionIcon.svg",
  title: "Total Ratio",
  number: "2.6",
  dataKey: "ratio",
  percentage: 12,
  chartData: [
    { name: "Sun", ratio: 400 },
    { name: "Mon", ratio: 600 },
    { name: "Tue", ratio: 500 },
    { name: "Wed", ratio: 700 },
    { name: "Thu", ratio: 400 },
    { name: "Fri", ratio: 500 },
    { name: "Sat", ratio: 450 },
  ],
};

export const barChartBoxRevenue = {
  title: "Profit Earned",
  color: "#8884d8",
  dataKey: "profit",
  chartData: [
    {
      name: "Sun",
      profit: 4000,
    },
    {
      name: "Mon",
      profit: 3000,
    },
    {
      name: "Tue",
      profit: 2000,
    },
    {
      name: "Wed",
      profit: 2780,
    },
    {
      name: "Thu",
      profit: 1890,
    },
    {
      name: "Fri",
      profit: 2390,
    },
    {
      name: "Sat",
      profit: 3490,
    },
  ],
};

export const barChartBoxVisit = {
  title: "Total Visit",
  color: "#FF8042",
  dataKey: "visit",
  chartData: [
    {
      name: "Sun",
      visit: 4000,
    },
    {
      name: "Mon",
      visit: 3000,
    },
    {
      name: "Tue",
      visit: 2000,
    },
    {
      name: "Wed",
      visit: 2780,
    },
    {
      name: "Thu",
      visit: 1890,
    },
    {
      name: "Fri",
      visit: 2390,
    },
    {
      name: "Sat",
      visit: 3490,
    },
  ],
};

export const userRows = [
  {
    id: 1,
    img: "https://images.pexels.com/photos/8405873/pexels-photo-8405873.jpeg?auto=compress&cs=tinysrgb&w=1600&lazy=load",
    lastName: "Hubbard",
    firstName: "Eula",
    email: "kewez@@gmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
    verified: true,
  },
  {
    id: 2,
    img: "https://images.pexels.com/photos/1181519/pexels-photo-1181519.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Manning",
    firstName: "Stella",
    email: "comhuhmit@gmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
    verified: true,
  },
  {
    id: 3,
    img: "https://images.pexels.com/photos/1587009/pexels-photo-1587009.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Greer",
    firstName: "Mary",
    email: "ujudokon@hottmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
    verified: true,
  },
  {
    id: 4,
    img: "https://images.pexels.com/photos/871495/pexels-photo-871495.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Williamson",
    firstName: "Mildred",
    email: "tinhavabe@gmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
    verified: true,
  },
  {
    id: 5,
    img: "https://images.pexels.com/photos/1758144/pexels-photo-1758144.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Gross",
    firstName: "Jose",
    email: "gobtagbes@yahoo.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
  },
  {
    id: 6,
    img: "https://images.pexels.com/photos/769745/pexels-photo-769745.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Sharp",
    firstName: "Jeremy",
    email: "vulca.eder@mail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
    verified: true,
  },
  {
    id: 7,
    img: "https://images.pexels.com/photos/1043474/pexels-photo-1043474.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Lowe",
    firstName: "Christina",
    email: "reso.bilic@gmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
  },
  {
    id: 8,
    img: "https://images.pexels.com/photos/428364/pexels-photo-428364.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Dean",
    firstName: "Garrett",
    email: "codaic@mail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
    verified: true,
  },
  {
    id: 9,
    img: "https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Parsons",
    firstName: "Leah",
    email: "uzozor@gmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
  },
  {
    id: 10,
    img: "https://images.pexels.com/photos/775358/pexels-photo-775358.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Reid",
    firstName: "Elnora",
    email: "tuhkabapu@gmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
    verified: true,
  },
  {
    id: 11,
    img: "https://images.pexels.com/photos/762020/pexels-photo-762020.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Dunn",
    firstName: "Gertrude",
    email: "gibo@gmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
    verified: true,
  },
  {
    id: 12,
    img: "https://images.pexels.com/photos/774095/pexels-photo-774095.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Williams",
    firstName: "Mark",
    email: "tic.harvey@hotmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
  },
  {
    id: 13,
    img: "https://images.pexels.com/photos/761977/pexels-photo-761977.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Cruz",
    firstName: "Charlotte",
    email: "ceuc@gmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
  },
  {
    id: 14,
    img: "https://images.pexels.com/photos/927022/pexels-photo-927022.jpeg?auto=compress&cs=tinysrgb&w=1600",
    lastName: "Harper",
    firstName: "Sara",
    email: "bafuv@hotmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
  },
  {
    id: 15,
    img: "https://images.pexels.com/photos/8405873/pexels-photo-8405873.jpeg?auto=compress&cs=tinysrgb&w=1600&lazy=load",
    lastName: "Griffin",
    firstName: "Eric",
    email: "ubi@gmail.com",
    phone: "123 456 789",
    createdAt: "01.02.2023",
  },
];

export const products = [
  {
    id: 1,
    img: "https://store.sony.com.au/on/demandware.static/-/Sites-sony-master-catalog/default/dw1b537bbb/images/PLAYSTATION5W/PLAYSTATION5W.png",
    title: "Playstation 5 Digital Edition",
    color: "white",
    producer: "Sony",
    price: "$250.99",
    createdAt: "01.02.2023",
    inStock: true,
  },
  {
    id: 2,
    img: "https://www.pngmart.com/files/6/Dell-Laptop-PNG-Image.png",
    title: "Dell Laptop KR211822",
    color: "black",
    producer: "Dell",
    price: "$499.99",
    createdAt: "01.02.2023",
    inStock: true,
  },
  {
    id: 3,
    img: "http://images.samsung.com/is/image/samsung/uk-led-tv-hg40ed670ck-hg40ed670ckxxu-001-front",
    title: "Samsung TV 4K SmartTV",
    color: "gray",
    producer: "Samsung",
    price: "$999.49",
    createdAt: "01.02.2023",
    inStock: true,
  },
  {
    id: 4,
    img: "https://raylo.imgix.net/iphone-14-blue.png",
    title: "Apple Iphone 14 Pro Max",
    color: "white",
    producer: "Apple",
    price: "$799.49",
    createdAt: "01.02.2023",
    inStock: true,
  },
  {
    id: 5,
    img: "https://www.signify.com/b-dam/signify/en-aa/about/news/2020/20200903-movie-night-essentials-popcorn-ice-cream-and-the-new-philips-hue-play-gradient-lightstrip/packaging-lighstrip.png",
    title: "Philips Hue Play Gradient",
    color: "rainbow",
    producer: "Philips",
    price: "$39.99",
    createdAt: "01.02.2023",
  },
  {
    id: 6,
    img: "https://www.smartworld.it/wp-content/uploads/2019/09/High_Resolution_PNG-MX-Master-3-LEFT-GRAPHITE.png",
    title: "Logitech MX Master 3",
    color: "black",
    producer: "Logitech",
    price: "$59.49",
    createdAt: "01.02.2023",
    inStock: true,
  },
  {
    id: 7,
    img: "https://www.pngarts.com/files/7/Podcast-Mic-PNG-Picture.png",
    title: "Rode Podcast Microphone",
    color: "gray",
    producer: "Rode",
    price: "$119.49",
    createdAt: "01.02.2023",
  },
  {
    id: 8,
    img: "https://5.imimg.com/data5/SW/VM/MY-5774620/toshiba-split-ac-2-ton-3-star-rated-ras-24s3ks-500x500.png",
    title: "Toshiba Split AC 2",
    color: "white",
    producer: "Toshiba",
    price: "$899.99",
    createdAt: "01.02.2023",
    inStock: true,
  },
  {
    id: 9,
    img: "https://img.productz.com/review_image/102489/preview_sony-kdl-50w800b-50-inch-hdtv-review-superb-picture-102489.png",
    title: "Sony Bravia KDL-47W805A",
    color: "black",
    producer: "Sony",
    price: "$970.49",
    createdAt: "01.02.2023",
  },
  {
    id: 10,
    img: "https://venturebeat.com/wp-content/uploads/2015/07/As_AO1-131_gray_nonglare_win10_03.png?fit=1338%2C1055&strip=all",
    title: "Acer Laptop 16 KL-4804",
    color: "black",
    producer: "Acer",
    price: "$599.99",
    createdAt: "01.02.2023",
    inStock: true,
  },
];

export const singleUser = {
  id: 1,
  title: "John Doe",
  img: "https://images.pexels.com/photos/17397364/pexels-photo-17397364.jpeg?auto=compress&cs=tinysrgb&w=1600&lazy=load",
  info: {
    username: "Johndoe99",
    fullname: "John Doe",
    email: "johndoe@gmail.com",
    phone: "123 456 789",
    status: "verified",
  },
  chart: {
    dataKeys: [
      { name: "visits", color: "#82ca9d" },
      { name: "clicks", color: "#8884d8" },
    ],
    data: [
      {
        name: "Sun",
        visits: 4000,
        clicks: 2400,
      },
      {
        name: "Mon",
        visits: 3000,
        clicks: 1398,
      },
      {
        name: "Tue",
        visits: 2000,
        clicks: 3800,
      },
      {
        name: "Wed",
        visits: 2780,
        clicks: 3908,
      },
      {
        name: "Thu",
        visits: 1890,
        clicks: 4800,
      },
      {
        name: "Fri",
        visits: 2390,
        clicks: 3800,
      },
      {
        name: "Sat",
        visits: 3490,
        clicks: 4300,
      },
    ],
  },
  activities: [
    {
      text: "John Doe purchased Playstation 5 Digital Edition",
      time: "3 day ago",
    },
    {
      text: "John Doe added 3 items into their wishlist",
      time: "1 week ago",
    },
    {
      text: "John Doe purchased Sony Bravia KD-32w800",
      time: "2 weeks ago",
    },
    {
      text: "John Doe reviewed a product",
      time: "1 month ago",
    },
    {
      text: "John Doe added 1 items into their wishlist",
      time: "1 month ago",
    },
    {
      text: "John Doe reviewed a product",
      time: "2 months ago",
    },
  ],
};
export const singleProduct = {
  id: 1,
  title: "Playstation 5 Digital Edition",
  img: "https://store.sony.com.au/on/demandware.static/-/Sites-sony-master-catalog/default/dw1b537bbb/images/PLAYSTATION5W/PLAYSTATION5W.png",
  info: {
    productId: "Ps5SDF1156d",
    color: "white",
    price: "$250.99",
    producer: "Sony",
    export: "Japan",
  },
  chart: {
    dataKeys: [
      { name: "visits", color: "#82ca9d" },
      { name: "orders", color: "#8884d8" },
    ],
    data: [
      {
        name: "Sun",
        visits: 4000,
        orders: 2400,
      },
      {
        name: "Mon",
        visits: 3000,
        orders: 1398,
      },
      {
        name: "Tue",
        visits: 2000,
        orders: 3800,
      },
      {
        name: "Wed",
        visits: 2780,
        orders: 3908,
      },
      {
        name: "Thu",
        visits: 1890,
        orders: 4800,
      },
      {
        name: "Fri",
        visits: 2390,
        orders: 3800,
      },
      {
        name: "Sat",
        visits: 3490,
        orders: 4300,
      },
    ],
  },
  activities: [
    {
      text: "John Doe purchased Playstation 5 Digital Edition",
      time: "3 day ago",
    },
    {
      text: "Jane Doe added Playstation 5 Digital Edition into their wishlist",
      time: "1 week ago",
    },
    {
      text: "Mike Doe purchased Playstation 5 Digital Edition",
      time: "2 weeks ago",
    },
    {
      text: "Anna Doe reviewed the product",
      time: "1 month ago",
    },
    {
      text: "Michael Doe added Playstation 5 Digital Edition into their wishlist",
      time: "1 month ago",
    },
    {
      text: "Helen Doe reviewed the product",
      time: "2 months ago",
    },
  ],
};

export const councils = [
  { id: 1, name: "Andhra Pradesh Medical Council" },
  { id: 2, name: "Arunachal Pradesh Medical Council" },
  { id: 3, name: "Assam Medical Council" },
  { id: 28, name: "Bhopal Medical Council" },
  { id: 4, name: "Bihar Medical Council" },
  { id: 29, name: "Bombay Medical Council" },
  { id: 30, name: "Chandigarh Medical Council" },
  { id: 5, name: "Chattisgarh Medical Council" },
  { id: 6, name: "Delhi Medical Council" },
  { id: 7, name: "Goa Medical Council" },
  { id: 8, name: "Gujarat Medical Council" },
  { id: 9, name: "Haryana Medical Council" },
  { id: 45, name: "Hyderabad Medical Council" },
  { id: 10, name: "Himachal Pradesh Medical Council" },
  { id: 11, name: "Jammu & Kashmir Medical Council" },
  { id: 12, name: "Jharkhand Medical Council" },
  { id: 13, name: "Karnataka Medical Council" },
  { id: 46, name: "Medical Council of India" },
  { id: 47, name: "Medical Council of Tanganyika" },
  { id: 26, name: "Manipur Medical Council" },
  { id: 36, name: "Madras Medical Council" },
  { id: 15, name: "Madhya Pradesh Medical Council" },
  { id: 35, name: "Mahakoshal Medical Council" },
  { id: 16, name: "Maharashtra Medical Council" },
  { id: 42, name: "Mizoram Medical Council" },
  { id: 37, name: "Mysore Medical Council" },
  { id: 41, name: "Nagaland Medical Council" },
  { id: 17, name: "Orissa Council of Medical Registration" },
  { id: 38, name: "Pondicherry Medical Council" },
  { id: 18, name: "Punjab Medical Council" },
  { id: 19, name: "Rajasthan Medical Council" },
  { id: 43, name: "Telangana State Medical Council" },
  { id: 50, name: "Travancore Cochin Medical Council, Trivandrum" },
  { id: 22, name: "Tripura State Medical Council" },
  { id: 23, name: "Uttar Pradesh Medical Council" },
  { id: 24, name: "Uttarakhand Medical Council" },
  { id: 40, name: "Vidharba Medical Council" },
  { id: 20, name: "Sikkim Medical Council" },
  { id: 21, name: "Tamil Nadu Medical Council" },
  { id: 25, name: "West Bengal Medical Council" },
];

export const weekdays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export const departments = [
  "Eye Care",
  "gynecologist",
  "psychotherapist",
  "orthopedic",
  "dentist",
  "gastrologist",
  "urologist",
  "neurologist",
];

export const addDoctorFieldsUpdate = [
  ["Name", "name", "text"],
  ["Email", "email", "email"],
  ["Password", "password", "password"],
  ["Phone", "phone", "text"],
  ["Date of Birth", "dob", "date"],
  ["Gender", "gender", "select", ["Male", "Female", "Other"]], // Added 'select' with options
  [
    "Department",
    "doctorDepartment",
    "select",
    [
      "Eye Care",
      "Gynecologist",
      "Psychotherapist",
      "Orthopedic",
      "Dentist",
      "Gastrologist",
      "Urologist",
      "Neurologist",
    ],
  ],
  ["Registration Number", "registrationNumber", "text"],
  ["Year of Registration", "year", "text"],
  ["Fee Per Consultation", "feePerConsultation", "number"],
  ["Status", "status", "select", ["Pending", "Accepted", "Rejected"]],
];

export const addDoctorFields = [
  ["Name", "name", "text"],
  ["Email", "email", "email"],
  ["Password", "password", "password"],
  ["Phone", "phone", "text"],
  ["Date of Birth", "dob", "date"],
  ["Gender", "gender", "select", ["Male", "Female", "Other"]], // Added 'select' with options
  [
    "Department",
    "doctorDepartment",
    "select",
    [
      "Eye Care",
      "Gynecologist",
      "Psychotherapist",
      "Orthopedic",
      "Dentist",
      "Gastrologist",
      "Urologist",
      "Neurologist",
    ],
  ],
  ["Registration Number", "registrationNumber", "text"],
  ["Year of Registration", "year", "text"],
  ["Fee Per Consultation", "feePerConsultation", "number"],
];

export const teamData = [
  {
    imgUrl: "/images/doctors/doctor_1.png",
    department: "Emergency Department",
    name: "Dr. Lisa Chen, MD",
    designation: "Emergency Medicine Specialist",
    description:
      "Dr. Chen has over 10 years of experience in emergency medicine and is board certified in emergency medicine. She has a special interest in critical care and trauma management.",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "cardiology",
    href: "/doctors/doctor-details",
  },
  {
    imgUrl: "/images/doctors/doctor_2.png",
    department: "Emergency Department",
    name: "Dr. Michael Johnson, MD",
    designation: "Emergency Medicine Specialist",
    description:
      "Dr. Johnson is a highly experienced emergency medicine physician with over 15 years of experience. He is board-certified in emergency medicine and has a special interest in disaster management.",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "emergency",
    href: "/doctors/doctor-details",
  },
  {
    imgUrl: "/images/doctors/doctor_3.png",
    department: "Emergency Department",
    name: "Dr. Karen Lee, MD",
    designation: "Emergency Medicine Specialist",
    description:
      "Dr. Lee is a skilled emergency medicine physician with expertise in the treatment of acute medical conditions. She is board-certified in emergency medicine and has a special interest in cardiac.",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "pediatric",
    href: "/doctors/doctor-details",
  },
  {
    imgUrl: "/images/doctors/doctor_4.png",
    department: "Pediatric Department",
    name: "Dr. Sarah Patel, MD",
    designation: "Pediatrician",
    description:
      "Dr. Patel is a compassionate pediatrician with over 15 years of experience. She is board-certified in pediatrics and has a special interest in preventive care and childhood development.",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "others",
    href: "/doctors/doctor-details",
  },
  {
    imgUrl: "/images/doctors/doctor_5.png",
    department: "Pediatric Department",
    name: "Dr. David Nguyen, MD",
    designation: "Pediatrician",
    description:
      "Dr. Nguyen is a highly skilled pediatrician with expertise in the treatment of common childhood illnesses and conditions. She is board-certified in pediatrics",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "cardiology",
    href: "/doctors/doctor-details",
  },
  {
    imgUrl: "/images/doctors/doctor_6.png",
    department: "Pediatric Department",
    name: "Dr. Susan Bones, MD",
    designation: "Pediatrician",
    description:
      "Dr. Bones is a dedicated pediatrician with a focus on providing comprehensive care to children of all ages. He is board-certified in pediatrics and has a special interest in childhood obesity",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "psychiatry",
    href: "/doctors/doctor-details",
  },
  {
    imgUrl: "/images/doctors/doctor_7.png",
    department: "Emergency Department",
    name: "Dr. Lisa Chen, MD",
    designation: "Cardiologist",
    description:
      "Dr. Lee is a skilled cardiologist with expertise in the diagnosis and treatment of cardiovascular disease. He is board-certified in cardiology and has a special interest in preventive cardiology.",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "emergency",
    href: "/doctors/doctor-details",
  },
  {
    imgUrl: "/images/doctors/doctor_8.png",
    department: "Emergency Department",
    name: "Dr. Michelle Kim, MD",
    designation: "Cardiologist",
    description:
      "Dr. Kim is a renowned cardiologist with over 20 years of experience. She is board-certified in cardiology and has a special interest in the treatment of heart failure and arrhythmias.",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "others",
    href: "/doctors/doctor-details",
  },
  {
    imgUrl: "/images/doctors/doctor_9.png",
    department: "Emergency Department",
    name: "Dr. John Smith, MD",
    designation: "Cardiologist",
    description:
      "Dr. Smith is a board-certified cardiologist with extensive experience in the management of complex cardiac conditions. He has a special interest in interventional cardiology",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "psychiatry",
    href: "/doctors/doctor-details",
  },
  {
    imgUrl: "/images/doctors/doctor_10.png",
    department: "Psychiatry Department",
    name: "Dr. Sarah Lee, MD",
    designation: "Psychiatrist",
    description:
      "With more than 15 years of experience learning human psychology and behavior, Dr. Jones is an expert in managing mood disorders and anxiety disorders",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "others",
    href: "/doctors/doctor-details",
  },
  {
    imgUrl: "/images/doctors/doctor_11.png",
    department: "Psychiatry Department",
    name: "Dr. David Park, MD",
    designation: "Psychiatrist",
    description:
      "Dr. Park is a board-certified psychiatrist with over 10 years of experience. He has a special interest in addiction psychiatry and the treatment of substance use disorders.",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "emergency",
    href: "/doctors/doctor-details",
  },
  {
    imgUrl: "/images/doctors/doctor_12.png",
    department: "Psychiatry Department",
    name: "Dr. Maria Rodriguez, MD",
    designation: "Psychiatrist",
    description:
      "Dr. Chen is a skilled psychiatrist with expertise in the treatment of mood disorders and psychotic disorders. She is board-certified in psychiatry and has a special interest in the management.",
    social: [
      { icon: "fa6-brands:facebook-f", href: "/about" },
      { icon: "fa6-brands:linkedin-in", href: "/about" },
      { icon: "fa6-brands:twitter", href: "/about" },
    ],
    category: "pediatric",
    href: "/doctors/doctor-details",
  },
];

export const tags = [
  { tag: "Emergency", href: "/blog/blog-details" },
  { tag: "Pediatric", href: "/blog/blog-details" },
  { tag: "Cardiology", href: "/blog/blog-details" },
  { tag: "Psychiatry", href: "/blog/blog-details" },
  { tag: "Others", href: "/blog/blog-details" },
];
export const relatedBlog = [
  {
    title:
      "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
    thumbUrl: "/images/blog/post_1.jpeg",
    date: "March 12",
    btnText: "Learn More",
    href: "/blog/blog-details",
  },
  {
    title: `A Parent's Guide to Childhood Vaccinations: What You Need to Know`,
    thumbUrl: "/images/blog/post_2.jpeg",
    date: "March 11",
    btnText: "Learn More",
    href: "/blog/blog-details",
  },
  {
    title: "Preventing Heart Disease: Tips for a Heart-Healthy Lifestyle",
    thumbUrl: "/images/blog/post_3.jpeg",
    date: "March 9",
    btnText: "Learn More",
    href: "/blog/blog-details",
  },
];

export const newsData = [
  {
    path: "_news/2021-02-25-hong-kong-records-13-new-coronavirus-infections-three-of-them-untraceable.md",
    title:
      "Hong Kong records 13 new coronavirus infections, three of them untraceable",
    excerpt:
      "One of the untraceable cases involved a 62-year-old man who went to work the day after testing positive for reasons that remain unclear.",
    sourceUrl: null,
    webUrl:
      "https://www.scmp.com/news/hong-kong/health-environment/article/3123077/hong-kong-records-13-new-coronavirus-infections",
    originalUrl:
      "https://www.scmp.com/news/hong-kong/health-environment/article/3123077/hong-kong-records-13-new-coronavirus-infections",
    featuredContent: null,
    highlight: null,
    heat: 103,
    tags: ["China-HongKong", "CN", "CN-HK"],
    images: [
      {
        url: "https://cdn.i-scmp.com/sites/default/files/styles/og_image_scmp_coronavirus_generic/public/d8/images/methode/2021/02/25/1c14a918-7763-11eb-8b9d-76c80a88a6d4_image_hires_204027.jpg?itok=3AHu9yh1&v=1614256833",
        width: 1200,
        height: 630,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://amp.scmp.com/news/hong-kong/health-environment/article/3123077/hong-kong-records-13-new-coronavirus-infections",
    cdnAmpWebUrl:
      "https://amp-scmp-com.cdn.ampproject.org/c/s/amp.scmp.com/news/hong-kong/health-environment/article/3123077/hong-kong-records-13-new-coronavirus-infections",
    publishedDateTime: "2021-02-25T06:55:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "South China Morning Post",
      domain: "scmp.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in China", "Coronavirus in Asia", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-despite-covid-asian-outbound-real-estate-investment-recovering-in-2021.md",
    title:
      "Despite Covid, Asian Outbound Real Estate Investment Recovering in 2021",
    excerpt:
      "According to new research from global property consultant CBRE, Asian outbound commercial real estate investment volume declined 37% year-over-year to $30 billion in 2020, as Coronavirus-related obstacles including restrictions on travel and site inspections impeded purchasing activity.",
    sourceUrl: null,
    webUrl:
      "https://www.worldpropertyjournal.com/real-estate-news/singapore/commercial-real-estate-news-asian-property-investor-data-for-2020-cbre-asian-commercial-property-investment-report-cross-border-real-estate-investment-12395.php",
    originalUrl:
      "https://www.worldpropertyjournal.com/real-estate-news/singapore/commercial-real-estate-news-asian-property-investor-data-for-2020-cbre-asian-commercial-property-investment-report-cross-border-real-estate-investment-12395.php",
    featuredContent: null,
    highlight: null,
    heat: 70,
    tags: null,
    images: [
      {
        url: "https://www.worldpropertyjournal.com/news-assets/Singapore-City-keyimage2.jpg",
        width: 1400,
        height: 636,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl: null,
    cdnAmpWebUrl: null,
    publishedDateTime: "2021-02-25T06:53:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "International",
      domain: "worldpropertyjournal.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in Asia", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-covid-19-testing-site-now-at-riverview-park-activities-center.md",
    title: "COVID-19 testing site now at Riverview Park Activities Center",
    excerpt:
      "The Riverview Park Activities Center is now a site for COVID-19 testing. Officials say testing will be available in the parking lot, just look for the PODS",
    sourceUrl: null,
    webUrl:
      "https://www.wjbf.com/news/covid-19-testing-site-now-at-riverview-park-activities-center/",
    originalUrl:
      "https://www.wjbf.com/news/covid-19-testing-site-now-at-riverview-park-activities-center/",
    featuredContent: null,
    highlight: null,
    heat: 75,
    tags: null,
    images: [
      {
        url: "https://www.wjbf.com/wp-content/uploads/sites/47/2021/02/154362236_2826932214232743_6284941196951074119_n.jpg?w=1280",
        width: 490,
        height: 405,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://www.wjbf.com/news/covid-19-testing-site-now-at-riverview-park-activities-center/amp/",
    cdnAmpWebUrl:
      "https://www-wjbf-com.cdn.ampproject.org/c/s/www.wjbf.com/news/covid-19-testing-site-now-at-riverview-park-activities-center/amp/",
    publishedDateTime: "2021-02-25T06:51:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "WJBF",
      domain: "wjbf.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in Asia", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-new-york-district-attorney-reportedly-obtains-trumps-financial-records-live.md",
    title:
      "New York district attorney reportedly obtains Trump's financial records – live",
    excerpt:
      "Millions of pages of documents received after president has attempted for years to keep his records, particularly tax returns, out of public view",
    sourceUrl: null,
    webUrl:
      "https://www.theguardian.com/us-news/live/2021/feb/25/joe-biden-kamala-harris-covid-coronavirus-vaccine-donald-trump-cpac-live-updates",
    originalUrl:
      "https://www.theguardian.com/us-news/live/2021/feb/25/joe-biden-kamala-harris-covid-coronavirus-vaccine-donald-trump-cpac-live-updates",
    featuredContent: null,
    highlight: null,
    heat: 86,
    tags: ["US-NY"],
    images: [
      {
        url: "https://i.guim.co.uk/img/media/217e603b6b725cecaaa8e92cba452b33b4725a9e/0_267_4000_2400/master/4000.jpg?width=300&quality=45&auto=format&fit=max&dpr=2&s=350ce288ff53be8e28b963cceec278e2",
        width: 600,
        height: 360,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://amp.theguardian.com/us-news/live/2021/feb/25/joe-biden-kamala-harris-covid-coronavirus-vaccine-donald-trump-cpac-live-updates",
    cdnAmpWebUrl:
      "https://amp-theguardian-com.cdn.ampproject.org/c/s/amp.theguardian.com/us-news/live/2021/feb/25/joe-biden-kamala-harris-covid-coronavirus-vaccine-donald-trump-cpac-live-updates",
    publishedDateTime: "2021-02-25T06:50:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "The Guardian",
      domain: "theguardian.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/theguardian.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in US", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-coronavirus-live-news-china-approves-two-more-covid-vaccines-swedes-in-nursing-homes-can-see-family-again-after-two-jabs.md",
    title:
      "Coronavirus live news: China approves two more Covid vaccines; Swedes in nursing homes can see family again after two jabs",
    excerpt:
      "China now has four locally developed vaccines; Swedish health minister says elderly Swedes who are fully vaccinated can hug grandchildren",
    sourceUrl: null,
    webUrl:
      "https://www.theguardian.com/world/live/2021/feb/25/coronavirus-live-news-pfizer-vaccine-found-94-effective-in-major-study-eu-states-split-over-vaccine-passports?page=with:block-6037b2ae8f08614ccf106462",
    originalUrl:
      "https://www.theguardian.com/world/live/2021/feb/25/coronavirus-live-news-pfizer-vaccine-found-94-effective-in-major-study-eu-states-split-over-vaccine-passports?page=with:block-6037b2ae8f08614ccf106462",
    featuredContent: null,
    highlight: null,
    heat: 144,
    tags: ["CN"],
    images: [
      {
        url: "https://i.guim.co.uk/img/media/f7468b65e6bf8537fc536478903c57d9941ef742/0_226_3500_2101/master/3500.jpg?width=300&quality=45&auto=format&fit=max&dpr=2&s=75a743f5135e064b45c5987ef4f83e03",
        width: 600,
        height: 360,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://amp.theguardian.com/world/live/2021/feb/25/coronavirus-live-news-pfizer-vaccine-found-94-effective-in-major-study-eu-states-split-over-vaccine-passports",
    cdnAmpWebUrl:
      "https://amp-theguardian-com.cdn.ampproject.org/c/s/amp.theguardian.com/world/live/2021/feb/25/coronavirus-live-news-pfizer-vaccine-found-94-effective-in-major-study-eu-states-split-over-vaccine-passports",
    publishedDateTime: "2021-02-25T06:45:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "The Guardian",
      domain: "theguardian.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/theguardian.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in China", "Coronavirus in Asia", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-japan-fears-covid-19-will-herald-shift-in-power-balance.md",
    title: "Japan fears Covid-19 will herald shift in power balance",
    excerpt:
      "TOKYO - History is dotted with plagues that have triggered a paradigm shift in the balance of power, Japanese Foreign Minister Toshimitsu Motegi said yesterday as he stressed the need to look to the past for lessons on how the world might emerge from the Covid-19 pandemic.",
    sourceUrl: null,
    webUrl:
      "https://www.straitstimes.com/asia/east-asia/japan-fears-covid-19-will-herald-shift-in-power-balance",
    originalUrl:
      "https://www.straitstimes.com/asia/east-asia/japan-fears-covid-19-will-herald-shift-in-power-balance",
    featuredContent: null,
    highlight: null,
    heat: 95,
    tags: ["JP"],
    images: [
      {
        url: "https://c.files.bbci.co.uk/1391F/production/_128495108_ce10225f8b34296dda0592707884bd9dbdab13010_0_7087_49881000x704.jpg",
        width: 763,
        height: 509,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl: null,
    cdnAmpWebUrl: null,
    publishedDateTime: "2021-02-25T06:41:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "The Straits Times",
      domain: "straitstimes.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in Japan", "Coronavirus in Asia", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-shanghai-handed-asian-champions-league-berth-as-shandong-expulsion-confirmed.md",
    title:
      "Shanghai handed Asian Champions League berth as Shandong expulsion confirmed",
    excerpt:
      "Former Chinese champions Shanghai SIPG have earned a late call-up to the 2021 Asian Champions League after the Asian Football Confederation confirmed the expulsion of Shandong Luneng from the latest edition of the continental club championship.",
    sourceUrl: null,
    webUrl:
      "https://dunyanews.tv/en/Sports/589869-Shanghai-handed-Asian-Champions-League-berth-as-Shandong-expulsion",
    originalUrl:
      "https://dunyanews.tv/en/Sports/589869-Shanghai-handed-Asian-Champions-League-berth-as-Shandong-expulsion",
    featuredContent: null,
    highlight: null,
    heat: 82,
    tags: ["China-Shanghai", "CN", "CN-SH"],
    images: [
      {
        url: "https://img.dunyanews.tv/news/2021/February/02-25-21/news_big_images/589869_17364543.jpg",
        width: 556,
        height: 370,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl: "https://dunyanews.tv/amp/english/589869.php",
    cdnAmpWebUrl:
      "https://dunyanews-tv.cdn.ampproject.org/c/s/dunyanews.tv/amp/english/589869.php",
    publishedDateTime: "2021-02-25T06:35:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "Dunya News",
      domain: "dunyanews.tv",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in China", "Coronavirus in Asia", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-santa-monica-school-playground-temporarily-closed-for-repairs.md",
    title: "Santa Monica School Playground Temporarily Closed For Repairs",
    excerpt:
      "The Roosevelt Elementary School playground is closed for temporary repairs and service, the Santa Monica-Malibu Unified School District said. The temporary closure for school and community use includes the field,",
    sourceUrl: null,
    webUrl:
      "https://patch.com/california/santamonica/santa-monica-school-playground-temporarily-closed-repairs",
    originalUrl:
      "https://patch.com/california/santamonica/santa-monica-school-playground-temporarily-closed-repairs",
    featuredContent: null,
    highlight: null,
    heat: 110,
    tags: null,
    images: [
      {
        url: "https://patch.com/img/cdn20/shutterstock/753660/20210224/083628/styles/patch_image/public/shutterstock-145819646___24202418417.jpg?width=984",
        width: 711,
        height: 533,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://patch.com/california/santamonica/amp/29301423/santa-monica-school-playground-temporarily-closed-for-repairs",
    cdnAmpWebUrl:
      "https://patch-com.cdn.ampproject.org/c/s/patch.com/california/santamonica/amp/29301423/santa-monica-school-playground-temporarily-closed-for-repairs",
    publishedDateTime: "2021-02-25T06:33:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "Patch",
      domain: "patch.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Education Impact", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-rescinding-aca-may-worsen-racial-health-disparities-covid-19.md",
    title: "Rescinding ACA May Worsen Racial Health Disparities, COVID-19",
    excerpt:
      "If pre-existing condition protections are removed from the ACA, COVID-19 infection may lead to further racial health disparities in coverage.",
    sourceUrl: null,
    webUrl:
      "https://healthpayerintelligence.com/news/rescinding-aca-may-worsen-racial-health-disparities-covid-19",
    originalUrl:
      "https://healthpayerintelligence.com/news/rescinding-aca-may-worsen-racial-health-disparities-covid-19",
    featuredContent: null,
    highlight: null,
    heat: 75,
    tags: null,
    images: [
      {
        url: "https://healthpayerintelligence.com/images/sized/GettyImages-529278709-3f32efd853ffed8e5d8a1184abc2c18d.jpg",
        width: 480,
        height: 278,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://healthpayerintelligence.com/news/amp/rescinding-aca-may-worsen-racial-health-disparities-covid-19",
    cdnAmpWebUrl:
      "https://healthpayerintelligence-com.cdn.ampproject.org/c/s/healthpayerintelligence.com/news/amp/rescinding-aca-may-worsen-racial-health-disparities-covid-19",
    publishedDateTime: "2021-02-25T06:31:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "healthpayerintelligence.com",
      domain: "healthpayerintelligence.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in Asia", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-rep-reschenthaler-to-newsmax-tv-china-capitalized-on-pandemic-invaded-hong-kong.md",
    title:
      "Rep. Reschenthaler to Newsmax TV: China Capitalized on Pandemic, Invaded Hong Kong",
    excerpt:
      "China turned around and basically invaded Hong Kong, a quasi-independent city-state that was a Democracy, and took over this city-state against international treaties,” Reschenthaler said Wednesday during an appearance on Newsmax TV’s “Chris Salcedo Show.",
    sourceUrl: null,
    webUrl:
      "https://www.kabc.com/news/rep-reschenthaler-to-newsmax-tv-china-capitalized-on-pandemic-invaded-hong-kong/",
    originalUrl:
      "https://www.kabc.com/news/rep-reschenthaler-to-newsmax-tv-china-capitalized-on-pandemic-invaded-hong-kong/",
    featuredContent: null,
    highlight: null,
    heat: 74,
    tags: ["China-HongKong", "CN", "CN-HK"],
    images: [
      {
        url: "https://www.newsmax.com/Newsmax/files/08/083d9d4a-1ff0-4a61-89e5-696da700b318.jpg",
        width: 600,
        height: 500,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl: null,
    cdnAmpWebUrl: null,
    publishedDateTime: "2021-02-25T06:26:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "KABC",
      domain: "kabc.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in China", "Coronavirus in Asia", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-over-1000-tokyo-2020-volunteers-quit-over-covid-19-concerns.md",
    title: "Over 1,000 Tokyo 2020 volunteers quit over COVID-19 concerns",
    excerpt:
      "A large number of Olympics volunteers have decided to quit over the past month, organisers have said the number is around 1,000.",
    sourceUrl: null,
    webUrl:
      "https://www.espn.com.au/olympics/story/_/id/30961748/over-1000-tokyo-2020-volunteers-quit-covid-19-concerns",
    originalUrl:
      "https://www.espn.com.au/olympics/story/_/id/30961748/over-1000-tokyo-2020-volunteers-quit-covid-19-concerns",
    featuredContent: null,
    highlight: null,
    heat: 105,
    tags: ["JP"],
    images: [
      {
        url: "https://a1.espncdn.com/combiner/i?img=%2Fphoto%2F2021%2F0225%2Fr819340_1296x729_16%2D9.jpg",
        width: 1296,
        height: 729,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://www.espn.com.au/olympics/story/_/id/30961748/over-1000-tokyo-2020-volunteers-quit-covid-19-concerns?platform=amp",
    cdnAmpWebUrl:
      "https://www-espn-com-au.cdn.ampproject.org/c/s/www.espn.com.au/olympics/story/_/id/30961748/over-1000-tokyo-2020-volunteers-quit-covid-19-concerns?platform=amp",
    publishedDateTime: "2021-02-25T06:25:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "ESPN.com",
      domain: "espn.com.au",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in Japan", "Coronavirus in Asia", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-quick-service-restaurant-qsr-it-market-sales-to-receive-a-boost-due-to-covid-19-marketus-study.md",
    title:
      "Quick Service Restaurant (QSR) IT Market Sales to Receive a Boost Due to COVID-19: Market.us Study",
    excerpt:
      "The latest research report provides a complete assessment of the Global Quick Service Restaurant (QSR) IT market for the forecast year 2022-2031, which is beneficial for companies regardless of their size and revenue.",
    sourceUrl: null,
    webUrl:
      "https://www.marketwatch.com/press-release/quick-service-restaurant-qsr-it-market-sales-to-receive-a-boost-due-to-covid-19-marketus-study-2021-02-25",
    originalUrl:
      "https://www.marketwatch.com/press-release/quick-service-restaurant-qsr-it-market-sales-to-receive-a-boost-due-to-covid-19-marketus-study-2021-02-25",
    featuredContent: null,
    highlight: null,
    heat: 81,
    tags: null,
    images: [
      {
        url: "https://mw3.wsj.net/mw5/content/logos/mw_logo_social.png",
        width: 1200,
        height: 630,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl: null,
    cdnAmpWebUrl: null,
    publishedDateTime: "2021-02-25T06:22:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "MarketWatch",
      domain: "marketwatch.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/marketwatch.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Stock Impact", "Coronavirus", "Coronavirus in Asia"],
  },
  {
    path: "_news/2021-02-25-unemployment-claims-dropped-last-week-as-coronavirus-cases-eased.md",
    title: "Unemployment claims dropped last week as coronavirus cases eased.",
    excerpt:
      "The Labor Department is scheduled to release its weekly report on applications for government unemployment insurance.",
    sourceUrl: null,
    webUrl:
      "https://www.nytimes.com/2021/02/25/business/unemployment-claims.html",
    originalUrl:
      "https://www.nytimes.com/2021/02/25/business/unemployment-claims.html",
    featuredContent: null,
    highlight: null,
    heat: 105,
    tags: null,
    images: [
      {
        url: "https://static01.nyt.com/images/2021/02/25/us/25economy-briefing-jobless/25economy-briefing-jobless-facebookJumbo.jpg",
        width: 1050,
        height: 550,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://www.nytimes.com/2021/02/25/business/unemployment-claims.amp.html",
    cdnAmpWebUrl:
      "https://www-nytimes-com.cdn.ampproject.org/c/s/www.nytimes.com/2021/02/25/business/unemployment-claims.amp.html",
    publishedDateTime: "2021-02-25T06:19:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "New York Times",
      domain: "nytimes.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/nytimes.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Travel Impact", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-coronavirus-latest-news-police-chief-blames-surge-in-covid-breaches-on-lockdown-fatigue.md",
    title:
      "Coronavirus latest news: Police chief blames surge in Covid breaches on 'lockdown fatigue'",
    excerpt:
      'A police chief has blamed lockdown "fatigue" for a rise in Covid-19 rulebreakers as new figures show almost 40 per cent of all fines issued for breaches of coronavirus regulations came in just four weeks.',
    sourceUrl: null,
    webUrl:
      "https://www.telegraph.co.uk/global-health/science-and-disease/coronavirus-news-covid-vaccine-schools-lockdown-roadmap/",
    originalUrl:
      "https://www.telegraph.co.uk/global-health/science-and-disease/coronavirus-news-covid-vaccine-schools-lockdown-roadmap/",
    featuredContent: null,
    highlight: null,
    heat: 70,
    tags: null,
    images: [
      {
        url: "https://www.telegraph.co.uk/content/dam/global-health/2021/02/25/TELEMMGLPICT000251618145_trans_NvBQzQNjv4BqpVlberWd9EgFPZtcLiMQfyf2A9a6I9YchsjMeADBa08.jpeg",
        width: 2501,
        height: 1563,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://www.telegraph.co.uk/global-health/science-and-disease/coronavirus-news-covid-vaccine-schools-lockdown-roadmap/amp/",
    cdnAmpWebUrl:
      "https://www-telegraph-co-uk.cdn.ampproject.org/c/s/www.telegraph.co.uk/global-health/science-and-disease/coronavirus-news-covid-vaccine-schools-lockdown-roadmap/amp/",
    publishedDateTime: "2021-02-25T06:15:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "The Daily Telegraph",
      domain: "telegraph.co.uk",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus"],
  },
  {
    path: "_news/2021-02-25-harris-acknowledges-righteous-skepticism-over-covid-19-vaccine-but-says-it-will-save-your-life.md",
    title:
      "Harris acknowledges 'righteous skepticism' over COVID-19 vaccine, but says 'it will save your life'",
    excerpt:
      "Vice President Kamala Harris is urging Americans to get vaccinated for coronavirus while acknowledging the mistrust some have for medical research and development.",
    sourceUrl: null,
    webUrl:
      "https://www.foxnews.com/politics/harris-covid-vaccine-skepticism-save-your-life",
    originalUrl:
      "https://www.foxnews.com/politics/harris-covid-vaccine-skepticism-save-your-life",
    featuredContent: null,
    highlight: null,
    heat: 81,
    tags: null,
    images: [
      {
        url: "https://a57.foxnews.com/static.foxnews.com/foxnews.com/content/uploads/2021/02/640/320/Kamala-Harris-COVID-19-Vaccine-AP.jpg?ve=1&tl=1",
        width: 640,
        height: 320,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://www.foxnews.com/politics/harris-covid-vaccine-skepticism-save-your-life.amp",
    cdnAmpWebUrl:
      "https://www-foxnews-com.cdn.ampproject.org/c/s/www.foxnews.com/politics/harris-covid-vaccine-skepticism-save-your-life.amp",
    publishedDateTime: "2021-02-25T06:15:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "Fox News",
      domain: "foxnews.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/foxnews.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus"],
  },
  {
    path: "_news/2021-02-25-moderna-expects-184-billion-in-covid-19-vaccine-sales-in-2021.md",
    title: "Moderna expects $18.4 billion in COVID-19 vaccine sales in 2021",
    excerpt:
      "Moderna Inc said on Thursday it expects COVID-19 vaccine sales of $18.4 billion this year, above the $15 billion in sales forecast by Pfizer Inc for the only other vaccine authorized for emergency use in the United States so far.",
    sourceUrl: null,
    webUrl:
      "https://www.reuters.com/article/us-health-coronavirus-moderna/moderna-sees-184-billion-in-sales-from-covid-19-vaccine-in-2021-idUSKBN2AP1JL",
    originalUrl:
      "https://www.reuters.com/article/us-health-coronavirus-moderna/moderna-sees-184-billion-in-sales-from-covid-19-vaccine-in-2021-idUSKBN2AP1JL",
    featuredContent: null,
    highlight: null,
    heat: 145,
    tags: null,
    images: [
      {
        url: "https://s4.reutersmedia.net/resources/r/?m=02&d=20210225&t=2&i=1552876640&w=&fh=545px&fw=&ll=&pl=&sq=&r=LYNXMPEH1O0US",
        width: 817,
        height: 545,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl: "https://mobile.reuters.com/article/amp/idUSKBN2AP1JG",
    cdnAmpWebUrl:
      "https://mobile-reuters-com.cdn.ampproject.org/c/s/mobile.reuters.com/article/amp/idUSKBN2AP1JG",
    publishedDateTime: "2021-02-25T06:10:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "Reuters",
      domain: "reuters.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/reuters.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Treatment", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-covid-19-lockdowns-give-china-breathing-room-on-air-quality-targets.md",
    title:
      "Covid-19 lockdowns give China breathing room on air quality targets",
    excerpt:
      "Environment ministry reports PM2.5 pollution reductions meet national standard, if effects of pandemic discounted.",
    sourceUrl: null,
    webUrl:
      "https://www.scmp.com/news/china/politics/article/3123161/covid-19-lockdowns-give-china-breathing-room-air-quality",
    originalUrl:
      "https://www.scmp.com/news/china/politics/article/3123161/covid-19-lockdowns-give-china-breathing-room-air-quality",
    featuredContent: null,
    highlight: null,
    heat: 115,
    tags: ["CN"],
    images: [
      {
        url: "https://cdn.i-scmp.com/sites/default/files/styles/og_image_scmp_generic/public/d8/images/methode/2021/02/25/c4cd857a-7754-11eb-8b9d-76c80a88a6d4_image_hires_213028.jpg?itok=m-3RxExp&v=1614259837",
        width: 1200,
        height: 630,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://amp.scmp.com/news/china/politics/article/3123161/covid-19-lockdowns-give-china-breathing-room-air-quality",
    cdnAmpWebUrl:
      "https://amp-scmp-com.cdn.ampproject.org/c/s/amp.scmp.com/news/china/politics/article/3123161/covid-19-lockdowns-give-china-breathing-room-air-quality",
    publishedDateTime: "2021-02-25T06:03:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "South China Morning Post",
      domain: "scmp.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in China", "Coronavirus in Asia", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-washington-dc-police-fight-a-rise-in-carjackings-and-blame-covid-19.md",
    title:
      "Washington, D.C., Police Fight a Rise in Carjackings and Blame Covid-19",
    excerpt:
      "The nation’s capital and other cities report sharp increases in carjackings in 2020.",
    sourceUrl: null,
    webUrl:
      "https://www.wsj.com/articles/washington-d-c-police-fight-a-rise-in-carjackings-and-blame-covid-19-11614261600",
    originalUrl:
      "https://www.wsj.com/articles/washington-d-c-police-fight-a-rise-in-carjackings-and-blame-covid-19-11614261600",
    featuredContent: null,
    highlight: null,
    heat: 115,
    tags: ["US-DC"],
    images: [
      {
        url: "https://images.wsj.net/im-303368/social",
        width: 1280,
        height: 640,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://www.wsj.com/amp/articles/washington-d-c-police-fight-a-rise-in-carjackings-and-blame-covid-19-11614261600",
    cdnAmpWebUrl:
      "https://www-wsj-com.cdn.ampproject.org/c/s/www.wsj.com/amp/articles/washington-d-c-police-fight-a-rise-in-carjackings-and-blame-covid-19-11614261600",
    publishedDateTime: "2021-02-25T06:01:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "Wall Street Journal",
      domain: "wsj.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/wsj.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in US", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-australian-bid-put-on-ioc-fast-track-to-host-2032-olympics.md",
    title: "Australian bid put on IOC fast track to host 2032 Olympics",
    excerpt:
      "Did the Australian city of Brisbane just get picked as the host of the 2032 Olympics? It looked that way Wednesday when the International Olympic Committee named the",
    sourceUrl: null,
    webUrl:
      "https://apnews.com/article/australia-thomas-bach-brisbane-2020-tokyo-olympics-queensland-84821cc188179912ba06db06e9577450",
    originalUrl:
      "https://apnews.com/article/australia-thomas-bach-brisbane-2020-tokyo-olympics-queensland-84821cc188179912ba06db06e9577450",
    featuredContent: null,
    highlight: null,
    heat: 90,
    tags: ["JP"],
    images: [
      {
        url: "https://storage.googleapis.com/afs-prod/media/c67d0142b8f6486c8d8d62c14e0b926c/3000.jpeg",
        width: 3000,
        height: 2187,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl: null,
    cdnAmpWebUrl: null,
    publishedDateTime: "2021-02-25T06:00:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "Associated Press",
      domain: "apnews.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/apnews.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in Japan", "Coronavirus in Asia", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-governor-lujan-grisham-new-mexico-officials-to-provide-covid-19-update.md",
    title:
      "Governor Lujan Grisham, New Mexico officials to provide COVID-19 update",
    excerpt:
      "Governor Michelle Lujan Grisham and New Mexico officials will host a remote news conference at 3:30 p.m. on Thursday, Feb. 25 to provide an update on COVID-19 in the state.",
    sourceUrl: null,
    webUrl:
      "https://www.krqe.com/health/coronavirus-new-mexico/governor-lujan-grisham-new-mexico-officials-to-provide-covid-19-update/",
    originalUrl:
      "https://www.krqe.com/health/coronavirus-new-mexico/governor-lujan-grisham-new-mexico-officials-to-provide-covid-19-update/",
    featuredContent: null,
    highlight: null,
    heat: 75,
    tags: ["US-NM"],
    images: [
      {
        url: "https://www.krqe.com/wp-content/uploads/sites/12/2021/01/Michelle-Lujan-Grisham.jpg?w=1280",
        width: 833,
        height: 455,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://www.krqe.com/health/coronavirus-new-mexico/governor-lujan-grisham-new-mexico-officials-to-provide-covid-19-update/amp/",
    cdnAmpWebUrl:
      "https://www-krqe-com.cdn.ampproject.org/c/s/www.krqe.com/health/coronavirus-new-mexico/governor-lujan-grisham-new-mexico-officials-to-provide-covid-19-update/amp/",
    publishedDateTime: "2021-02-25T05:58:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "KRQE",
      domain: "krqe.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in US", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-live-updates-in-a-50-50-senate-one-democrats-power-swells.md",
    title: "Live Updates: In a 50-50 Senate, One Democrat’s Power Swells",
    excerpt:
      "Senator Joe Manchin, the most conservative Democrat in the chamber, has more leverage than ever before, and his votes can bless or curse his party’s priorities.",
    sourceUrl: null,
    webUrl: "https://www.nytimes.com/live/2021/02/25/us/joe-biden-news",
    originalUrl: "https://www.nytimes.com/live/2021/02/25/us/joe-biden-news",
    featuredContent: null,
    highlight: null,
    heat: 90,
    tags: null,
    images: [
      {
        url: "https://static01.nyt.com/images/2021/02/24/us/politics/24new-washington-briefing-ManchinSetUp/24new-washington-briefing-ManchinSetUp-facebookJumbo.jpg",
        width: 1050,
        height: 550,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://www.nytimes.com/live/2021/02/25/us/joe-biden-news.amp.html",
    cdnAmpWebUrl:
      "https://www-nytimes-com.cdn.ampproject.org/c/s/www.nytimes.com/live/2021/02/25/us/joe-biden-news.amp.html",
    publishedDateTime: "2021-02-25T05:57:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "New York Times",
      domain: "nytimes.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/nytimes.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Political Impact", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-california-reaches-another-bleak-milestone.md",
    title: "California Reaches Another Bleak Milestone",
    excerpt:
      "More than 50,000 people have died from Covid-19 in the state. Also: More on the Newsom recall effort; and remembering Fry’s Electronics.",
    sourceUrl: null,
    webUrl: "https://www.nytimes.com/2021/02/25/us/california-covid.html",
    originalUrl: "https://www.nytimes.com/2021/02/25/us/california-covid.html",
    featuredContent: null,
    highlight: null,
    heat: 110,
    tags: ["US-CA"],
    images: [
      {
        url: "https://static01.nyt.com/images/2021/02/25/us/25deathscatoday/merlin_184227360_e415f57f-ff21-49c0-8de6-505a59b5fa18-facebookJumbo.jpg",
        width: 1050,
        height: 550,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://www.nytimes.com/2021/02/25/us/california-covid.amp.html",
    cdnAmpWebUrl:
      "https://www-nytimes-com.cdn.ampproject.org/c/s/www.nytimes.com/2021/02/25/us/california-covid.amp.html",
    publishedDateTime: "2021-02-25T05:55:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "New York Times",
      domain: "nytimes.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/nytimes.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in US", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-modernas-covid-19-booster-plan-jjs-day-at-the-fda-consolidation-among-the-contractors.md",
    title:
      "Moderna’s Covid-19 booster plan, J&J’s day at the FDA, & consolidation among the contractors",
    excerpt:
      'Damian covers biotech, is a co-writer of The Readout newsletter, and a co-host of "The Readout LOUD" podcast. FDA scientists endorse J&J’s Covid vaccine, as new data… FDA scientists endorse J&J’s Covid vaccine, as new data shed light on efficacy How Covid-19 could usher in a new role for… How Covid-19 could usher in a new role for continuous glucose monitoring in hospitals Comparing the Covid-19 vaccines developed by Pfizer, Moderna, and… Comparing the Covid-19 vaccines developed by Pfizer, Moderna, and Johnson & Johnson Recommended J&J’s vaccine data, OpenBiome’s last days, & making the… J&J’s vaccine data, OpenBiome’s last days, & making the most of soaring stock Vaccine execs go to Washington, Moderna’s future revenue, &… Vaccine execs go to Washington, Moderna’s future revenue, & Brainstorm’s FDA setback Democratizing research, vaccine trials lack diversity, & a PDUFA… Democratizing research, vaccine trials lack diversity, & a PDUFA for Sarepta',
    sourceUrl: null,
    webUrl:
      "https://www.statnews.com/2021/02/25/modernas-covid-19-booster-plan-jjs-day-at-the-fda-consolidation-among-the-contractors/",
    originalUrl:
      "https://www.statnews.com/2021/02/25/modernas-covid-19-booster-plan-jjs-day-at-the-fda-consolidation-among-the-contractors/",
    featuredContent: null,
    highlight: null,
    heat: 74,
    tags: null,
    images: [
      {
        url: "https://www.statnews.com/wp-content/uploads/2016/06/READOUT-800x576.gif",
        width: 800,
        height: 576,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl: null,
    cdnAmpWebUrl: null,
    publishedDateTime: "2021-02-25T05:52:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "STAT",
      domain: "statnews.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Treatment", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-university-of-delaware-has-seen-over-140-covid-19-cases-since-tuesday.md",
    title:
      "University of Delaware has seen over 140 COVID-19 cases since Tuesday",
    excerpt:
      "The University of Delaware is tightening its coronavirus restrictions and urging students to reduce time indoors with others amid an explosion of new coronavirus cases on campus over the last two days.",
    sourceUrl: null,
    webUrl:
      "https://www.fox29.com/news/university-of-delaware-has-seen-over-140-covid-19-cases-since-tuesday",
    originalUrl:
      "https://www.fox29.com/news/university-of-delaware-has-seen-over-140-covid-19-cases-since-tuesday",
    featuredContent: null,
    highlight: null,
    heat: 85,
    tags: ["US-DE"],
    images: [
      {
        url: "https://images.foxtv.com/static.fox29.com/www.fox29.com/content/uploads/2020/11/932/470/University-of-Delaware.jpeg?ve=1&tl=1",
        width: 932,
        height: 470,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://www.fox29.com/news/university-of-delaware-has-seen-over-140-covid-19-cases-since-tuesday.amp",
    cdnAmpWebUrl:
      "https://www-fox29-com.cdn.ampproject.org/c/s/www.fox29.com/news/university-of-delaware-has-seen-over-140-covid-19-cases-since-tuesday.amp",
    publishedDateTime: "2021-02-25T05:48:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "FOX 29",
      domain: "fox29.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in US", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-us-jobless-claims-fall-but-more-uk-workers-on-furlough-business-live.md",
    title:
      "US jobless claims fall, but more UK workers on furlough – business live",
    excerpt: "Rolling coverage of the latest economic and financial news",
    sourceUrl: null,
    webUrl:
      "https://www.theguardian.com/business/live/2021/feb/25/markets-rebound-inflation-economy-covid-ftse-dow-gamestop-business-live?page=with:block-60377df98f088c613add2277",
    originalUrl:
      "https://www.theguardian.com/business/live/2021/feb/25/markets-rebound-inflation-economy-covid-ftse-dow-gamestop-business-live?page=with:block-60377df98f088c613add2277",
    featuredContent: null,
    highlight: null,
    heat: 90,
    tags: ["GB", "UK"],
    images: [
      {
        url: "https://i.guim.co.uk/img/media/b4072bcc7ba5192d51c37878f5a8677f49d946df/0_384_5760_3456/master/5760.jpg?width=300&quality=45&auto=format&fit=max&dpr=2&s=1d900c84f4952693460281960c759286",
        width: 600,
        height: 360,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://amp.theguardian.com/business/live/2021/feb/25/markets-rebound-inflation-economy-covid-ftse-dow-gamestop-business-live",
    cdnAmpWebUrl:
      "https://amp-theguardian-com.cdn.ampproject.org/c/s/amp.theguardian.com/business/live/2021/feb/25/markets-rebound-inflation-economy-covid-ftse-dow-gamestop-business-live",
    publishedDateTime: "2021-02-25T05:46:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "The Guardian",
      domain: "theguardian.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/theguardian.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in Europe", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-czech-republic-confirms-first-case-of-covid-19-south-african-variant.md",
    title:
      "Czech Republic confirms first case of COVID-19 South African variant",
    excerpt:
      "The Czech Republic has confirmed its first case of the COVID-19 variant first detected in South Africa, the Health Ministry said on Thursday.",
    sourceUrl: null,
    webUrl:
      "https://www.reuters.com/article/health-coronavirus-czech-variants-idUSL8N2KV7M6",
    originalUrl:
      "https://www.reuters.com/article/health-coronavirus-czech-variants-idUSL8N2KV7M6",
    featuredContent: null,
    highlight: null,
    heat: 85,
    tags: null,
    images: null,
    content: "\r\n",
    type: "article",
    ampWebUrl: "https://mobile.reuters.com/article/amp/idUSL8N2KV7M6",
    cdnAmpWebUrl:
      "https://mobile-reuters-com.cdn.ampproject.org/c/s/mobile.reuters.com/article/amp/idUSL8N2KV7M6",
    publishedDateTime: "2021-02-25T05:40:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "Reuters",
      domain: "reuters.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/reuters.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Travel Impact", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-should-you-buy-apple-stock-after-the-recent-correction.md",
    title: "Should You Buy Apple Stock After The Recent Correction?",
    excerpt:
      "Apple stock dropped -5.5% over the last five trading days and has underperformed the S&P 500 which fell by a little over -1% during the same period. The stock is also down by almost -10% over the last 21 trading days.",
    sourceUrl: null,
    webUrl:
      "https://www.forbes.com/sites/greatspeculations/2021/02/25/should-you-buy-apple-stock-after-the-recent-correction/",
    originalUrl:
      "https://www.forbes.com/sites/greatspeculations/2021/02/25/should-you-buy-apple-stock-after-the-recent-correction/",
    featuredContent: null,
    highlight: null,
    heat: 85,
    tags: null,
    images: [
      {
        url: "https://thumbor.forbes.com/thumbor/fit-in/1200x0/filters%3Aformat%28jpg%29/https%3A%2F%2Fspecials-images.forbesimg.com%2Fimageserve%2F60370ad1a58178dfa2cd4e77%2F0x0.jpg",
        width: 1200,
        height: 800,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl: null,
    cdnAmpWebUrl: null,
    publishedDateTime: "2021-02-25T05:40:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "Forbes",
      domain: "forbes.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/forbes.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Stock Impact", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-saskatchewan-seeks-to-build-a-containment-level-4-lab-to-research-pandemics.md",
    title:
      "Saskatchewan seeks to build a containment level 4 lab to research pandemics",
    excerpt:
      "Regina - Vertical integration, where you control all aspects of your operation, is what Saskatchewan's Vaccine and Infectious Disease Organization (VIDO)",
    sourceUrl: null,
    webUrl:
      "https://www.plant.ca/health-safety/saskatchewan-seeks-to-build-a-containment-level-4-lab-to-research-pandemics-200099/",
    originalUrl:
      "https://www.plant.ca/health-safety/saskatchewan-seeks-to-build-a-containment-level-4-lab-to-research-pandemics-200099/",
    featuredContent: null,
    highlight: null,
    heat: 83,
    tags: ["CA", "CA-SK"],
    images: [
      {
        url: "https://www.nationalobserver.com/sites/nationalobserver.com/files/styles/nat_social/public/img/2020/03/20/cpt14053463.jpg?itok=T6X3esYC",
        width: 1874,
        height: 937,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl: null,
    cdnAmpWebUrl: null,
    publishedDateTime: "2021-02-25T05:34:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "plant.ca",
      domain: "plant.ca",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in Canada", "Coronavirus", "Treatment"],
  },
  {
    path: "_news/2021-02-25-walmart-hosting-covid-19-vaccine-events-in-oklahoma.md",
    title: "Walmart hosting COVID-19 vaccine events in Oklahoma",
    excerpt:
      "As many more Oklahomans are now eligible to receive a COVID-19 vaccine, Walmart says it is here to help. Walmart will begin administering Pfizer COVID-19 vaccines on Feb. 27 in greater Oklahoma City with a clinic inside the Walmart Pharmacy,",
    sourceUrl: null,
    webUrl:
      "https://kfor.com/news/local/walmart-hosting-covid-19-vaccine-events-in-oklahoma/",
    originalUrl:
      "https://kfor.com/news/local/walmart-hosting-covid-19-vaccine-events-in-oklahoma/",
    featuredContent: null,
    highlight: null,
    heat: 75,
    tags: ["US-OK"],
    images: [
      {
        url: "https://kfor.com/wp-content/uploads/sites/3/2021/02/AP21054752218980.jpg?w=1280",
        width: 1280,
        height: 853,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl:
      "https://kfor.com/news/local/walmart-hosting-covid-19-vaccine-events-in-oklahoma/amp/",
    cdnAmpWebUrl:
      "https://kfor-com.cdn.ampproject.org/c/s/kfor.com/news/local/walmart-hosting-covid-19-vaccine-events-in-oklahoma/amp/",
    publishedDateTime: "2021-02-25T05:34:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "Oklahoma's News",
      domain: "kfor.com",
      images: null,
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in US", "Coronavirus"],
  },
  {
    path: "_news/2021-02-25-town-board-in-maine-contends-mask-mandates-violate-the-ada.md",
    title: "Town board in Maine contends mask mandates violate the ADA",
    excerpt:
      "The leaders of a town in western Maine say the governor's executive order requiring people to wear masks during the pandemic violates the Americans With",
    sourceUrl: null,
    webUrl:
      "https://apnews.com/article/coronavirus-pandemic-bangor-maine-98cef94d138c70c9997ee2108fe95f38",
    originalUrl:
      "https://apnews.com/article/coronavirus-pandemic-bangor-maine-98cef94d138c70c9997ee2108fe95f38",
    featuredContent: null,
    highlight: null,
    heat: 70,
    tags: ["US-ME"],
    images: [
      {
        url: "https://apnews.com/images/ShareLogo2.png",
        width: 700,
        height: 450,
        title: null,
        attribution: null,
        isCached: true,
      },
    ],
    content: "\r\n",
    type: "article",
    ampWebUrl: null,
    cdnAmpWebUrl: null,
    publishedDateTime: "2021-02-25T05:29:00-08:00",
    updatedDateTime: null,
    provider: {
      name: "Associated Press",
      domain: "apnews.com",
      images: [
        {
          url: "https://insideout.github.io/coronavirus/assets/images/organizations/apnews.com-50x50.jpg",
          width: 50,
          height: 50,
          title: null,
          attribution: null,
          isCached: false,
        },
      ],
      publishers: null,
      authors: null,
    },
    locale: "en-us",
    categories: ["news"],
    topics: ["Coronavirus in US", "Coronavirus"],
  },
];

export const statsData = {
  location: {
    long: null,
    countryOrRegion: null,
    provinceOrState: null,
    county: null,
    isoCode: null,
    lat: null,
  },
  updatedDateTime: "2021-02-26T06:48:58.0374064Z",
  stats: {
    totalConfirmedCases: 112567104,
    newlyConfirmedCases: 423205,
    totalDeaths: 2512203,
    newDeaths: 9756,
    totalRecoveredCases: 72468921,
    newlyRecoveredCases: 303107,
    history: [
      {
        date: "2020-01-22T00:00:00",
        confirmed: 554,
        deaths: 17,
        recovered: 28,
      },
      {
        date: "2020-01-23T00:00:00",
        confirmed: 653,
        deaths: 18,
        recovered: 30,
      },
      {
        date: "2020-01-24T00:00:00",
        confirmed: 941,
        deaths: 26,
        recovered: 36,
      },
      {
        date: "2020-01-25T00:00:00",
        confirmed: 1434,
        deaths: 42,
        recovered: 39,
      },
      {
        date: "2020-01-26T00:00:00",
        confirmed: 2118,
        deaths: 56,
        recovered: 52,
      },
      {
        date: "2020-01-27T00:00:00",
        confirmed: 2927,
        deaths: 82,
        recovered: 61,
      },
      {
        date: "2020-01-28T00:00:00",
        confirmed: 5578,
        deaths: 131,
        recovered: 107,
      },
      {
        date: "2020-01-29T00:00:00",
        confirmed: 6166,
        deaths: 133,
        recovered: 126,
      },
      {
        date: "2020-01-30T00:00:00",
        confirmed: 8233,
        deaths: 171,
        recovered: 143,
      },
      {
        date: "2020-01-31T00:00:00",
        confirmed: 9927,
        deaths: 213,
        recovered: 222,
      },
      {
        date: "2020-02-01T00:00:00",
        confirmed: 12037,
        deaths: 259,
        recovered: 284,
      },
      {
        date: "2020-02-02T00:00:00",
        confirmed: 16787,
        deaths: 362,
        recovered: 471,
      },
      {
        date: "2020-02-03T00:00:00",
        confirmed: 19881,
        deaths: 426,
        recovered: 623,
      },
      {
        date: "2020-02-04T00:00:00",
        confirmed: 23892,
        deaths: 492,
        recovered: 852,
      },
      {
        date: "2020-02-05T00:00:00",
        confirmed: 27635,
        deaths: 564,
        recovered: 1121,
      },
      {
        date: "2020-02-06T00:00:00",
        confirmed: 30794,
        deaths: 634,
        recovered: 1487,
      },
      {
        date: "2020-02-07T00:00:00",
        confirmed: 34391,
        deaths: 719,
        recovered: 2011,
      },
      {
        date: "2020-02-08T00:00:00",
        confirmed: 37120,
        deaths: 806,
        recovered: 2614,
      },
      {
        date: "2020-02-09T00:00:00",
        confirmed: 40150,
        deaths: 906,
        recovered: 3244,
      },
      {
        date: "2020-02-10T00:00:00",
        confirmed: 42762,
        deaths: 1013,
        recovered: 3944,
      },
      {
        date: "2020-02-11T00:00:00",
        confirmed: 44802,
        deaths: 1113,
        recovered: 4683,
      },
      {
        date: "2020-02-12T00:00:00",
        confirmed: 45221,
        deaths: 1118,
        recovered: 5151,
      },
      {
        date: "2020-02-13T00:00:00",
        confirmed: 60368,
        deaths: 1371,
        recovered: 6295,
      },
      {
        date: "2020-02-14T00:00:00",
        confirmed: 66885,
        deaths: 1523,
        recovered: 8054,
      },
      {
        date: "2020-02-15T00:00:00",
        confirmed: 69030,
        deaths: 1666,
        recovered: 9395,
      },
      {
        date: "2020-02-16T00:00:00",
        confirmed: 71224,
        deaths: 1770,
        recovered: 10865,
      },
      {
        date: "2020-02-17T00:00:00",
        confirmed: 73258,
        deaths: 1868,
        recovered: 12583,
      },
      {
        date: "2020-02-18T00:00:00",
        confirmed: 75136,
        deaths: 2007,
        recovered: 14352,
      },
      {
        date: "2020-02-19T00:00:00",
        confirmed: 75639,
        deaths: 2122,
        recovered: 16121,
      },
      {
        date: "2020-02-20T00:00:00",
        confirmed: 76197,
        deaths: 2247,
        recovered: 18178,
      },
      {
        date: "2020-02-21T00:00:00",
        confirmed: 76819,
        deaths: 2251,
        recovered: 18890,
      },
      {
        date: "2020-02-22T00:00:00",
        confirmed: 78572,
        deaths: 2458,
        recovered: 22886,
      },
      {
        date: "2020-02-23T00:00:00",
        confirmed: 78958,
        deaths: 2469,
        recovered: 23394,
      },
      {
        date: "2020-02-24T00:00:00",
        confirmed: 79561,
        deaths: 2629,
        recovered: 25228,
      },
      {
        date: "2020-02-25T00:00:00",
        confirmed: 80406,
        deaths: 2708,
        recovered: 27906,
      },
      {
        date: "2020-02-26T00:00:00",
        confirmed: 81379,
        deaths: 2770,
        recovered: 30387,
      },
      {
        date: "2020-02-27T00:00:00",
        confirmed: 82736,
        deaths: 2814,
        recovered: 33280,
      },
      {
        date: "2020-02-28T00:00:00",
        confirmed: 84102,
        deaths: 2872,
        recovered: 36714,
      },
      {
        date: "2020-02-29T00:00:00",
        confirmed: 85999,
        deaths: 2941,
        recovered: 39785,
      },
      {
        date: "2020-03-01T00:00:00",
        confirmed: 88356,
        deaths: 2996,
        recovered: 42719,
      },
      {
        date: "2020-03-02T00:00:00",
        confirmed: 90293,
        deaths: 3085,
        recovered: 45605,
      },
      {
        date: "2020-03-03T00:00:00",
        confirmed: 92824,
        deaths: 3160,
        recovered: 48231,
      },
      {
        date: "2020-03-04T00:00:00",
        confirmed: 95097,
        deaths: 3254,
        recovered: 51173,
      },
      {
        date: "2020-03-05T00:00:00",
        confirmed: 97859,
        deaths: 3348,
        recovered: 53799,
      },
      {
        date: "2020-03-06T00:00:00",
        confirmed: 101759,
        deaths: 3460,
        recovered: 55867,
      },
      {
        date: "2020-03-07T00:00:00",
        confirmed: 105796,
        deaths: 3558,
        recovered: 58361,
      },
      {
        date: "2020-03-08T00:00:00",
        confirmed: 109758,
        deaths: 3802,
        recovered: 60714,
      },
      {
        date: "2020-03-09T00:00:00",
        confirmed: 113471,
        deaths: 3988,
        recovered: 62514,
      },
      {
        date: "2020-03-10T00:00:00",
        confirmed: 118139,
        deaths: 4262,
        recovered: 64406,
      },
      {
        date: "2020-03-11T00:00:00",
        confirmed: 125774,
        deaths: 4611,
        recovered: 67010,
      },
      {
        date: "2020-03-12T00:00:00",
        confirmed: 134155,
        deaths: 4976,
        recovered: 69079,
      },
      {
        date: "2020-03-13T00:00:00",
        confirmed: 145731,
        deaths: 5436,
        recovered: 72505,
      },
      {
        date: "2020-03-14T00:00:00",
        confirmed: 156873,
        deaths: 5839,
        recovered: 75893,
      },
      {
        date: "2020-03-15T00:00:00",
        confirmed: 168668,
        deaths: 6516,
        recovered: 77708,
      },
      {
        date: "2020-03-16T00:00:00",
        confirmed: 182807,
        deaths: 7171,
        recovered: 79832,
      },
      {
        date: "2020-03-17T00:00:00",
        confirmed: 198674,
        deaths: 7989,
        recovered: 82706,
      },
      {
        date: "2020-03-18T00:00:00",
        confirmed: 219190,
        deaths: 8966,
        recovered: 85729,
      },
      {
        date: "2020-03-19T00:00:00",
        confirmed: 245687,
        deaths: 10047,
        recovered: 88425,
      },
      {
        date: "2020-03-20T00:00:00",
        confirmed: 276386,
        deaths: 11419,
        recovered: 91929,
      },
      {
        date: "2020-03-21T00:00:00",
        confirmed: 308268,
        deaths: 13073,
        recovered: 95621,
      },
      {
        date: "2020-03-22T00:00:00",
        confirmed: 339251,
        deaths: 14721,
        recovered: 99048,
      },
      {
        date: "2020-03-23T00:00:00",
        confirmed: 381628,
        deaths: 16555,
        recovered: 101556,
      },
      {
        date: "2020-03-24T00:00:00",
        confirmed: 423197,
        deaths: 18924,
        recovered: 108468,
      },
      {
        date: "2020-03-25T00:00:00",
        confirmed: 472163,
        deaths: 21316,
        recovered: 114588,
      },
      {
        date: "2020-03-26T00:00:00",
        confirmed: 533643,
        deaths: 24090,
        recovered: 122334,
      },
      {
        date: "2020-03-27T00:00:00",
        confirmed: 597500,
        deaths: 27375,
        recovered: 131107,
      },
      {
        date: "2020-03-28T00:00:00",
        confirmed: 665001,
        deaths: 30854,
        recovered: 139541,
      },
      {
        date: "2020-03-29T00:00:00",
        confirmed: 737290,
        deaths: 34525,
        recovered: 148096,
      },
      {
        date: "2020-03-30T00:00:00",
        confirmed: 798299,
        deaths: 38268,
        recovered: 160899,
      },
      {
        date: "2020-03-31T00:00:00",
        confirmed: 869449,
        deaths: 42725,
        recovered: 172531,
      },
      {
        date: "2020-04-01T00:00:00",
        confirmed: 952762,
        deaths: 47787,
        recovered: 194713,
      },
      {
        date: "2020-04-02T00:00:00",
        confirmed: 1031314,
        deaths: 53664,
        recovered: 211805,
      },
      {
        date: "2020-04-03T00:00:00",
        confirmed: 1113657,
        deaths: 59390,
        recovered: 226513,
      },
      {
        date: "2020-04-04T00:00:00",
        confirmed: 1194664,
        deaths: 65238,
        recovered: 246752,
      },
      {
        date: "2020-04-05T00:00:00",
        confirmed: 1267722,
        deaths: 69973,
        recovered: 262634,
      },
      {
        date: "2020-04-06T00:00:00",
        confirmed: 1338691,
        deaths: 75317,
        recovered: 284387,
      },
      {
        date: "2020-04-07T00:00:00",
        confirmed: 1414301,
        deaths: 82608,
        recovered: 300646,
      },
      {
        date: "2020-04-08T00:00:00",
        confirmed: 1499980,
        deaths: 88959,
        recovered: 328788,
      },
      {
        date: "2020-04-09T00:00:00",
        confirmed: 1585375,
        deaths: 96183,
        recovered: 355165,
      },
      {
        date: "2020-04-10T00:00:00",
        confirmed: 1680108,
        deaths: 103297,
        recovered: 377401,
      },
      {
        date: "2020-04-11T00:00:00",
        confirmed: 1756958,
        deaths: 109365,
        recovered: 404474,
      },
      {
        date: "2020-04-12T00:00:00",
        confirmed: 1853984,
        deaths: 114768,
        recovered: 435166,
      },
      {
        date: "2020-04-13T00:00:00",
        confirmed: 1924490,
        deaths: 120222,
        recovered: 457636,
      },
      {
        date: "2020-04-14T00:00:00",
        confirmed: 1999840,
        deaths: 127269,
        recovered: 493610,
      },
      {
        date: "2020-04-15T00:00:00",
        confirmed: 2080891,
        deaths: 135075,
        recovered: 510922,
      },
      {
        date: "2020-04-16T00:00:00",
        confirmed: 2176704,
        deaths: 143547,
        recovered: 548174,
      },
      {
        date: "2020-04-17T00:00:00",
        confirmed: 2266479,
        deaths: 154816,
        recovered: 566644,
      },
      {
        date: "2020-04-18T00:00:00",
        confirmed: 2343093,
        deaths: 161469,
        recovered: 593739,
      },
      {
        date: "2020-04-19T00:00:00",
        confirmed: 2421289,
        deaths: 165964,
        recovered: 620803,
      },
      {
        date: "2020-04-20T00:00:00",
        confirmed: 2495367,
        deaths: 171251,
        recovered: 647153,
      },
      {
        date: "2020-04-21T00:00:00",
        confirmed: 2568583,
        deaths: 178037,
        recovered: 681610,
      },
      {
        date: "2020-04-22T00:00:00",
        confirmed: 2646629,
        deaths: 184790,
        recovered: 708870,
      },
      {
        date: "2020-04-23T00:00:00",
        confirmed: 2734509,
        deaths: 191436,
        recovered: 737543,
      },
      {
        date: "2020-04-24T00:00:00",
        confirmed: 2832490,
        deaths: 197884,
        recovered: 786066,
      },
      {
        date: "2020-04-25T00:00:00",
        confirmed: 2926162,
        deaths: 203735,
        recovered: 833231,
      },
      {
        date: "2020-04-26T00:00:00",
        confirmed: 2999073,
        deaths: 207384,
        recovered: 877022,
      },
      {
        date: "2020-04-27T00:00:00",
        confirmed: 3069349,
        deaths: 212095,
        recovered: 916866,
      },
      {
        date: "2020-04-28T00:00:00",
        confirmed: 3144334,
        deaths: 218218,
        recovered: 952107,
      },
      {
        date: "2020-04-29T00:00:00",
        confirmed: 3223748,
        deaths: 228554,
        recovered: 995771,
      },
      {
        date: "2020-04-30T00:00:00",
        confirmed: 3309901,
        deaths: 234263,
        recovered: 1033606,
      },
      {
        date: "2020-05-01T00:00:00",
        confirmed: 3393419,
        deaths: 239296,
        recovered: 1070466,
      },
      {
        date: "2020-05-02T00:00:00",
        confirmed: 3483141,
        deaths: 244852,
        recovered: 1110695,
      },
      {
        date: "2020-05-03T00:00:00",
        confirmed: 3564011,
        deaths: 248550,
        recovered: 1142380,
      },
      {
        date: "2020-05-04T00:00:00",
        confirmed: 3640914,
        deaths: 252720,
        recovered: 1183660,
      },
      {
        date: "2020-05-05T00:00:00",
        confirmed: 3721483,
        deaths: 258239,
        recovered: 1218567,
      },
      {
        date: "2020-05-06T00:00:00",
        confirmed: 3816737,
        deaths: 264912,
        recovered: 1277832,
      },
      {
        date: "2020-05-07T00:00:00",
        confirmed: 3913657,
        deaths: 270531,
        recovered: 1317352,
      },
      {
        date: "2020-05-08T00:00:00",
        confirmed: 4010583,
        deaths: 276012,
        recovered: 1358428,
      },
      {
        date: "2020-05-09T00:00:00",
        confirmed: 4097263,
        deaths: 280276,
        recovered: 1411984,
      },
      {
        date: "2020-05-10T00:00:00",
        confirmed: 4176367,
        deaths: 283720,
        recovered: 1462759,
      },
      {
        date: "2020-05-11T00:00:00",
        confirmed: 4251137,
        deaths: 287283,
        recovered: 1495773,
      },
      {
        date: "2020-05-12T00:00:00",
        confirmed: 4336309,
        deaths: 292868,
        recovered: 1578337,
      },
      {
        date: "2020-05-13T00:00:00",
        confirmed: 4423941,
        deaths: 298205,
        recovered: 1633795,
      },
      {
        date: "2020-05-14T00:00:00",
        confirmed: 4515469,
        deaths: 303700,
        recovered: 1711028,
      },
      {
        date: "2020-05-15T00:00:00",
        confirmed: 4621481,
        deaths: 309146,
        recovered: 1759002,
      },
      {
        date: "2020-05-16T00:00:00",
        confirmed: 4714187,
        deaths: 313317,
        recovered: 1810726,
      },
      {
        date: "2020-05-17T00:00:00",
        confirmed: 4796977,
        deaths: 316747,
        recovered: 1857606,
      },
      {
        date: "2020-05-18T00:00:00",
        confirmed: 4885129,
        deaths: 320133,
        recovered: 1906152,
      },
      {
        date: "2020-05-19T00:00:00",
        confirmed: 4980313,
        deaths: 325099,
        recovered: 1957880,
      },
      {
        date: "2020-05-20T00:00:00",
        confirmed: 5082904,
        deaths: 329737,
        recovered: 2023165,
      },
      {
        date: "2020-05-21T00:00:00",
        confirmed: 5188991,
        deaths: 334510,
        recovered: 2079743,
      },
      {
        date: "2020-05-22T00:00:00",
        confirmed: 5296777,
        deaths: 339989,
        recovered: 2154999,
      },
      {
        date: "2020-05-23T00:00:00",
        confirmed: 5395929,
        deaths: 344704,
        recovered: 2242091,
      },
      {
        date: "2020-05-24T00:00:00",
        confirmed: 5491996,
        deaths: 347515,
        recovered: 2297755,
      },
      {
        date: "2020-05-25T00:00:00",
        confirmed: 5580337,
        deaths: 350662,
        recovered: 2361900,
      },
      {
        date: "2020-05-26T00:00:00",
        confirmed: 5677475,
        deaths: 354667,
        recovered: 2425344,
      },
      {
        date: "2020-05-27T00:00:00",
        confirmed: 5779886,
        deaths: 359744,
        recovered: 2492490,
      },
      {
        date: "2020-05-28T00:00:00",
        confirmed: 5896047,
        deaths: 364604,
        recovered: 2576473,
      },
      {
        date: "2020-05-29T00:00:00",
        confirmed: 6020340,
        deaths: 369204,
        recovered: 2654260,
      },
      {
        date: "2020-05-30T00:00:00",
        confirmed: 6146982,
        deaths: 373121,
        recovered: 2730942,
      },
      {
        date: "2020-05-31T00:00:00",
        confirmed: 6253005,
        deaths: 376121,
        recovered: 2840545,
      },
      {
        date: "2020-06-01T00:00:00",
        confirmed: 6357664,
        deaths: 379786,
        recovered: 2897384,
      },
      {
        date: "2020-06-02T00:00:00",
        confirmed: 6473556,
        deaths: 384560,
        recovered: 3055783,
      },
      {
        date: "2020-06-03T00:00:00",
        confirmed: 6588620,
        deaths: 389945,
        recovered: 3156979,
      },
      {
        date: "2020-06-04T00:00:00",
        confirmed: 6722828,
        deaths: 395255,
        recovered: 3239848,
      },
      {
        date: "2020-06-05T00:00:00",
        confirmed: 6868463,
        deaths: 400154,
        recovered: 3338229,
      },
      {
        date: "2020-06-06T00:00:00",
        confirmed: 6998362,
        deaths: 404171,
        recovered: 3399937,
      },
      {
        date: "2020-06-07T00:00:00",
        confirmed: 7108502,
        deaths: 408141,
        recovered: 3447625,
      },
      {
        date: "2020-06-08T00:00:00",
        confirmed: 7214652,
        deaths: 410711,
        recovered: 3522289,
      },
      {
        date: "2020-06-09T00:00:00",
        confirmed: 7338636,
        deaths: 415505,
        recovered: 3590558,
      },
      {
        date: "2020-06-10T00:00:00",
        confirmed: 7472740,
        deaths: 420829,
        recovered: 3762798,
      },
      {
        date: "2020-06-11T00:00:00",
        confirmed: 7610188,
        deaths: 425640,
        recovered: 3826561,
      },
      {
        date: "2020-06-12T00:00:00",
        confirmed: 7748650,
        deaths: 429853,
        recovered: 3949863,
      },
      {
        date: "2020-06-13T00:00:00",
        confirmed: 7882413,
        deaths: 434201,
        recovered: 4025872,
      },
      {
        date: "2020-06-14T00:00:00",
        confirmed: 8005367,
        deaths: 437358,
        recovered: 4109147,
      },
      {
        date: "2020-06-15T00:00:00",
        confirmed: 8125521,
        deaths: 440855,
        recovered: 4211540,
      },
      {
        date: "2020-06-16T00:00:00",
        confirmed: 8271444,
        deaths: 447747,
        recovered: 4302386,
      },
      {
        date: "2020-06-17T00:00:00",
        confirmed: 8433577,
        deaths: 453050,
        recovered: 4412595,
      },
      {
        date: "2020-06-18T00:00:00",
        confirmed: 8590185,
        deaths: 458000,
        recovered: 4514562,
      },
      {
        date: "2020-06-19T00:00:00",
        confirmed: 8768690,
        deaths: 463034,
        recovered: 4606676,
      },
      {
        date: "2020-06-20T00:00:00",
        confirmed: 8923083,
        deaths: 467286,
        recovered: 4722282,
      },
      {
        date: "2020-06-21T00:00:00",
        confirmed: 9052216,
        deaths: 471320,
        recovered: 4820631,
      },
      {
        date: "2020-06-22T00:00:00",
        confirmed: 9193026,
        deaths: 474982,
        recovered: 4919578,
      },
      {
        date: "2020-06-23T00:00:00",
        confirmed: 9359861,
        deaths: 480376,
        recovered: 5025800,
      },
      {
        date: "2020-06-24T00:00:00",
        confirmed: 9528125,
        deaths: 485548,
        recovered: 5157469,
      },
      {
        date: "2020-06-25T00:00:00",
        confirmed: 9710313,
        deaths: 492298,
        recovered: 5260056,
      },
      {
        date: "2020-06-26T00:00:00",
        confirmed: 9899418,
        deaths: 497229,
        recovered: 5366328,
      },
      {
        date: "2020-06-27T00:00:00",
        confirmed: 10071599,
        deaths: 501572,
        recovered: 5460392,
      },
      {
        date: "2020-06-28T00:00:00",
        confirmed: 10240381,
        deaths: 504833,
        recovered: 5556728,
      },
      {
        date: "2020-06-29T00:00:00",
        confirmed: 10399497,
        deaths: 508580,
        recovered: 5662635,
      },
      {
        date: "2020-06-30T00:00:00",
        confirmed: 10577509,
        deaths: 514380,
        recovered: 5790976,
      },
      {
        date: "2020-07-01T00:00:00",
        confirmed: 10793669,
        deaths: 519360,
        recovered: 6019589,
      },
      {
        date: "2020-07-02T00:00:00",
        confirmed: 11002596,
        deaths: 524374,
        recovered: 6132580,
      },
      {
        date: "2020-07-03T00:00:00",
        confirmed: 11205391,
        deaths: 529488,
        recovered: 6319839,
      },
      {
        date: "2020-07-04T00:00:00",
        confirmed: 11394265,
        deaths: 533932,
        recovered: 6419394,
      },
      {
        date: "2020-07-05T00:00:00",
        confirmed: 11577145,
        deaths: 537221,
        recovered: 6507395,
      },
      {
        date: "2020-07-06T00:00:00",
        confirmed: 11746590,
        deaths: 541098,
        recovered: 6714655,
      },
      {
        date: "2020-07-07T00:00:00",
        confirmed: 11934370,
        deaths: 545709,
        recovered: 6849450,
      },
      {
        date: "2020-07-08T00:00:00",
        confirmed: 12168518,
        deaths: 552481,
        recovered: 7041377,
      },
      {
        date: "2020-07-09T00:00:00",
        confirmed: 12391259,
        deaths: 557812,
        recovered: 7195820,
      },
      {
        date: "2020-07-10T00:00:00",
        confirmed: 12622784,
        deaths: 563167,
        recovered: 7338772,
      },
      {
        date: "2020-07-11T00:00:00",
        confirmed: 12836757,
        deaths: 567949,
        recovered: 7453519,
      },
      {
        date: "2020-07-12T00:00:00",
        confirmed: 13023888,
        deaths: 572157,
        recovered: 7558043,
      },
      {
        date: "2020-07-13T00:00:00",
        confirmed: 13231871,
        deaths: 576161,
        recovered: 7675125,
      },
      {
        date: "2020-07-14T00:00:00",
        confirmed: 13450274,
        deaths: 581842,
        recovered: 7819390,
      },
      {
        date: "2020-07-15T00:00:00",
        confirmed: 13684196,
        deaths: 587441,
        recovered: 8121422,
      },
      {
        date: "2020-07-16T00:00:00",
        confirmed: 13936015,
        deaths: 593270,
        recovered: 8249123,
      },
      {
        date: "2020-07-17T00:00:00",
        confirmed: 14167823,
        deaths: 599843,
        recovered: 8433405,
      },
      {
        date: "2020-07-18T00:00:00",
        confirmed: 14405407,
        deaths: 605357,
        recovered: 8583537,
      },
      {
        date: "2020-07-19T00:00:00",
        confirmed: 14621371,
        deaths: 609387,
        recovered: 8700056,
      },
      {
        date: "2020-07-20T00:00:00",
        confirmed: 14828123,
        deaths: 614565,
        recovered: 8873576,
      },
      {
        date: "2020-07-21T00:00:00",
        confirmed: 15066754,
        deaths: 620811,
        recovered: 9077687,
      },
      {
        date: "2020-07-22T00:00:00",
        confirmed: 15341399,
        deaths: 628989,
        recovered: 9290476,
      },
      {
        date: "2020-07-23T00:00:00",
        confirmed: 15617534,
        deaths: 637624,
        recovered: 9503364,
      },
      {
        date: "2020-07-24T00:00:00",
        confirmed: 15902698,
        deaths: 651525,
        recovered: 9699563,
      },
      {
        date: "2020-07-25T00:00:00",
        confirmed: 16158479,
        deaths: 657133,
        recovered: 9870169,
      },
      {
        date: "2020-07-26T00:00:00",
        confirmed: 16371942,
        deaths: 660931,
        recovered: 10006836,
      },
      {
        date: "2020-07-27T00:00:00",
        confirmed: 16588470,
        deaths: 664907,
        recovered: 10188496,
      },
      {
        date: "2020-07-28T00:00:00",
        confirmed: 16841568,
        deaths: 672604,
        recovered: 10414748,
      },
      {
        date: "2020-07-29T00:00:00",
        confirmed: 17132029,
        deaths: 679175,
        recovered: 10653321,
      },
      {
        date: "2020-07-30T00:00:00",
        confirmed: 17416375,
        deaths: 685513,
        recovered: 10889066,
      },
      {
        date: "2020-07-31T00:00:00",
        confirmed: 17699141,
        deaths: 691771,
        recovered: 11111980,
      },
      {
        date: "2020-08-01T00:00:00",
        confirmed: 17953335,
        deaths: 697357,
        recovered: 11277342,
      },
      {
        date: "2020-08-02T00:00:00",
        confirmed: 18168210,
        deaths: 701174,
        recovered: 11392134,
      },
      {
        date: "2020-08-03T00:00:00",
        confirmed: 18371737,
        deaths: 705337,
        recovered: 11620654,
      },
      {
        date: "2020-08-04T00:00:00",
        confirmed: 18633145,
        deaths: 712655,
        recovered: 11864456,
      },
      {
        date: "2020-08-05T00:00:00",
        confirmed: 18901336,
        deaths: 719361,
        recovered: 12108083,
      },
      {
        date: "2020-08-06T00:00:00",
        confirmed: 19182012,
        deaths: 725713,
        recovered: 12298741,
      },
      {
        date: "2020-08-07T00:00:00",
        confirmed: 19464433,
        deaths: 732128,
        recovered: 12482577,
      },
      {
        date: "2020-08-08T00:00:00",
        confirmed: 19729128,
        deaths: 737611,
        recovered: 12658344,
      },
      {
        date: "2020-08-09T00:00:00",
        confirmed: 19937520,
        deaths: 741874,
        recovered: 12832567,
      },
      {
        date: "2020-08-10T00:00:00",
        confirmed: 20167271,
        deaths: 746715,
        recovered: 13119418,
      },
      {
        date: "2020-08-11T00:00:00",
        confirmed: 20437706,
        deaths: 753512,
        recovered: 13377776,
      },
      {
        date: "2020-08-12T00:00:00",
        confirmed: 20718764,
        deaths: 761695,
        recovered: 13613638,
      },
      {
        date: "2020-08-13T00:00:00",
        confirmed: 21001312,
        deaths: 770427,
        recovered: 13849602,
      },
      {
        date: "2020-08-14T00:00:00",
        confirmed: 21282537,
        deaths: 776374,
        recovered: 14074473,
      },
      {
        date: "2020-08-15T00:00:00",
        confirmed: 21551690,
        deaths: 783274,
        recovered: 14231496,
      },
      {
        date: "2020-08-16T00:00:00",
        confirmed: 21767634,
        deaths: 787336,
        recovered: 14439419,
      },
      {
        date: "2020-08-17T00:00:00",
        confirmed: 21952335,
        deaths: 791412,
        recovered: 14618642,
      },
      {
        date: "2020-08-18T00:00:00",
        confirmed: 22220937,
        deaths: 798361,
        recovered: 14838358,
      },
      {
        date: "2020-08-19T00:00:00",
        confirmed: 22494890,
        deaths: 805043,
        recovered: 15037481,
      },
      {
        date: "2020-08-20T00:00:00",
        confirmed: 22782386,
        deaths: 811089,
        recovered: 15216018,
      },
      {
        date: "2020-08-21T00:00:00",
        confirmed: 23038244,
        deaths: 816915,
        recovered: 15380152,
      },
      {
        date: "2020-08-22T00:00:00",
        confirmed: 23300740,
        deaths: 822317,
        recovered: 15554038,
      },
      {
        date: "2020-08-23T00:00:00",
        confirmed: 23500502,
        deaths: 826084,
        recovered: 15710023,
      },
      {
        date: "2020-08-24T00:00:00",
        confirmed: 23684937,
        deaths: 830057,
        recovered: 15931874,
      },
      {
        date: "2020-08-25T00:00:00",
        confirmed: 23979422,
        deaths: 836941,
        recovered: 16150823,
      },
      {
        date: "2020-08-26T00:00:00",
        confirmed: 24265869,
        deaths: 842708,
        recovered: 16344456,
      },
      {
        date: "2020-08-27T00:00:00",
        confirmed: 24553837,
        deaths: 849029,
        recovered: 16538189,
      },
      {
        date: "2020-08-28T00:00:00",
        confirmed: 24834638,
        deaths: 854581,
        recovered: 16715338,
      },
      {
        date: "2020-08-29T00:00:00",
        confirmed: 25089927,
        deaths: 859884,
        recovered: 16891405,
      },
      {
        date: "2020-08-30T00:00:00",
        confirmed: 25263177,
        deaths: 863023,
        recovered: 17064797,
      },
      {
        date: "2020-08-31T00:00:00",
        confirmed: 25549534,
        deaths: 867825,
        recovered: 17277383,
      },
      {
        date: "2020-09-01T00:00:00",
        confirmed: 25820161,
        deaths: 874238,
        recovered: 17490424,
      },
      {
        date: "2020-09-02T00:00:00",
        confirmed: 26106057,
        deaths: 880266,
        recovered: 17690067,
      },
      {
        date: "2020-09-03T00:00:00",
        confirmed: 26398255,
        deaths: 886014,
        recovered: 17878980,
      },
      {
        date: "2020-09-04T00:00:00",
        confirmed: 26722960,
        deaths: 891627,
        recovered: 18062065,
      },
      {
        date: "2020-09-05T00:00:00",
        confirmed: 26985409,
        deaths: 896261,
        recovered: 18238291,
      },
      {
        date: "2020-09-06T00:00:00",
        confirmed: 27214568,
        deaths: 900151,
        recovered: 18428079,
      },
      {
        date: "2020-09-07T00:00:00",
        confirmed: 27418335,
        deaths: 909410,
        recovered: 18619331,
      },
      {
        date: "2020-09-08T00:00:00",
        confirmed: 27673129,
        deaths: 914270,
        recovered: 18821988,
      },
      {
        date: "2020-09-09T00:00:00",
        confirmed: 27957671,
        deaths: 920354,
        recovered: 19044921,
      },
      {
        date: "2020-09-10T00:00:00",
        confirmed: 28183038,
        deaths: 924135,
        recovered: 19226639,
      },
      {
        date: "2020-09-11T00:00:00",
        confirmed: 28586183,
        deaths: 931911,
        recovered: 19454393,
      },
      {
        date: "2020-09-12T00:00:00",
        confirmed: 28867010,
        deaths: 936667,
        recovered: 19647358,
      },
      {
        date: "2020-09-13T00:00:00",
        confirmed: 29108696,
        deaths: 940354,
        recovered: 19835278,
      },
      {
        date: "2020-09-14T00:00:00",
        confirmed: 29356252,
        deaths: 944686,
        recovered: 20030823,
      },
      {
        date: "2020-09-15T00:00:00",
        confirmed: 29648760,
        deaths: 951164,
        recovered: 20256555,
      },
      {
        date: "2020-09-16T00:00:00",
        confirmed: 29956971,
        deaths: 956830,
        recovered: 20467298,
      },
      {
        date: "2020-09-17T00:00:00",
        confirmed: 30269788,
        deaths: 962264,
        recovered: 20669121,
      },
      {
        date: "2020-09-18T00:00:00",
        confirmed: 30608288,
        deaths: 968024,
        recovered: 20925970,
      },
      {
        date: "2020-09-19T00:00:00",
        confirmed: 30900983,
        deaths: 973010,
        recovered: 21141717,
      },
      {
        date: "2020-09-20T00:00:00",
        confirmed: 31142047,
        deaths: 976549,
        recovered: 21357767,
      },
      {
        date: "2020-09-21T00:00:00",
        confirmed: 31401395,
        deaths: 980763,
        recovered: 21592143,
      },
      {
        date: "2020-09-22T00:00:00",
        confirmed: 31696497,
        deaths: 986936,
        recovered: 21828605,
      },
      {
        date: "2020-09-23T00:00:00",
        confirmed: 32010872,
        deaths: 993343,
        recovered: 22058109,
      },
      {
        date: "2020-09-24T00:00:00",
        confirmed: 32325885,
        deaths: 999001,
        recovered: 22268088,
      },
      {
        date: "2020-09-25T00:00:00",
        confirmed: 32660968,
        deaths: 1004559,
        recovered: 22469411,
      },
      {
        date: "2020-09-26T00:00:00",
        confirmed: 32951240,
        deaths: 1009743,
        recovered: 22659091,
      },
      {
        date: "2020-09-27T00:00:00",
        confirmed: 33204020,
        deaths: 1013462,
        recovered: 22850145,
      },
      {
        date: "2020-09-28T00:00:00",
        confirmed: 33442055,
        deaths: 1017379,
        recovered: 23043219,
      },
      {
        date: "2020-09-29T00:00:00",
        confirmed: 33743241,
        deaths: 1023571,
        recovered: 23273255,
      },
      {
        date: "2020-09-30T00:00:00",
        confirmed: 34061956,
        deaths: 1029637,
        recovered: 23507665,
      },
      {
        date: "2020-10-01T00:00:00",
        confirmed: 34378675,
        deaths: 1038310,
        recovered: 23709815,
      },
      {
        date: "2020-10-02T00:00:00",
        confirmed: 34727987,
        deaths: 1043936,
        recovered: 23892451,
      },
      {
        date: "2020-10-03T00:00:00",
        confirmed: 35026332,
        deaths: 1048448,
        recovered: 24080809,
      },
      {
        date: "2020-10-04T00:00:00",
        confirmed: 35187322,
        deaths: 1050697,
        recovered: 24225667,
      },
      {
        date: "2020-10-05T00:00:00",
        confirmed: 35591732,
        deaths: 1056434,
        recovered: 24487115,
      },
      {
        date: "2020-10-06T00:00:00",
        confirmed: 35933615,
        deaths: 1064939,
        recovered: 24725144,
      },
      {
        date: "2020-10-07T00:00:00",
        confirmed: 36280846,
        deaths: 1070697,
        recovered: 24939771,
      },
      {
        date: "2020-10-08T00:00:00",
        confirmed: 36631861,
        deaths: 1076880,
        recovered: 25150868,
      },
      {
        date: "2020-10-09T00:00:00",
        confirmed: 36992829,
        deaths: 1082714,
        recovered: 25343102,
      },
      {
        date: "2020-10-10T00:00:00",
        confirmed: 37347931,
        deaths: 1087358,
        recovered: 25532085,
      },
      {
        date: "2020-10-11T00:00:00",
        confirmed: 37617739,
        deaths: 1091193,
        recovered: 25738121,
      },
      {
        date: "2020-10-12T00:00:00",
        confirmed: 37906694,
        deaths: 1095146,
        recovered: 25929643,
      },
      {
        date: "2020-10-13T00:00:00",
        confirmed: 38228973,
        deaths: 1100261,
        recovered: 26133244,
      },
      {
        date: "2020-10-14T00:00:00",
        confirmed: 38611529,
        deaths: 1106098,
        recovered: 26356444,
      },
      {
        date: "2020-10-15T00:00:00",
        confirmed: 39038868,
        deaths: 1112054,
        recovered: 26566624,
      },
      {
        date: "2020-10-16T00:00:00",
        confirmed: 39462703,
        deaths: 1118243,
        recovered: 26770957,
      },
      {
        date: "2020-10-17T00:00:00",
        confirmed: 39824937,
        deaths: 1123510,
        recovered: 26961615,
      },
      {
        date: "2020-10-18T00:00:00",
        confirmed: 40149328,
        deaths: 1127108,
        recovered: 27168968,
      },
      {
        date: "2020-10-19T00:00:00",
        confirmed: 40517935,
        deaths: 1131779,
        recovered: 27361458,
      },
      {
        date: "2020-10-20T00:00:00",
        confirmed: 40908506,
        deaths: 1138140,
        recovered: 27591528,
      },
      {
        date: "2020-10-21T00:00:00",
        confirmed: 41351203,
        deaths: 1144647,
        recovered: 27819675,
      },
      {
        date: "2020-10-22T00:00:00",
        confirmed: 41855873,
        deaths: 1150706,
        recovered: 28040168,
      },
      {
        date: "2020-10-23T00:00:00",
        confirmed: 42349187,
        deaths: 1156969,
        recovered: 28236449,
      },
      {
        date: "2020-10-24T00:00:00",
        confirmed: 42817641,
        deaths: 1162335,
        recovered: 28435731,
      },
      {
        date: "2020-10-25T00:00:00",
        confirmed: 43216733,
        deaths: 1166307,
        recovered: 28638975,
      },
      {
        date: "2020-10-26T00:00:00",
        confirmed: 43639228,
        deaths: 1171533,
        recovered: 28853912,
      },
      {
        date: "2020-10-27T00:00:00",
        confirmed: 44121346,
        deaths: 1178084,
        recovered: 29074347,
      },
      {
        date: "2020-10-28T00:00:00",
        confirmed: 44642202,
        deaths: 1185458,
        recovered: 29299266,
      },
      {
        date: "2020-10-29T00:00:00",
        confirmed: 45211956,
        deaths: 1192410,
        recovered: 29517748,
      },
      {
        date: "2020-10-30T00:00:00",
        confirmed: 45779652,
        deaths: 1199623,
        recovered: 29732531,
      },
      {
        date: "2020-10-31T00:00:00",
        confirmed: 46226078,
        deaths: 1205504,
        recovered: 29930277,
      },
      {
        date: "2020-11-01T00:00:00",
        confirmed: 46690654,
        deaths: 1210705,
        recovered: 30162819,
      },
      {
        date: "2020-11-02T00:00:00",
        confirmed: 47195109,
        deaths: 1216892,
        recovered: 30372635,
      },
      {
        date: "2020-11-03T00:00:00",
        confirmed: 47692204,
        deaths: 1225505,
        recovered: 30637527,
      },
      {
        date: "2020-11-04T00:00:00",
        confirmed: 48275952,
        deaths: 1236370,
        recovered: 30899232,
      },
      {
        date: "2020-11-05T00:00:00",
        confirmed: 48872294,
        deaths: 1245002,
        recovered: 31163995,
      },
      {
        date: "2020-11-06T00:00:00",
        confirmed: 49524245,
        deaths: 1254635,
        recovered: 31398176,
      },
      {
        date: "2020-11-07T00:00:00",
        confirmed: 50072636,
        deaths: 1261527,
        recovered: 31619484,
      },
      {
        date: "2020-11-08T00:00:00",
        confirmed: 50539072,
        deaths: 1267207,
        recovered: 31820670,
      },
      {
        date: "2020-11-09T00:00:00",
        confirmed: 51048711,
        deaths: 1274546,
        recovered: 32018127,
      },
      {
        date: "2020-11-10T00:00:00",
        confirmed: 51619489,
        deaths: 1284737,
        recovered: 32310387,
      },
      {
        date: "2020-11-11T00:00:00",
        confirmed: 52269449,
        deaths: 1295137,
        recovered: 32544238,
      },
      {
        date: "2020-11-12T00:00:00",
        confirmed: 52915934,
        deaths: 1304722,
        recovered: 33001764,
      },
      {
        date: "2020-11-13T00:00:00",
        confirmed: 53564751,
        deaths: 1315565,
        recovered: 33250188,
      },
      {
        date: "2020-11-14T00:00:00",
        confirmed: 54136858,
        deaths: 1324292,
        recovered: 33492491,
      },
      {
        date: "2020-11-15T00:00:00",
        confirmed: 54617426,
        deaths: 1330475,
        recovered: 33716852,
      },
      {
        date: "2020-11-16T00:00:00",
        confirmed: 55167397,
        deaths: 1338847,
        recovered: 34015668,
      },
      {
        date: "2020-11-17T00:00:00",
        confirmed: 55716569,
        deaths: 1349233,
        recovered: 34394212,
      },
      {
        date: "2020-11-18T00:00:00",
        confirmed: 56383131,
        deaths: 1361278,
        recovered: 34747060,
      },
      {
        date: "2020-11-19T00:00:00",
        confirmed: 57042910,
        deaths: 1371552,
        recovered: 35011863,
      },
      {
        date: "2020-11-20T00:00:00",
        confirmed: 57703242,
        deaths: 1383471,
        recovered: 35312670,
      },
      {
        date: "2020-11-21T00:00:00",
        confirmed: 58251263,
        deaths: 1391925,
        recovered: 35576209,
      },
      {
        date: "2020-11-22T00:00:00",
        confirmed: 58762542,
        deaths: 1399154,
        recovered: 35826199,
      },
      {
        date: "2020-11-23T00:00:00",
        confirmed: 59283992,
        deaths: 1407581,
        recovered: 36127194,
      },
      {
        date: "2020-11-24T00:00:00",
        confirmed: 59843964,
        deaths: 1419958,
        recovered: 36434096,
      },
      {
        date: "2020-11-25T00:00:00",
        confirmed: 60492792,
        deaths: 1432259,
        recovered: 36747664,
      },
      {
        date: "2020-11-26T00:00:00",
        confirmed: 61075274,
        deaths: 1443052,
        recovered: 37070107,
      },
      {
        date: "2020-11-27T00:00:00",
        confirmed: 61769401,
        deaths: 1454696,
        recovered: 37391252,
      },
      {
        date: "2020-11-28T00:00:00",
        confirmed: 62339349,
        deaths: 1463654,
        recovered: 37689515,
      },
      {
        date: "2020-11-29T00:00:00",
        confirmed: 62802820,
        deaths: 1470081,
        recovered: 37955525,
      },
      {
        date: "2020-11-30T00:00:00",
        confirmed: 63308363,
        deaths: 1478831,
        recovered: 38282833,
      },
      {
        date: "2020-12-01T00:00:00",
        confirmed: 63881671,
        deaths: 1491216,
        recovered: 38634815,
      },
      {
        date: "2020-12-02T00:00:00",
        confirmed: 64548028,
        deaths: 1504037,
        recovered: 39004951,
      },
      {
        date: "2020-12-03T00:00:00",
        confirmed: 64988110,
        deaths: 1512603,
        recovered: 39304803,
      },
      {
        date: "2020-12-04T00:00:00",
        confirmed: 65915958,
        deaths: 1528827,
        recovered: 39677785,
      },
      {
        date: "2020-12-05T00:00:00",
        confirmed: 66528739,
        deaths: 1538718,
        recovered: 39973596,
      },
      {
        date: "2020-12-06T00:00:00",
        confirmed: 67051371,
        deaths: 1545853,
        recovered: 40244686,
      },
      {
        date: "2020-12-07T00:00:00",
        confirmed: 67584821,
        deaths: 1554305,
        recovered: 40566252,
      },
      {
        date: "2020-12-08T00:00:00",
        confirmed: 68210874,
        deaths: 1566781,
        recovered: 40902209,
      },
      {
        date: "2020-12-09T00:00:00",
        confirmed: 68877078,
        deaths: 1579335,
        recovered: 41293730,
      },
      {
        date: "2020-12-10T00:00:00",
        confirmed: 70362707,
        deaths: 1591916,
        recovered: 42347468,
      },
      {
        date: "2020-12-11T00:00:00",
        confirmed: 71047884,
        deaths: 1604744,
        recovered: 42660956,
      },
      {
        date: "2020-12-12T00:00:00",
        confirmed: 71663723,
        deaths: 1615068,
        recovered: 43368583,
      },
      {
        date: "2020-12-13T00:00:00",
        confirmed: 72187783,
        deaths: 1622146,
        recovered: 43656709,
      },
      {
        date: "2020-12-14T00:00:00",
        confirmed: 72790849,
        deaths: 1631334,
        recovered: 43988267,
      },
      {
        date: "2020-12-15T00:00:00",
        confirmed: 73407131,
        deaths: 1645069,
        recovered: 44339407,
      },
      {
        date: "2020-12-16T00:00:00",
        confirmed: 74125330,
        deaths: 1658480,
        recovered: 44724583,
      },
      {
        date: "2020-12-17T00:00:00",
        confirmed: 74871723,
        deaths: 1671584,
        recovered: 45084410,
      },
      {
        date: "2020-12-18T00:00:00",
        confirmed: 75597604,
        deaths: 1684505,
        recovered: 45420884,
      },
      {
        date: "2020-12-19T00:00:00",
        confirmed: 76185425,
        deaths: 1694809,
        recovered: 45726572,
      },
      {
        date: "2020-12-20T00:00:00",
        confirmed: 76730910,
        deaths: 1702660,
        recovered: 45985240,
      },
      {
        date: "2020-12-21T00:00:00",
        confirmed: 77269831,
        deaths: 1712015,
        recovered: 46323584,
      },
      {
        date: "2020-12-22T00:00:00",
        confirmed: 77907263,
        deaths: 1726124,
        recovered: 46716300,
      },
      {
        date: "2020-12-23T00:00:00",
        confirmed: 78595268,
        deaths: 1740097,
        recovered: 47079210,
      },
      {
        date: "2020-12-24T00:00:00",
        confirmed: 79281582,
        deaths: 1751686,
        recovered: 47441622,
      },
      {
        date: "2020-12-25T00:00:00",
        confirmed: 79729795,
        deaths: 1759809,
        recovered: 47738235,
      },
      {
        date: "2020-12-26T00:00:00",
        confirmed: 80227450,
        deaths: 1766580,
        recovered: 48017490,
      },
      {
        date: "2020-12-27T00:00:00",
        confirmed: 80651038,
        deaths: 1773846,
        recovered: 48313662,
      },
      {
        date: "2020-12-28T00:00:00",
        confirmed: 81149671,
        deaths: 1783292,
        recovered: 48631171,
      },
      {
        date: "2020-12-29T00:00:00",
        confirmed: 81820433,
        deaths: 1798161,
        recovered: 49001640,
      },
      {
        date: "2020-12-30T00:00:00",
        confirmed: 82625364,
        deaths: 1813179,
        recovered: 49380172,
      },
      {
        date: "2020-12-31T00:00:00",
        confirmed: 83343066,
        deaths: 1826684,
        recovered: 49706037,
      },
      {
        date: "2021-01-01T00:00:00",
        confirmed: 83894801,
        deaths: 1836029,
        recovered: 49982407,
      },
      {
        date: "2021-01-02T00:00:00",
        confirmed: 84512709,
        deaths: 1844845,
        recovered: 50251902,
      },
      {
        date: "2021-01-03T00:00:00",
        confirmed: 85036571,
        deaths: 1851910,
        recovered: 50554038,
      },
      {
        date: "2021-01-04T00:00:00",
        confirmed: 85584585,
        deaths: 1861646,
        recovered: 50844091,
      },
      {
        date: "2021-01-05T00:00:00",
        confirmed: 86329261,
        deaths: 1877503,
        recovered: 51298160,
      },
      {
        date: "2021-01-06T00:00:00",
        confirmed: 87120499,
        deaths: 1892648,
        recovered: 52957167,
      },
      {
        date: "2021-01-07T00:00:00",
        confirmed: 87969643,
        deaths: 1907362,
        recovered: 53294752,
      },
      {
        date: "2021-01-08T00:00:00",
        confirmed: 88742817,
        deaths: 1921868,
        recovered: 53587617,
      },
      {
        date: "2021-01-09T00:00:00",
        confirmed: 89523301,
        deaths: 1935184,
        recovered: 53896487,
      },
      {
        date: "2021-01-10T00:00:00",
        confirmed: 90086389,
        deaths: 1942995,
        recovered: 54123106,
      },
      {
        date: "2021-01-11T00:00:00",
        confirmed: 90716718,
        deaths: 1952882,
        recovered: 54435662,
      },
      {
        date: "2021-01-12T00:00:00",
        confirmed: 91414047,
        deaths: 1970288,
        recovered: 54839290,
      },
      {
        date: "2021-01-13T00:00:00",
        confirmed: 91453688,
        deaths: 1971410,
        recovered: 54884085,
      },
      {
        date: "2021-01-14T00:00:00",
        confirmed: 92182720,
        deaths: 1984772,
        recovered: 55248391,
      },
      {
        date: "2021-01-15T00:00:00",
        confirmed: 92913081,
        deaths: 1998724,
        recovered: 55612776,
      },
      {
        date: "2021-01-16T00:00:00",
        confirmed: 93643423,
        deaths: 2012758,
        recovered: 55977151,
      },
      {
        date: "2021-01-17T00:00:00",
        confirmed: 94373784,
        deaths: 2026710,
        recovered: 56341536,
      },
      {
        date: "2021-01-18T00:00:00",
        confirmed: 95350322,
        deaths: 2048184,
        recovered: 56913409,
      },
      {
        date: "2021-01-19T00:00:00",
        confirmed: 95953488,
        deaths: 2064087,
        recovered: 57309522,
      },
      {
        date: "2021-01-20T00:00:00",
        confirmed: 96608868,
        deaths: 2081231,
        recovered: 57671051,
      },
      {
        date: "2021-01-21T00:00:00",
        confirmed: 97403259,
        deaths: 2098249,
        recovered: 58175580,
      },
      {
        date: "2021-01-22T00:00:00",
        confirmed: 98056577,
        deaths: 2113811,
        recovered: 58514302,
      },
      {
        date: "2021-01-23T00:00:00",
        confirmed: 98616048,
        deaths: 2127574,
        recovered: 58837074,
      },
      {
        date: "2021-01-24T00:00:00",
        confirmed: 99048595,
        deaths: 2135914,
        recovered: 59140522,
      },
      {
        date: "2021-01-25T00:00:00",
        confirmed: 99551245,
        deaths: 2146351,
        recovered: 59496481,
      },
      {
        date: "2021-01-26T00:00:00",
        confirmed: 100101409,
        deaths: 2163935,
        recovered: 59899015,
      },
      {
        date: "2021-01-27T00:00:00",
        confirmed: 100704411,
        deaths: 2181000,
        recovered: 60181662,
      },
      {
        date: "2021-01-28T00:00:00",
        confirmed: 101290699,
        deaths: 2197933,
        recovered: 60608610,
      },
      {
        date: "2021-01-29T00:00:00",
        confirmed: 101868311,
        deaths: 2212933,
        recovered: 60918865,
      },
      {
        date: "2021-01-30T00:00:00",
        confirmed: 102353737,
        deaths: 2225388,
        recovered: 61222391,
      },
      {
        date: "2021-01-31T00:00:00",
        confirmed: 102732917,
        deaths: 2233417,
        recovered: 61507802,
      },
      {
        date: "2021-02-01T00:00:00",
        confirmed: 103139440,
        deaths: 2245335,
        recovered: 61925670,
      },
      {
        date: "2021-02-02T00:00:00",
        confirmed: 103604161,
        deaths: 2260276,
        recovered: 62318496,
      },
      {
        date: "2021-02-03T00:00:00",
        confirmed: 104103892,
        deaths: 2275520,
        recovered: 62681573,
      },
      {
        date: "2021-02-04T00:00:00",
        confirmed: 104621633,
        deaths: 2291720,
        recovered: 63014984,
      },
      {
        date: "2021-02-05T00:00:00",
        confirmed: 105113170,
        deaths: 2306099,
        recovered: 63335256,
      },
      {
        date: "2021-02-06T00:00:00",
        confirmed: 105526609,
        deaths: 2317213,
        recovered: 63645738,
      },
      {
        date: "2021-02-07T00:00:00",
        confirmed: 105869237,
        deaths: 2324052,
        recovered: 63978771,
      },
      {
        date: "2021-02-08T00:00:00",
        confirmed: 106015765,
        deaths: 2330879,
        recovered: 64253881,
      },
      {
        date: "2021-02-09T00:00:00",
        confirmed: 106515413,
        deaths: 2347099,
        recovered: 64646766,
      },
      {
        date: "2021-02-10T00:00:00",
        confirmed: 106964022,
        deaths: 2360729,
        recovered: 64985116,
      },
      {
        date: "2021-02-11T00:00:00",
        confirmed: 107401404,
        deaths: 2374687,
        recovered: 65348980,
      },
      {
        date: "2021-02-12T00:00:00",
        confirmed: 107839538,
        deaths: 2390193,
        recovered: 65665992,
      },
      {
        date: "2021-02-13T00:00:00",
        confirmed: 108207196,
        deaths: 2401086,
        recovered: 65923294,
      },
      {
        date: "2021-02-14T00:00:00",
        confirmed: 108466067,
        deaths: 2406558,
        recovered: 66185031,
      },
      {
        date: "2021-02-15T00:00:00",
        confirmed: 108757545,
        deaths: 2413877,
        recovered: 68798392,
      },
      {
        date: "2021-02-16T00:00:00",
        confirmed: 109119092,
        deaths: 2424677,
        recovered: 69170848,
      },
      {
        date: "2021-02-17T00:00:00",
        confirmed: 109520924,
        deaths: 2435940,
        recovered: 69529936,
      },
      {
        date: "2021-02-18T00:00:00",
        confirmed: 109907459,
        deaths: 2447080,
        recovered: 69872137,
      },
      {
        date: "2021-02-19T00:00:00",
        confirmed: 110340532,
        deaths: 2458094,
        recovered: 70143423,
      },
      {
        date: "2021-02-20T00:00:00",
        confirmed: 110716049,
        deaths: 2466350,
        recovered: 70756742,
      },
      {
        date: "2021-02-21T00:00:00",
        confirmed: 111017785,
        deaths: 2472057,
        recovered: 71138535,
      },
      {
        date: "2021-02-22T00:00:00",
        confirmed: 111319589,
        deaths: 2479351,
        recovered: 71472353,
      },
      {
        date: "2021-02-23T00:00:00",
        confirmed: 111702208,
        deaths: 2490463,
        recovered: 71822827,
      },
      {
        date: "2021-02-24T00:00:00",
        confirmed: 112143899,
        deaths: 2502447,
        recovered: 72165814,
      },
      {
        date: "2021-02-25T00:00:00",
        confirmed: 112567104,
        deaths: 2512203,
        recovered: 72468921,
      },
    ],
    breakdowns: [
      {
        location: {
          long: 65.0,
          countryOrRegion: "Afghanistan",
          provinceOrState: null,
          county: null,
          isoCode: "AF",
          lat: 33.0,
        },
        totalConfirmedCases: 55696,
        newlyConfirmedCases: 16,
        totalDeaths: 2442,
        newDeaths: 4,
        totalRecoveredCases: 49281,
        newlyRecoveredCases: 195,
      },
      {
        location: {
          long: 20.1683,
          countryOrRegion: "Albania",
          provinceOrState: null,
          county: null,
          isoCode: "AL",
          lat: 41.1533,
        },
        totalConfirmedCases: 104313,
        newlyConfirmedCases: 986,
        totalDeaths: 1736,
        newDeaths: 21,
        totalRecoveredCases: 67158,
        newlyRecoveredCases: 849,
      },
      {
        location: {
          long: 1.6596,
          countryOrRegion: "Algeria",
          provinceOrState: null,
          county: null,
          isoCode: "DZ",
          lat: 28.0339,
        },
        totalConfirmedCases: 112622,
        newlyConfirmedCases: 161,
        totalDeaths: 2973,
        newDeaths: 3,
        totalRecoveredCases: 77683,
        newlyRecoveredCases: 146,
      },
      {
        location: {
          long: 1.5218,
          countryOrRegion: "Andorra",
          provinceOrState: null,
          county: null,
          isoCode: "AD",
          lat: 42.5063,
        },
        totalConfirmedCases: 10799,
        newlyConfirmedCases: 24,
        totalDeaths: 110,
        newDeaths: 0,
        totalRecoveredCases: 10356,
        newlyRecoveredCases: 37,
      },
      {
        location: {
          long: 17.873887,
          countryOrRegion: "Angola",
          provinceOrState: null,
          county: null,
          isoCode: "AO",
          lat: -11.202692,
        },
        totalConfirmedCases: 20695,
        newlyConfirmedCases: 55,
        totalDeaths: 502,
        newDeaths: 1,
        totalRecoveredCases: 19238,
        newlyRecoveredCases: 17,
      },
      {
        location: {
          long: -63.068615,
          countryOrRegion: "Anguilla",
          provinceOrState: null,
          county: null,
          isoCode: "AI",
          lat: 18.220554,
        },
        totalConfirmedCases: 18,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 18,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -61.796428,
          countryOrRegion: "Antigua and Barbuda",
          provinceOrState: null,
          county: null,
          isoCode: "AG",
          lat: 17.060816,
        },
        totalConfirmedCases: 701,
        newlyConfirmedCases: 55,
        totalDeaths: 14,
        newDeaths: 0,
        totalRecoveredCases: 271,
        newlyRecoveredCases: 38,
      },
      {
        location: {
          long: -63.6167,
          countryOrRegion: "Argentina",
          provinceOrState: null,
          county: null,
          isoCode: "AR",
          lat: -38.4161,
        },
        totalConfirmedCases: 2093645,
        newlyConfirmedCases: 8234,
        totalDeaths: 51795,
        newDeaths: 145,
        totalRecoveredCases: 1886732,
        newlyRecoveredCases: 4164,
      },
      {
        location: {
          long: 45.0382,
          countryOrRegion: "Armenia",
          provinceOrState: null,
          county: null,
          isoCode: "AM",
          lat: 40.0691,
        },
        totalConfirmedCases: 171227,
        newlyConfirmedCases: 0,
        totalDeaths: 3179,
        newDeaths: 0,
        totalRecoveredCases: 162984,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -69.968338,
          countryOrRegion: "Aruba",
          provinceOrState: null,
          county: null,
          isoCode: "AW",
          lat: 12.52111,
        },
        totalConfirmedCases: 7804,
        newlyConfirmedCases: 29,
        totalDeaths: 71,
        newDeaths: 0,
        totalRecoveredCases: 7494,
        newlyRecoveredCases: 58,
      },
      {
        location: {
          long: 133.775136,
          countryOrRegion: "Australia",
          provinceOrState: null,
          county: null,
          isoCode: "AU",
          lat: -25.274398,
        },
        totalConfirmedCases: 6991,
        newlyConfirmedCases: 0,
        totalDeaths: 98,
        newDeaths: 0,
        totalRecoveredCases: 6301,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 14.5501,
          countryOrRegion: "Austria",
          provinceOrState: null,
          county: null,
          isoCode: "AT",
          lat: 47.5162,
        },
        totalConfirmedCases: 452767,
        newlyConfirmedCases: 2391,
        totalDeaths: 8493,
        newDeaths: 23,
        totalRecoveredCases: 425786,
        newlyRecoveredCases: 1438,
      },
      {
        location: {
          long: 47.5769,
          countryOrRegion: "Azerbaijan",
          provinceOrState: null,
          county: null,
          isoCode: "AZ",
          lat: 40.1431,
        },
        totalConfirmedCases: 233770,
        newlyConfirmedCases: 126,
        totalDeaths: 3209,
        newDeaths: 3,
        totalRecoveredCases: 228299,
        newlyRecoveredCases: 142,
      },
      {
        location: {
          long: -78.035889,
          countryOrRegion: "Bahamas",
          provinceOrState: null,
          county: null,
          isoCode: "BS",
          lat: 25.025885,
        },
        totalConfirmedCases: 94,
        newlyConfirmedCases: 0,
        totalDeaths: 11,
        newDeaths: 0,
        totalRecoveredCases: 41,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 50.55,
          countryOrRegion: "Bahrain",
          provinceOrState: null,
          county: null,
          isoCode: "BH",
          lat: 26.0275,
        },
        totalConfirmedCases: 120495,
        newlyConfirmedCases: 637,
        totalDeaths: 439,
        newDeaths: 2,
        totalRecoveredCases: 113132,
        newlyRecoveredCases: 809,
      },
      {
        location: {
          long: 90.3563,
          countryOrRegion: "Bangladesh",
          provinceOrState: null,
          county: null,
          isoCode: "BD",
          lat: 23.685,
        },
        totalConfirmedCases: 544954,
        newlyConfirmedCases: 410,
        totalDeaths: 8384,
        newDeaths: 5,
        totalRecoveredCases: 494755,
        newlyRecoveredCases: 957,
      },
      {
        location: {
          long: -59.543198,
          countryOrRegion: "Barbados",
          provinceOrState: null,
          county: null,
          isoCode: "BB",
          lat: 13.193887,
        },
        totalConfirmedCases: 2949,
        newlyConfirmedCases: 42,
        totalDeaths: 32,
        newDeaths: 0,
        totalRecoveredCases: 2171,
        newlyRecoveredCases: 79,
      },
      {
        location: {
          long: 27.9534,
          countryOrRegion: "Belarus",
          provinceOrState: null,
          county: null,
          isoCode: "BY",
          lat: 53.7098,
        },
        totalConfirmedCases: 282898,
        newlyConfirmedCases: 1191,
        totalDeaths: 1948,
        newDeaths: 9,
        totalRecoveredCases: 273146,
        newlyRecoveredCases: 1413,
      },
      {
        location: {
          long: 4.0,
          countryOrRegion: "Belgium",
          provinceOrState: null,
          county: null,
          isoCode: "BE",
          lat: 50.8333,
        },
        totalConfirmedCases: 763885,
        newlyConfirmedCases: 3076,
        totalDeaths: 22006,
        newDeaths: 18,
        totalRecoveredCases: 52091,
        newlyRecoveredCases: 145,
      },
      {
        location: {
          long: -88.49765,
          countryOrRegion: "Belize",
          provinceOrState: null,
          county: null,
          isoCode: "BZ",
          lat: 17.189877,
        },
        totalConfirmedCases: 12280,
        newlyConfirmedCases: 9,
        totalDeaths: 315,
        newDeaths: 0,
        totalRecoveredCases: 11824,
        newlyRecoveredCases: 8,
      },
      {
        location: {
          long: 2.3158,
          countryOrRegion: "Benin",
          provinceOrState: null,
          county: null,
          isoCode: "BJ",
          lat: 9.3077,
        },
        totalConfirmedCases: 5434,
        newlyConfirmedCases: 0,
        totalDeaths: 70,
        newDeaths: 0,
        totalRecoveredCases: 4248,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -64.75737,
          countryOrRegion: "Bermuda",
          provinceOrState: null,
          county: null,
          isoCode: "BM",
          lat: 32.321384,
        },
        totalConfirmedCases: 705,
        newlyConfirmedCases: 2,
        totalDeaths: 12,
        newDeaths: 0,
        totalRecoveredCases: 682,
        newlyRecoveredCases: 1,
      },
      {
        location: {
          long: 90.4336,
          countryOrRegion: "Bhutan",
          provinceOrState: null,
          county: null,
          isoCode: "BT",
          lat: 27.5142,
        },
        totalConfirmedCases: 867,
        newlyConfirmedCases: 0,
        totalDeaths: 1,
        newDeaths: 0,
        totalRecoveredCases: 862,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -63.5887,
          countryOrRegion: "Bolivia",
          provinceOrState: null,
          county: null,
          isoCode: "BO",
          lat: -16.2902,
        },
        totalConfirmedCases: 246822,
        newlyConfirmedCases: 1103,
        totalDeaths: 11577,
        newDeaths: 30,
        totalRecoveredCases: 191081,
        newlyRecoveredCases: 1249,
      },
      {
        location: {
          long: 17.6791,
          countryOrRegion: "Bosnia and Herzegovina",
          provinceOrState: null,
          county: null,
          isoCode: "BA",
          lat: 43.9159,
        },
        totalConfirmedCases: 130510,
        newlyConfirmedCases: 757,
        totalDeaths: 5062,
        newDeaths: 11,
        totalRecoveredCases: 114995,
        newlyRecoveredCases: 634,
      },
      {
        location: {
          long: 24.6849,
          countryOrRegion: "Botswana",
          provinceOrState: null,
          county: null,
          isoCode: "BW",
          lat: -22.3285,
        },
        totalConfirmedCases: 28371,
        newlyConfirmedCases: 650,
        totalDeaths: 310,
        newDeaths: 10,
        totalRecoveredCases: 23244,
        newlyRecoveredCases: 471,
      },
      {
        location: {
          long: -51.9253,
          countryOrRegion: "Brazil",
          provinceOrState: null,
          county: null,
          isoCode: "BR",
          lat: -14.235,
        },
        totalConfirmedCases: 10393886,
        newlyConfirmedCases: 67878,
        totalDeaths: 251661,
        newDeaths: 1582,
        totalRecoveredCases: 9323696,
        newlyRecoveredCases: 42678,
      },
      {
        location: {
          long: -64.639968,
          countryOrRegion: "British Virgin Islands",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 18.420695,
        },
        totalConfirmedCases: 114,
        newlyConfirmedCases: 0,
        totalDeaths: 1,
        newDeaths: 0,
        totalRecoveredCases: 95,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 114.7277,
          countryOrRegion: "Brunei",
          provinceOrState: null,
          county: null,
          isoCode: "BN",
          lat: 4.5353,
        },
        totalConfirmedCases: 185,
        newlyConfirmedCases: 0,
        totalDeaths: 3,
        newDeaths: 0,
        totalRecoveredCases: 178,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 25.4858,
          countryOrRegion: "Bulgaria",
          provinceOrState: null,
          county: null,
          isoCode: "BG",
          lat: 42.7339,
        },
        totalConfirmedCases: 243946,
        newlyConfirmedCases: 1822,
        totalDeaths: 10079,
        newDeaths: 53,
        totalRecoveredCases: 202694,
        newlyRecoveredCases: 689,
      },
      {
        location: {
          long: -1.5616,
          countryOrRegion: "Burkina Faso",
          provinceOrState: null,
          county: null,
          isoCode: "BF",
          lat: 12.2383,
        },
        totalConfirmedCases: 11914,
        newlyConfirmedCases: 27,
        totalDeaths: 142,
        newDeaths: 0,
        totalRecoveredCases: 11340,
        newlyRecoveredCases: 20,
      },
      {
        location: {
          long: 95.956,
          countryOrRegion: "Burma",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 21.9162,
        },
        totalConfirmedCases: 181,
        newlyConfirmedCases: 0,
        totalDeaths: 6,
        newDeaths: 0,
        totalRecoveredCases: 84,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Cabo Verde",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: null,
        },
        totalConfirmedCases: 15201,
        newlyConfirmedCases: 40,
        totalDeaths: 145,
        newDeaths: 0,
        totalRecoveredCases: 14694,
        newlyRecoveredCases: 56,
      },
      {
        location: {
          long: 104.9167,
          countryOrRegion: "Cambodia",
          provinceOrState: null,
          county: null,
          isoCode: "KH",
          lat: 11.55,
        },
        totalConfirmedCases: 741,
        newlyConfirmedCases: 44,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 477,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 11.5021,
          countryOrRegion: "Cameroon",
          provinceOrState: null,
          county: null,
          isoCode: "CM",
          lat: 3.848,
        },
        totalConfirmedCases: 35714,
        newlyConfirmedCases: 1965,
        totalDeaths: 551,
        newDeaths: 28,
        totalRecoveredCases: 32594,
        newlyRecoveredCases: 1232,
      },
      {
        location: {
          long: -106.346771,
          countryOrRegion: "Canada",
          provinceOrState: null,
          county: null,
          isoCode: "CA",
          lat: 56.130366,
        },
        totalConfirmedCases: 863496,
        newlyConfirmedCases: 3146,
        totalDeaths: 21868,
        newDeaths: 58,
        totalRecoveredCases: 819761,
        newlyRecoveredCases: 3101,
      },
      {
        location: {
          long: -23.6167,
          countryOrRegion: "Cape Verde",
          provinceOrState: null,
          county: null,
          isoCode: "CV",
          lat: 15.1111,
        },
        totalConfirmedCases: 1,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 0,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: null,
          countryOrRegion: "CAR",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: null,
        },
        totalConfirmedCases: 1,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 0,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -80.566956,
          countryOrRegion: "Cayman Islands",
          provinceOrState: null,
          county: null,
          isoCode: "KY",
          lat: 19.513469,
        },
        totalConfirmedCases: 438,
        newlyConfirmedCases: 7,
        totalDeaths: 2,
        newDeaths: 0,
        totalRecoveredCases: 405,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 20.9394,
          countryOrRegion: "Central African Republic",
          provinceOrState: null,
          county: null,
          isoCode: "CF",
          lat: 6.6111,
        },
        totalConfirmedCases: 5004,
        newlyConfirmedCases: 0,
        totalDeaths: 63,
        newDeaths: 0,
        totalRecoveredCases: 4920,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 18.7322,
          countryOrRegion: "Chad",
          provinceOrState: null,
          county: null,
          isoCode: "TD",
          lat: 15.4542,
        },
        totalConfirmedCases: 3934,
        newlyConfirmedCases: 30,
        totalDeaths: 137,
        newDeaths: 1,
        totalRecoveredCases: 3420,
        newlyRecoveredCases: 22,
      },
      {
        location: {
          long: -2.3644,
          countryOrRegion: "Channel Islands",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 49.3723,
        },
        totalConfirmedCases: 4032,
        newlyConfirmedCases: 1,
        totalDeaths: 86,
        newDeaths: 0,
        totalRecoveredCases: 3893,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -71.543,
          countryOrRegion: "Chile",
          provinceOrState: null,
          county: null,
          isoCode: "CL",
          lat: -35.6751,
        },
        totalConfirmedCases: 812344,
        newlyConfirmedCases: 4472,
        totalDeaths: 20310,
        newDeaths: 137,
        totalRecoveredCases: 770190,
        newlyRecoveredCases: 2858,
      },
      {
        location: {
          long: 104.195397,
          countryOrRegion: "China",
          provinceOrState: null,
          county: null,
          isoCode: "CN",
          lat: 35.86166,
        },
        totalConfirmedCases: 93904,
        newlyConfirmedCases: 13,
        totalDeaths: 4831,
        newDeaths: 0,
        totalRecoveredCases: 89558,
        newlyRecoveredCases: 13,
      },
      {
        location: {
          long: -74.2973,
          countryOrRegion: "Colombia",
          provinceOrState: null,
          county: null,
          isoCode: "CO",
          lat: 4.5709,
        },
        totalConfirmedCases: 2241225,
        newlyConfirmedCases: 3683,
        totalDeaths: 59396,
        newDeaths: 136,
        totalRecoveredCases: 2138193,
        newlyRecoveredCases: 4139,
      },
      {
        location: {
          long: -83.7534,
          countryOrRegion: "Costa Rica",
          provinceOrState: null,
          county: null,
          isoCode: "CR",
          lat: 9.7489,
        },
        totalConfirmedCases: 203914,
        newlyConfirmedCases: 418,
        totalDeaths: 2796,
        newDeaths: 3,
        totalRecoveredCases: 175883,
        newlyRecoveredCases: 1787,
      },
      {
        location: {
          long: -5.5471,
          countryOrRegion: "Cote d'Ivoire",
          provinceOrState: null,
          county: null,
          isoCode: "CI",
          lat: 7.54,
        },
        totalConfirmedCases: 32295,
        newlyConfirmedCases: 0,
        totalDeaths: 188,
        newDeaths: 0,
        totalRecoveredCases: 31224,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 15.2,
          countryOrRegion: "Croatia",
          provinceOrState: null,
          county: null,
          isoCode: "HR",
          lat: 45.1,
        },
        totalConfirmedCases: 241592,
        newlyConfirmedCases: 544,
        totalDeaths: 5489,
        newDeaths: 12,
        totalRecoveredCases: 233170,
        newlyRecoveredCases: 278,
      },
      {
        location: {
          long: 139.638,
          countryOrRegion: "Cruise Ship: Diamond Princess",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 35.4437,
        },
        totalConfirmedCases: 712,
        newlyConfirmedCases: 0,
        totalDeaths: 13,
        newDeaths: 0,
        totalRecoveredCases: 699,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -80.0,
          countryOrRegion: "Cuba",
          provinceOrState: null,
          county: null,
          isoCode: "CU",
          lat: 22.0,
        },
        totalConfirmedCases: 47566,
        newlyConfirmedCases: 670,
        totalDeaths: 312,
        newDeaths: 4,
        totalRecoveredCases: 42809,
        newlyRecoveredCases: 906,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Curacao",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: null,
        },
        totalConfirmedCases: 4708,
        newlyConfirmedCases: 3,
        totalDeaths: 22,
        newDeaths: 0,
        totalRecoveredCases: 4624,
        newlyRecoveredCases: 4,
      },
      {
        location: {
          long: 33.4299,
          countryOrRegion: "Cyprus",
          provinceOrState: null,
          county: null,
          isoCode: "CY",
          lat: 35.1264,
        },
        totalConfirmedCases: 33909,
        newlyConfirmedCases: 199,
        totalDeaths: 231,
        newDeaths: 0,
        totalRecoveredCases: 2057,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 15.473,
          countryOrRegion: "Czechia",
          provinceOrState: null,
          county: null,
          isoCode: "CZ",
          lat: 49.8175,
        },
        totalConfirmedCases: 1198168,
        newlyConfirmedCases: 0,
        totalDeaths: 19835,
        newDeaths: 0,
        totalRecoveredCases: 1046575,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 15.307,
          countryOrRegion: "Democratic Republic of the Congo",
          provinceOrState: null,
          county: null,
          isoCode: "CD",
          lat: -4.3224,
        },
        totalConfirmedCases: 25144,
        newlyConfirmedCases: 0,
        totalDeaths: 700,
        newDeaths: 0,
        totalRecoveredCases: 16135,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 9.5018,
          countryOrRegion: "Denmark",
          provinceOrState: null,
          county: null,
          isoCode: "DK",
          lat: 56.2639,
        },
        totalConfirmedCases: 209682,
        newlyConfirmedCases: 603,
        totalDeaths: 2351,
        newDeaths: 6,
        totalRecoveredCases: 201154,
        newlyRecoveredCases: 439,
      },
      {
        location: {
          long: 42.5903,
          countryOrRegion: "Djibouti",
          provinceOrState: null,
          county: null,
          isoCode: "DJ",
          lat: 11.8251,
        },
        totalConfirmedCases: 6060,
        newlyConfirmedCases: 8,
        totalDeaths: 63,
        newDeaths: 0,
        totalRecoveredCases: 5892,
        newlyRecoveredCases: 6,
      },
      {
        location: {
          long: -61.370976,
          countryOrRegion: "Dominica",
          provinceOrState: null,
          county: null,
          isoCode: "DM",
          lat: 15.414999,
        },
        totalConfirmedCases: 142,
        newlyConfirmedCases: 1,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 127,
        newlyRecoveredCases: 1,
      },
      {
        location: {
          long: -70.1627,
          countryOrRegion: "Dominican Republic",
          provinceOrState: null,
          county: null,
          isoCode: "DO",
          lat: 18.7357,
        },
        totalConfirmedCases: 237629,
        newlyConfirmedCases: 746,
        totalDeaths: 3075,
        newDeaths: 9,
        totalRecoveredCases: 188300,
        newlyRecoveredCases: 878,
      },
      {
        location: {
          long: 125.56,
          countryOrRegion: "East Timor",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: -8.55,
        },
        totalConfirmedCases: 1,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 0,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -78.1834,
          countryOrRegion: "Ecuador",
          provinceOrState: null,
          county: null,
          isoCode: "EC",
          lat: -1.8312,
        },
        totalConfirmedCases: 281169,
        newlyConfirmedCases: 2390,
        totalDeaths: 15669,
        newDeaths: 35,
        totalRecoveredCases: 238817,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 30.0,
          countryOrRegion: "Egypt",
          provinceOrState: null,
          county: null,
          isoCode: "EG",
          lat: 26.0,
        },
        totalConfirmedCases: 180640,
        newlyConfirmedCases: 589,
        totalDeaths: 10541,
        newDeaths: 46,
        totalRecoveredCases: 139494,
        newlyRecoveredCases: 422,
      },
      {
        location: {
          long: -88.89653,
          countryOrRegion: "El Salvador",
          provinceOrState: null,
          county: null,
          isoCode: "SV",
          lat: 13.794185,
        },
        totalConfirmedCases: 59866,
        newlyConfirmedCases: 631,
        totalDeaths: 1832,
        newDeaths: 0,
        totalRecoveredCases: 55312,
        newlyRecoveredCases: 988,
      },
      {
        location: {
          long: 10.267895,
          countryOrRegion: "Equatorial Guinea",
          provinceOrState: null,
          county: null,
          isoCode: "GQ",
          lat: 1.650801,
        },
        totalConfirmedCases: 5852,
        newlyConfirmedCases: 0,
        totalDeaths: 91,
        newDeaths: 0,
        totalRecoveredCases: 5559,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 39.782334,
          countryOrRegion: "Eritrea",
          provinceOrState: null,
          county: null,
          isoCode: "ER",
          lat: 15.179384,
        },
        totalConfirmedCases: 2826,
        newlyConfirmedCases: 37,
        totalDeaths: 7,
        newDeaths: 0,
        totalRecoveredCases: 2225,
        newlyRecoveredCases: 52,
      },
      {
        location: {
          long: 25.0136,
          countryOrRegion: "Estonia",
          provinceOrState: null,
          county: null,
          isoCode: "EE",
          lat: 58.5953,
        },
        totalConfirmedCases: 61627,
        newlyConfirmedCases: 1152,
        totalDeaths: 567,
        newDeaths: 10,
        totalRecoveredCases: 47460,
        newlyRecoveredCases: 321,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Eswatini",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: null,
        },
        totalConfirmedCases: 16946,
        newlyConfirmedCases: 49,
        totalDeaths: 650,
        newDeaths: 1,
        totalRecoveredCases: 14031,
        newlyRecoveredCases: 230,
      },
      {
        location: {
          long: 40.489673,
          countryOrRegion: "Ethiopia",
          provinceOrState: null,
          county: null,
          isoCode: "ET",
          lat: 9.145,
        },
        totalConfirmedCases: 156112,
        newlyConfirmedCases: 878,
        totalDeaths: 2321,
        newDeaths: 5,
        totalRecoveredCases: 133607,
        newlyRecoveredCases: 169,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Faeroe Islands",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: null,
        },
        totalConfirmedCases: 658,
        newlyConfirmedCases: 0,
        totalDeaths: 1,
        newDeaths: 0,
        totalRecoveredCases: 656,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -6.9118,
          countryOrRegion: "Faroe Islands",
          provinceOrState: null,
          county: null,
          isoCode: "FO",
          lat: 61.8926,
        },
        totalConfirmedCases: 187,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 187,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -53.0,
          countryOrRegion: "Fench Guiana",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 4.0,
        },
        totalConfirmedCases: 5,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 0,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 179.414413,
          countryOrRegion: "Fiji",
          provinceOrState: null,
          county: null,
          isoCode: "FJ",
          lat: -16.578193,
        },
        totalConfirmedCases: 57,
        newlyConfirmedCases: 0,
        totalDeaths: 2,
        newDeaths: 0,
        totalRecoveredCases: 54,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 26.0,
          countryOrRegion: "Finland",
          provinceOrState: null,
          county: null,
          isoCode: "FI",
          lat: 64.0,
        },
        totalConfirmedCases: 55687,
        newlyConfirmedCases: 565,
        totalDeaths: 740,
        newDeaths: 3,
        totalRecoveredCases: 40000,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 2.2137,
          countryOrRegion: "France",
          provinceOrState: null,
          county: null,
          isoCode: "FR",
          lat: 46.2276,
        },
        totalConfirmedCases: 3686813,
        newlyConfirmedCases: 25403,
        totalDeaths: 85582,
        newDeaths: 261,
        totalRecoveredCases: 254868,
        newlyRecoveredCases: 1418,
      },
      {
        location: {
          long: -53.1258,
          countryOrRegion: "French Guiana",
          provinceOrState: null,
          county: null,
          isoCode: "GF",
          lat: 3.9339,
        },
        totalConfirmedCases: 16529,
        newlyConfirmedCases: 0,
        totalDeaths: 83,
        newDeaths: 0,
        totalRecoveredCases: 9995,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -149.406843,
          countryOrRegion: "French Polynesia",
          provinceOrState: null,
          county: null,
          isoCode: "PF",
          lat: -17.679742,
        },
        totalConfirmedCases: 18379,
        newlyConfirmedCases: 9,
        totalDeaths: 139,
        newDeaths: 0,
        totalRecoveredCases: 4842,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 11.609444,
          countryOrRegion: "Gabon",
          provinceOrState: null,
          county: null,
          isoCode: "GA",
          lat: -0.803689,
        },
        totalConfirmedCases: 14234,
        newlyConfirmedCases: 0,
        totalDeaths: 80,
        newDeaths: 0,
        totalRecoveredCases: 12846,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -15.3101,
          countryOrRegion: "Gambia",
          provinceOrState: null,
          county: null,
          isoCode: "GM",
          lat: 13.4432,
        },
        totalConfirmedCases: 23,
        newlyConfirmedCases: 0,
        totalDeaths: 1,
        newDeaths: 0,
        totalRecoveredCases: 10,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 43.3569,
          countryOrRegion: "Georgia",
          provinceOrState: null,
          county: null,
          isoCode: "GE",
          lat: 42.3154,
        },
        totalConfirmedCases: 269800,
        newlyConfirmedCases: 0,
        totalDeaths: 3475,
        newDeaths: 0,
        totalRecoveredCases: 263727,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 9.0,
          countryOrRegion: "Germany",
          provinceOrState: null,
          county: null,
          isoCode: "DE",
          lat: 51.0,
        },
        totalConfirmedCases: 2426819,
        newlyConfirmedCases: 10782,
        totalDeaths: 70003,
        newDeaths: 393,
        totalRecoveredCases: 2226500,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -1.023194,
          countryOrRegion: "Ghana",
          provinceOrState: null,
          county: null,
          isoCode: "GH",
          lat: 7.946527,
        },
        totalConfirmedCases: 81673,
        newlyConfirmedCases: 428,
        totalDeaths: 588,
        newDeaths: 4,
        totalRecoveredCases: 74681,
        newlyRecoveredCases: 634,
      },
      {
        location: {
          long: -5.3536,
          countryOrRegion: "Gibraltar",
          provinceOrState: null,
          county: null,
          isoCode: "GI",
          lat: 36.1408,
        },
        totalConfirmedCases: 4235,
        newlyConfirmedCases: 1,
        totalDeaths: 92,
        newDeaths: 1,
        totalRecoveredCases: 4119,
        newlyRecoveredCases: 6,
      },
      {
        location: {
          long: 21.8243,
          countryOrRegion: "Greece",
          provinceOrState: null,
          county: null,
          isoCode: "GR",
          lat: 39.0742,
        },
        totalConfirmedCases: 186469,
        newlyConfirmedCases: 1783,
        totalDeaths: 6410,
        newDeaths: 39,
        totalRecoveredCases: 165095,
        newlyRecoveredCases: 1194,
      },
      {
        location: {
          long: 42.6043,
          countryOrRegion: "Greenland",
          provinceOrState: null,
          county: null,
          isoCode: "GL",
          lat: 71.7069,
        },
        totalConfirmedCases: 30,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 30,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -61.604171,
          countryOrRegion: "Grenada",
          provinceOrState: null,
          county: null,
          isoCode: "GD",
          lat: 12.262776,
        },
        totalConfirmedCases: 148,
        newlyConfirmedCases: 0,
        totalDeaths: 1,
        newDeaths: 0,
        totalRecoveredCases: 147,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -62.067641,
          countryOrRegion: "Guadeloupe",
          provinceOrState: null,
          county: null,
          isoCode: "GP",
          lat: 16.995971,
        },
        totalConfirmedCases: 9746,
        newlyConfirmedCases: 0,
        totalDeaths: 159,
        newDeaths: 0,
        totalRecoveredCases: 2242,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -95.712891,
          countryOrRegion: "United States",
          provinceOrState: null,
          county: null,
          isoCode: "US",
          lat: 37.09024,
        },
        totalConfirmedCases: 28089251,
        newlyConfirmedCases: 73964,
        totalDeaths: 514334,
        newDeaths: 2089,
        totalRecoveredCases: 2796278,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -90.230759,
          countryOrRegion: "Guatemala",
          provinceOrState: null,
          county: null,
          isoCode: "GT",
          lat: 15.783471,
        },
        totalConfirmedCases: 173142,
        newlyConfirmedCases: 378,
        totalDeaths: 6334,
        newDeaths: 7,
        totalRecoveredCases: 160047,
        newlyRecoveredCases: 192,
      },
      {
        location: {
          long: -2.58,
          countryOrRegion: "Guernsey",
          provinceOrState: null,
          county: null,
          isoCode: "GG",
          lat: 49.45,
        },
        totalConfirmedCases: 1,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 0,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -9.696645,
          countryOrRegion: "Guinea",
          provinceOrState: null,
          county: null,
          isoCode: "GN",
          lat: 9.945587,
        },
        totalConfirmedCases: 15789,
        newlyConfirmedCases: 109,
        totalDeaths: 88,
        newDeaths: 0,
        totalRecoveredCases: 14821,
        newlyRecoveredCases: 23,
      },
      {
        location: {
          long: -15.1804,
          countryOrRegion: "Guinea-Bissau",
          provinceOrState: null,
          county: null,
          isoCode: "GW",
          lat: 11.8037,
        },
        totalConfirmedCases: 3215,
        newlyConfirmedCases: 44,
        totalDeaths: 48,
        newDeaths: 0,
        totalRecoveredCases: 2587,
        newlyRecoveredCases: 9,
      },
      {
        location: {
          long: -58.75,
          countryOrRegion: "Guyana",
          provinceOrState: null,
          county: null,
          isoCode: "GY",
          lat: 5.0,
        },
        totalConfirmedCases: 8485,
        newlyConfirmedCases: 28,
        totalDeaths: 195,
        newDeaths: 3,
        totalRecoveredCases: 7890,
        newlyRecoveredCases: 56,
      },
      {
        location: {
          long: -72.285215,
          countryOrRegion: "Haiti",
          provinceOrState: null,
          county: null,
          isoCode: "HT",
          lat: 18.971187,
        },
        totalConfirmedCases: 12390,
        newlyConfirmedCases: 38,
        totalDeaths: 248,
        newDeaths: 1,
        totalRecoveredCases: 9611,
        newlyRecoveredCases: 41,
      },
      {
        location: {
          long: 12.4534,
          countryOrRegion: "Holy See",
          provinceOrState: null,
          county: null,
          isoCode: "VA",
          lat: 41.9029,
        },
        totalConfirmedCases: 27,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 15,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -86.2419,
          countryOrRegion: "Honduras",
          provinceOrState: null,
          county: null,
          isoCode: "HN",
          lat: 15.2,
        },
        totalConfirmedCases: 168243,
        newlyConfirmedCases: 749,
        totalDeaths: 4099,
        newDeaths: 23,
        totalRecoveredCases: 65425,
        newlyRecoveredCases: 437,
      },
      {
        location: {
          long: 19.5033,
          countryOrRegion: "Hungary",
          provinceOrState: null,
          county: null,
          isoCode: "HU",
          lat: 47.1625,
        },
        totalConfirmedCases: 414514,
        newlyConfirmedCases: 4385,
        totalDeaths: 14672,
        newDeaths: 120,
        totalRecoveredCases: 315781,
        newlyRecoveredCases: 2331,
      },
      {
        location: {
          long: -19.0208,
          countryOrRegion: "Iceland",
          provinceOrState: null,
          county: null,
          isoCode: "IS",
          lat: 64.9631,
        },
        totalConfirmedCases: 6049,
        newlyConfirmedCases: 0,
        totalDeaths: 29,
        newDeaths: 0,
        totalRecoveredCases: 6005,
        newlyRecoveredCases: 1,
      },
      {
        location: {
          long: 78.0,
          countryOrRegion: "India",
          provinceOrState: null,
          county: null,
          isoCode: "IN",
          lat: 21.0,
        },
        totalConfirmedCases: 11063491,
        newlyConfirmedCases: 16577,
        totalDeaths: 156861,
        newDeaths: 119,
        totalRecoveredCases: 10750680,
        newlyRecoveredCases: 12179,
      },
      {
        location: {
          long: 113.9213,
          countryOrRegion: "Indonesia",
          provinceOrState: null,
          county: null,
          isoCode: "ID",
          lat: -0.7893,
        },
        totalConfirmedCases: 1314634,
        newlyConfirmedCases: 8493,
        totalDeaths: 35518,
        newDeaths: 264,
        totalRecoveredCases: 1121411,
        newlyRecoveredCases: 8686,
      },
      {
        location: {
          long: 53.0,
          countryOrRegion: "Iran",
          provinceOrState: null,
          county: null,
          isoCode: "IR",
          lat: 32.0,
        },
        totalConfirmedCases: 1607081,
        newlyConfirmedCases: 8206,
        totalDeaths: 59830,
        newDeaths: 94,
        totalRecoveredCases: 1372308,
        newlyRecoveredCases: 7055,
      },
      {
        location: {
          long: 44.0,
          countryOrRegion: "Iraq",
          provinceOrState: null,
          county: null,
          isoCode: "IQ",
          lat: 33.0,
        },
        totalConfirmedCases: 684362,
        newlyConfirmedCases: 4074,
        totalDeaths: 13351,
        newDeaths: 27,
        totalRecoveredCases: 627718,
        newlyRecoveredCases: 2271,
      },
      {
        location: {
          long: -7.6921,
          countryOrRegion: "Ireland",
          provinceOrState: null,
          county: null,
          isoCode: "IE",
          lat: 53.1424,
        },
        totalConfirmedCases: 217478,
        newlyConfirmedCases: 608,
        totalDeaths: 4271,
        newDeaths: 34,
        totalRecoveredCases: 23364,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -4.548056,
          countryOrRegion: "Isle of Man",
          provinceOrState: null,
          county: null,
          isoCode: "IM",
          lat: 54.236107,
        },
        totalConfirmedCases: 475,
        newlyConfirmedCases: 5,
        totalDeaths: 25,
        newDeaths: 0,
        totalRecoveredCases: 451,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 35.0,
          countryOrRegion: "Israel",
          provinceOrState: null,
          county: null,
          isoCode: "IL",
          lat: 31.0,
        },
        totalConfirmedCases: 767726,
        newlyConfirmedCases: 3970,
        totalDeaths: 5687,
        newDeaths: 27,
        totalRecoveredCases: 722534,
        newlyRecoveredCases: 4612,
      },
      {
        location: {
          long: 12.0,
          countryOrRegion: "Italy",
          provinceOrState: null,
          county: null,
          isoCode: "IT",
          lat: 43.0,
        },
        totalConfirmedCases: 2868435,
        newlyConfirmedCases: 19871,
        totalDeaths: 96974,
        newDeaths: 308,
        totalRecoveredCases: 2375318,
        newlyRecoveredCases: 12853,
      },
      {
        location: {
          long: -77.2975,
          countryOrRegion: "Jamaica",
          provinceOrState: null,
          county: null,
          isoCode: "JM",
          lat: 18.1096,
        },
        totalConfirmedCases: 22267,
        newlyConfirmedCases: 248,
        totalDeaths: 410,
        newDeaths: 4,
        totalRecoveredCases: 13173,
        newlyRecoveredCases: 66,
      },
      {
        location: {
          long: 138.0,
          countryOrRegion: "Japan",
          provinceOrState: null,
          county: null,
          isoCode: "JP",
          lat: 36.0,
        },
        totalConfirmedCases: 428553,
        newlyConfirmedCases: 1086,
        totalDeaths: 7647,
        newDeaths: 63,
        totalRecoveredCases: 405257,
        newlyRecoveredCases: 1876,
      },
      {
        location: {
          long: -2.11,
          countryOrRegion: "Jersey",
          provinceOrState: null,
          county: null,
          isoCode: "JE",
          lat: 49.19,
        },
        totalConfirmedCases: 2,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 0,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 36.51,
          countryOrRegion: "Jordan",
          provinceOrState: null,
          county: null,
          isoCode: "JO",
          lat: 31.24,
        },
        totalConfirmedCases: 380268,
        newlyConfirmedCases: 3827,
        totalDeaths: 4627,
        newDeaths: 16,
        totalRecoveredCases: 342600,
        newlyRecoveredCases: 1579,
      },
      {
        location: {
          long: 66.923684,
          countryOrRegion: "Kazakhstan",
          provinceOrState: null,
          county: null,
          isoCode: "KZ",
          lat: 48.019573,
        },
        totalConfirmedCases: 211212,
        newlyConfirmedCases: 855,
        totalDeaths: 2540,
        newDeaths: 0,
        totalRecoveredCases: 195121,
        newlyRecoveredCases: 746,
      },
      {
        location: {
          long: 37.906193,
          countryOrRegion: "Kenya",
          provinceOrState: null,
          county: null,
          isoCode: "KE",
          lat: -0.023559,
        },
        totalConfirmedCases: 105057,
        newlyConfirmedCases: 277,
        totalDeaths: 1847,
        newDeaths: 8,
        totalRecoveredCases: 86497,
        newlyRecoveredCases: 119,
      },
      {
        location: {
          long: 20.903,
          countryOrRegion: "Kosovo",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 42.6026,
        },
        totalConfirmedCases: 919,
        newlyConfirmedCases: 0,
        totalDeaths: 29,
        newDeaths: 0,
        totalRecoveredCases: 671,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 47.75,
          countryOrRegion: "Kuwait",
          provinceOrState: null,
          county: null,
          isoCode: "KW",
          lat: 29.5,
        },
        totalConfirmedCases: 188024,
        newlyConfirmedCases: 1019,
        totalDeaths: 1067,
        newDeaths: 5,
        totalRecoveredCases: 176019,
        newlyRecoveredCases: 971,
      },
      {
        location: {
          long: 74.766098,
          countryOrRegion: "Kyrgyzstan",
          provinceOrState: null,
          county: null,
          isoCode: "KG",
          lat: 41.20438,
        },
        totalConfirmedCases: 86142,
        newlyConfirmedCases: 51,
        totalDeaths: 1498,
        newDeaths: 0,
        totalRecoveredCases: 83061,
        newlyRecoveredCases: 55,
      },
      {
        location: {
          long: 102.495496,
          countryOrRegion: "Laos",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 19.85627,
        },
        totalConfirmedCases: 45,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 42,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 24.6032,
          countryOrRegion: "Latvia",
          provinceOrState: null,
          county: null,
          isoCode: "LV",
          lat: 56.8796,
        },
        totalConfirmedCases: 84258,
        newlyConfirmedCases: 813,
        totalDeaths: 1593,
        newDeaths: 6,
        totalRecoveredCases: 73285,
        newlyRecoveredCases: 823,
      },
      {
        location: {
          long: 35.8623,
          countryOrRegion: "Lebanon",
          provinceOrState: null,
          county: null,
          isoCode: "LB",
          lat: 33.8547,
        },
        totalConfirmedCases: 366319,
        newlyConfirmedCases: 3469,
        totalDeaths: 4560,
        newDeaths: 52,
        totalRecoveredCases: 281194,
        newlyRecoveredCases: 3453,
      },
      {
        location: {
          long: -9.429499,
          countryOrRegion: "Liberia",
          provinceOrState: null,
          county: null,
          isoCode: "LR",
          lat: 6.428055,
        },
        totalConfirmedCases: 2009,
        newlyConfirmedCases: 7,
        totalDeaths: 85,
        newDeaths: 0,
        totalRecoveredCases: 1884,
        newlyRecoveredCases: 1,
      },
      {
        location: {
          long: 17.228331,
          countryOrRegion: "Libya",
          provinceOrState: null,
          county: null,
          isoCode: "LY",
          lat: 26.3351,
        },
        totalConfirmedCases: 131833,
        newlyConfirmedCases: 571,
        totalDeaths: 2156,
        newDeaths: 5,
        totalRecoveredCases: 118791,
        newlyRecoveredCases: 800,
      },
      {
        location: {
          long: 9.55,
          countryOrRegion: "Liechtenstein",
          provinceOrState: null,
          county: null,
          isoCode: "LI",
          lat: 47.14,
        },
        totalConfirmedCases: 2558,
        newlyConfirmedCases: 5,
        totalDeaths: 54,
        newDeaths: 0,
        totalRecoveredCases: 2484,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 23.8813,
          countryOrRegion: "Lithuania",
          provinceOrState: null,
          county: null,
          isoCode: "LT",
          lat: 55.1694,
        },
        totalConfirmedCases: 196047,
        newlyConfirmedCases: 0,
        totalDeaths: 3209,
        newDeaths: 0,
        totalRecoveredCases: 181809,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 6.1296,
          countryOrRegion: "Luxembourg",
          provinceOrState: null,
          county: null,
          isoCode: "LU",
          lat: 49.8153,
        },
        totalConfirmedCases: 54871,
        newlyConfirmedCases: 193,
        totalDeaths: 634,
        newDeaths: 2,
        totalRecoveredCases: 51290,
        newlyRecoveredCases: 226,
      },
      {
        location: {
          long: 46.869107,
          countryOrRegion: "Madagascar",
          provinceOrState: null,
          county: null,
          isoCode: "MG",
          lat: -18.766947,
        },
        totalConfirmedCases: 19831,
        newlyConfirmedCases: 0,
        totalDeaths: 297,
        newDeaths: 0,
        totalRecoveredCases: 19296,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 112.5,
          countryOrRegion: "Malaysia",
          provinceOrState: null,
          county: null,
          isoCode: "MY",
          lat: 2.5,
        },
        totalConfirmedCases: 293698,
        newlyConfirmedCases: 1924,
        totalDeaths: 1100,
        newDeaths: 12,
        totalRecoveredCases: 263761,
        newlyRecoveredCases: 3752,
      },
      {
        location: {
          long: 73.2207,
          countryOrRegion: "Maldives",
          provinceOrState: null,
          county: null,
          isoCode: "MV",
          lat: 3.2028,
        },
        totalConfirmedCases: 19346,
        newlyConfirmedCases: 184,
        totalDeaths: 60,
        newDeaths: 0,
        totalRecoveredCases: 16838,
        newlyRecoveredCases: 192,
      },
      {
        location: {
          long: -3.996166,
          countryOrRegion: "Mali",
          provinceOrState: null,
          county: null,
          isoCode: "ML",
          lat: 17.570692,
        },
        totalConfirmedCases: 8349,
        newlyConfirmedCases: 17,
        totalDeaths: 349,
        newDeaths: 1,
        totalRecoveredCases: 6352,
        newlyRecoveredCases: 6,
      },
      {
        location: {
          long: 14.3754,
          countryOrRegion: "Malta",
          provinceOrState: null,
          county: null,
          isoCode: "MT",
          lat: 35.9375,
        },
        totalConfirmedCases: 21724,
        newlyConfirmedCases: 192,
        totalDeaths: 311,
        newDeaths: 3,
        totalRecoveredCases: 18905,
        newlyRecoveredCases: 185,
      },
      {
        location: {
          long: -61.0242,
          countryOrRegion: "Martinique",
          provinceOrState: null,
          county: null,
          isoCode: "MQ",
          lat: 14.6415,
        },
        totalConfirmedCases: 6687,
        newlyConfirmedCases: 0,
        totalDeaths: 45,
        newDeaths: 0,
        totalRecoveredCases: 98,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -10.940835,
          countryOrRegion: "Mauritania",
          provinceOrState: null,
          county: null,
          isoCode: "MR",
          lat: 21.00789,
        },
        totalConfirmedCases: 17179,
        newlyConfirmedCases: 21,
        totalDeaths: 439,
        newDeaths: 0,
        totalRecoveredCases: 16524,
        newlyRecoveredCases: 27,
      },
      {
        location: {
          long: 57.552152,
          countryOrRegion: "Mauritius",
          provinceOrState: null,
          county: null,
          isoCode: "MU",
          lat: -20.348404,
        },
        totalConfirmedCases: 610,
        newlyConfirmedCases: 0,
        totalDeaths: 10,
        newDeaths: 0,
        totalRecoveredCases: 571,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 45.166244,
          countryOrRegion: "Mayotte",
          provinceOrState: null,
          county: null,
          isoCode: "YT",
          lat: -12.8275,
        },
        totalConfirmedCases: 16861,
        newlyConfirmedCases: 223,
        totalDeaths: 102,
        newDeaths: 4,
        totalRecoveredCases: 2964,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -102.5528,
          countryOrRegion: "Mexico",
          provinceOrState: null,
          county: null,
          isoCode: "MX",
          lat: 23.6345,
        },
        totalConfirmedCases: 2069370,
        newlyConfirmedCases: 8462,
        totalDeaths: 183692,
        newDeaths: 877,
        totalRecoveredCases: 1620008,
        newlyRecoveredCases: 5394,
      },
      {
        location: {
          long: 28.3699,
          countryOrRegion: "Moldova",
          provinceOrState: null,
          county: null,
          isoCode: "MD",
          lat: 47.4116,
        },
        totalConfirmedCases: 181886,
        newlyConfirmedCases: 1736,
        totalDeaths: 3871,
        newDeaths: 25,
        totalRecoveredCases: 164321,
        newlyRecoveredCases: 425,
      },
      {
        location: {
          long: 7.4167,
          countryOrRegion: "Monaco",
          provinceOrState: null,
          county: null,
          isoCode: "MC",
          lat: 43.7333,
        },
        totalConfirmedCases: 1932,
        newlyConfirmedCases: 16,
        totalDeaths: 23,
        newDeaths: 0,
        totalRecoveredCases: 1690,
        newlyRecoveredCases: 7,
      },
      {
        location: {
          long: 103.8467,
          countryOrRegion: "Mongolia",
          provinceOrState: null,
          county: null,
          isoCode: "MN",
          lat: 46.8625,
        },
        totalConfirmedCases: 2831,
        newlyConfirmedCases: 30,
        totalDeaths: 2,
        newDeaths: 0,
        totalRecoveredCases: 2150,
        newlyRecoveredCases: 53,
      },
      {
        location: {
          long: 19.3,
          countryOrRegion: "Montenegro",
          provinceOrState: null,
          county: null,
          isoCode: "ME",
          lat: 42.5,
        },
        totalConfirmedCases: 74183,
        newlyConfirmedCases: 571,
        totalDeaths: 987,
        newDeaths: 11,
        totalRecoveredCases: 64737,
        newlyRecoveredCases: 497,
      },
      {
        location: {
          long: -62.187366,
          countryOrRegion: "Montserrat",
          provinceOrState: null,
          county: null,
          isoCode: "MS",
          lat: 16.742498,
        },
        totalConfirmedCases: 20,
        newlyConfirmedCases: 0,
        totalDeaths: 1,
        newDeaths: 0,
        totalRecoveredCases: 13,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -7.0926,
          countryOrRegion: "Morocco",
          provinceOrState: null,
          county: null,
          isoCode: "MA",
          lat: 31.7917,
        },
        totalConfirmedCases: 482514,
        newlyConfirmedCases: 386,
        totalDeaths: 8598,
        newDeaths: 6,
        totalRecoveredCases: 467541,
        newlyRecoveredCases: 726,
      },
      {
        location: {
          long: 35.529562,
          countryOrRegion: "Mozambique",
          provinceOrState: null,
          county: null,
          isoCode: "MZ",
          lat: -18.665695,
        },
        totalConfirmedCases: 57597,
        newlyConfirmedCases: 677,
        totalDeaths: 613,
        newDeaths: 5,
        totalRecoveredCases: 38676,
        newlyRecoveredCases: 806,
      },
      {
        location: {
          long: null,
          countryOrRegion: "MS Zaandam",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: null,
        },
        totalConfirmedCases: 9,
        newlyConfirmedCases: 0,
        totalDeaths: 2,
        newDeaths: 0,
        totalRecoveredCases: 7,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Myanmar",
          provinceOrState: null,
          county: null,
          isoCode: "MM",
          lat: null,
        },
        totalConfirmedCases: 141841,
        newlyConfirmedCases: 25,
        totalDeaths: 3198,
        newDeaths: 1,
        totalRecoveredCases: 131417,
        newlyRecoveredCases: 12,
      },
      {
        location: {
          long: 18.49041,
          countryOrRegion: "Namibia",
          provinceOrState: null,
          county: null,
          isoCode: "NA",
          lat: -22.95764,
        },
        totalConfirmedCases: 38206,
        newlyConfirmedCases: 230,
        totalDeaths: 416,
        newDeaths: 3,
        totalRecoveredCases: 35788,
        newlyRecoveredCases: 38,
      },
      {
        location: {
          long: 84.25,
          countryOrRegion: "Nepal",
          provinceOrState: null,
          county: null,
          isoCode: "NP",
          lat: 28.1667,
        },
        totalConfirmedCases: 273872,
        newlyConfirmedCases: 112,
        totalDeaths: 2685,
        newDeaths: 1,
        totalRecoveredCases: 270223,
        newlyRecoveredCases: 84,
      },
      {
        location: {
          long: 5.2913,
          countryOrRegion: "Netherlands",
          provinceOrState: null,
          county: null,
          isoCode: "NL",
          lat: 52.1326,
        },
        totalConfirmedCases: 1073971,
        newlyConfirmedCases: 5011,
        totalDeaths: 15438,
        newDeaths: 32,
        totalRecoveredCases: 250,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 165.618042,
          countryOrRegion: "New Caledonia",
          provinceOrState: null,
          county: null,
          isoCode: "NC",
          lat: -20.904305,
        },
        totalConfirmedCases: 57,
        newlyConfirmedCases: 2,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 55,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 174.886,
          countryOrRegion: "New Zealand",
          provinceOrState: null,
          county: null,
          isoCode: "NZ",
          lat: -40.9006,
        },
        totalConfirmedCases: 2371,
        newlyConfirmedCases: 3,
        totalDeaths: 26,
        newDeaths: 0,
        totalRecoveredCases: 2278,
        newlyRecoveredCases: 1,
      },
      {
        location: {
          long: -85.1167,
          countryOrRegion: "Nicaragua",
          provinceOrState: null,
          county: null,
          isoCode: "NI",
          lat: 13.1333,
        },
        totalConfirmedCases: 6445,
        newlyConfirmedCases: 0,
        totalDeaths: 173,
        newDeaths: 0,
        totalRecoveredCases: 4225,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 8.081666,
          countryOrRegion: "Niger",
          provinceOrState: null,
          county: null,
          isoCode: "NE",
          lat: 17.607789,
        },
        totalConfirmedCases: 4740,
        newlyConfirmedCases: 0,
        totalDeaths: 172,
        newDeaths: 0,
        totalRecoveredCases: 4250,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 8.6753,
          countryOrRegion: "Nigeria",
          provinceOrState: null,
          county: null,
          isoCode: "NG",
          lat: 9.082,
        },
        totalConfirmedCases: 154476,
        newlyConfirmedCases: 634,
        totalDeaths: 1891,
        newDeaths: 6,
        totalRecoveredCases: 131699,
        newlyRecoveredCases: 881,
      },
      {
        location: {
          long: 21.7453,
          countryOrRegion: "North Macedonia",
          provinceOrState: null,
          county: null,
          isoCode: "MK",
          lat: 41.6086,
        },
        totalConfirmedCases: 101214,
        newlyConfirmedCases: 582,
        totalDeaths: 3111,
        newDeaths: 13,
        totalRecoveredCases: 90685,
        newlyRecoveredCases: 374,
      },
      {
        location: {
          long: 8.4689,
          countryOrRegion: "Norway",
          provinceOrState: null,
          county: null,
          isoCode: "NO",
          lat: 60.472,
        },
        totalConfirmedCases: 70040,
        newlyConfirmedCases: 551,
        totalDeaths: 620,
        newDeaths: 0,
        totalRecoveredCases: 63783,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 57.0,
          countryOrRegion: "Oman",
          provinceOrState: null,
          county: null,
          isoCode: "OM",
          lat: 21.0,
        },
        totalConfirmedCases: 140588,
        newlyConfirmedCases: 288,
        totalDeaths: 1562,
        newDeaths: 4,
        totalRecoveredCases: 131684,
        newlyRecoveredCases: 299,
      },
      {
        location: {
          long: 69.3451,
          countryOrRegion: "Pakistan",
          provinceOrState: null,
          county: null,
          isoCode: "PK",
          lat: 30.3753,
        },
        totalConfirmedCases: 577482,
        newlyConfirmedCases: 1541,
        totalDeaths: 12804,
        newDeaths: 32,
        totalRecoveredCases: 542393,
        newlyRecoveredCases: 2505,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Palestine",
          provinceOrState: null,
          county: null,
          isoCode: "PS",
          lat: null,
        },
        totalConfirmedCases: 179293,
        newlyConfirmedCases: 1525,
        totalDeaths: 2008,
        newDeaths: 9,
        totalRecoveredCases: 164557,
        newlyRecoveredCases: 762,
      },
      {
        location: {
          long: -80.7821,
          countryOrRegion: "Panama",
          provinceOrState: null,
          county: null,
          isoCode: "PA",
          lat: 8.538,
        },
        totalConfirmedCases: 339383,
        newlyConfirmedCases: 682,
        totalDeaths: 5810,
        newDeaths: 21,
        totalRecoveredCases: 324156,
        newlyRecoveredCases: 873,
      },
      {
        location: {
          long: 143.95555,
          countryOrRegion: "Papua New Guinea",
          provinceOrState: null,
          county: null,
          isoCode: "PG",
          lat: -6.314993,
        },
        totalConfirmedCases: 1228,
        newlyConfirmedCases: 89,
        totalDeaths: 12,
        newDeaths: 1,
        totalRecoveredCases: 846,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -58.4438,
          countryOrRegion: "Paraguay",
          provinceOrState: null,
          county: null,
          isoCode: "PY",
          lat: -23.4425,
        },
        totalConfirmedCases: 156189,
        newlyConfirmedCases: 1285,
        totalDeaths: 3135,
        newDeaths: 16,
        totalRecoveredCases: 130531,
        newlyRecoveredCases: 900,
      },
      {
        location: {
          long: -75.0152,
          countryOrRegion: "Peru",
          provinceOrState: null,
          county: null,
          isoCode: "PE",
          lat: -9.19,
        },
        totalConfirmedCases: 1308722,
        newlyConfirmedCases: 7923,
        totalDeaths: 45903,
        newDeaths: 220,
        totalRecoveredCases: 1210749,
        newlyRecoveredCases: 6699,
      },
      {
        location: {
          long: 122.0,
          countryOrRegion: "Philippines",
          provinceOrState: null,
          county: null,
          isoCode: "PH",
          lat: 13.0,
        },
        totalConfirmedCases: 568680,
        newlyConfirmedCases: 2260,
        totalDeaths: 12201,
        newDeaths: 72,
        totalRecoveredCases: 524042,
        newlyRecoveredCases: 721,
      },
      {
        location: {
          long: 19.1451,
          countryOrRegion: "Poland",
          provinceOrState: null,
          county: null,
          isoCode: "PL",
          lat: 51.9194,
        },
        totalConfirmedCases: 1673252,
        newlyConfirmedCases: 12143,
        totalDeaths: 43094,
        newDeaths: 286,
        totalRecoveredCases: 1397342,
        newlyRecoveredCases: 5361,
      },
      {
        location: {
          long: -8.2245,
          countryOrRegion: "Portugal",
          provinceOrState: null,
          county: null,
          isoCode: "PT",
          lat: 39.3999,
        },
        totalConfirmedCases: 801746,
        newlyConfirmedCases: 1160,
        totalDeaths: 16185,
        newDeaths: 49,
        totalRecoveredCases: 711713,
        newlyRecoveredCases: 2659,
      },
      {
        location: {
          long: 51.1839,
          countryOrRegion: "Qatar",
          provinceOrState: null,
          county: null,
          isoCode: "QA",
          lat: 25.3548,
        },
        totalConfirmedCases: 162268,
        newlyConfirmedCases: 465,
        totalDeaths: 257,
        newDeaths: 0,
        totalRecoveredCases: 152327,
        newlyRecoveredCases: 540,
      },
      {
        location: {
          long: 15.2831,
          countryOrRegion: "Republic of the Congo",
          provinceOrState: null,
          county: null,
          isoCode: "CG",
          lat: -4.2661,
        },
        totalConfirmedCases: 8820,
        newlyConfirmedCases: 0,
        totalDeaths: 128,
        newDeaths: 0,
        totalRecoveredCases: 7019,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 55.5364,
          countryOrRegion: "Reunion",
          provinceOrState: null,
          county: null,
          isoCode: "RE",
          lat: -21.1151,
        },
        totalConfirmedCases: 12416,
        newlyConfirmedCases: 0,
        totalDeaths: 52,
        newDeaths: 0,
        totalRecoveredCases: 11270,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 24.9668,
          countryOrRegion: "Romania",
          provinceOrState: null,
          county: null,
          isoCode: "RO",
          lat: 45.9432,
        },
        totalConfirmedCases: 791971,
        newlyConfirmedCases: 3923,
        totalDeaths: 20167,
        newDeaths: 81,
        totalRecoveredCases: 733616,
        newlyRecoveredCases: 2567,
      },
      {
        location: {
          long: 90.0,
          countryOrRegion: "Russia",
          provinceOrState: null,
          county: null,
          isoCode: "RU",
          lat: 60.0,
        },
        totalConfirmedCases: 4212100,
        newlyConfirmedCases: 11198,
        totalDeaths: 84876,
        newDeaths: 446,
        totalRecoveredCases: 3767664,
        newlyRecoveredCases: 16102,
      },
      {
        location: {
          long: 29.873888,
          countryOrRegion: "Rwanda",
          provinceOrState: null,
          county: null,
          isoCode: "RW",
          lat: -1.940278,
        },
        totalConfirmedCases: 18553,
        newlyConfirmedCases: 110,
        totalDeaths: 258,
        newDeaths: 4,
        totalRecoveredCases: 17279,
        newlyRecoveredCases: 15,
      },
      {
        location: {
          long: -62.8333,
          countryOrRegion: "Saint Barthelemy",
          provinceOrState: null,
          county: null,
          isoCode: "BL",
          lat: 17.9,
        },
        totalConfirmedCases: 573,
        newlyConfirmedCases: 0,
        totalDeaths: 1,
        newDeaths: 0,
        totalRecoveredCases: 462,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -62.782998,
          countryOrRegion: "Saint Kitts and Nevis",
          provinceOrState: null,
          county: null,
          isoCode: "KN",
          lat: 17.357822,
        },
        totalConfirmedCases: 41,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 40,
        newlyRecoveredCases: 1,
      },
      {
        location: {
          long: -60.978893,
          countryOrRegion: "Saint Lucia",
          provinceOrState: null,
          county: null,
          isoCode: "LC",
          lat: 13.909444,
        },
        totalConfirmedCases: 3149,
        newlyConfirmedCases: 0,
        totalDeaths: 34,
        newDeaths: 0,
        totalRecoveredCases: 2879,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -63.0501,
          countryOrRegion: "Saint Martin",
          provinceOrState: null,
          county: null,
          isoCode: "MF",
          lat: 18.0708,
        },
        totalConfirmedCases: 1544,
        newlyConfirmedCases: 0,
        totalDeaths: 12,
        newDeaths: 0,
        totalRecoveredCases: 1399,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -61.287228,
          countryOrRegion: "Saint Vincent and the Grenadines",
          provinceOrState: null,
          county: null,
          isoCode: "VC",
          lat: 12.984305,
        },
        totalConfirmedCases: 1519,
        newlyConfirmedCases: 0,
        totalDeaths: 6,
        newDeaths: 0,
        totalRecoveredCases: 848,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 12.4578,
          countryOrRegion: "San Marino",
          provinceOrState: null,
          county: null,
          isoCode: "SM",
          lat: 43.9424,
        },
        totalConfirmedCases: 3621,
        newlyConfirmedCases: 36,
        totalDeaths: 73,
        newDeaths: 0,
        totalRecoveredCases: 3201,
        newlyRecoveredCases: 6,
      },
      {
        location: {
          long: 45.0,
          countryOrRegion: "Saudi Arabia",
          provinceOrState: null,
          county: null,
          isoCode: "SA",
          lat: 24.0,
        },
        totalConfirmedCases: 376377,
        newlyConfirmedCases: 356,
        totalDeaths: 6480,
        newDeaths: 5,
        totalRecoveredCases: 367323,
        newlyRecoveredCases: 308,
      },
      {
        location: {
          long: -14.4524,
          countryOrRegion: "Senegal",
          provinceOrState: null,
          county: null,
          isoCode: "SN",
          lat: 14.4974,
        },
        totalConfirmedCases: 33741,
        newlyConfirmedCases: 288,
        totalDeaths: 852,
        newDeaths: 12,
        totalRecoveredCases: 28112,
        newlyRecoveredCases: 219,
      },
      {
        location: {
          long: 21.0059,
          countryOrRegion: "Serbia",
          provinceOrState: null,
          county: null,
          isoCode: "RS",
          lat: 44.0165,
        },
        totalConfirmedCases: 449901,
        newlyConfirmedCases: 3588,
        totalDeaths: 4398,
        newDeaths: 15,
        totalRecoveredCases: 400347,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 55.491977,
          countryOrRegion: "Seychelles",
          provinceOrState: null,
          county: null,
          isoCode: "SC",
          lat: -4.679574,
        },
        totalConfirmedCases: 2562,
        newlyConfirmedCases: 0,
        totalDeaths: 11,
        newDeaths: 0,
        totalRecoveredCases: 2048,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 103.8333,
          countryOrRegion: "Singapore",
          provinceOrState: null,
          county: null,
          isoCode: "SG",
          lat: 1.2833,
        },
        totalConfirmedCases: 59900,
        newlyConfirmedCases: 10,
        totalDeaths: 29,
        newDeaths: 0,
        totalRecoveredCases: 59785,
        newlyRecoveredCases: 24,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Sint Maarten",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: null,
        },
        totalConfirmedCases: 2051,
        newlyConfirmedCases: 1,
        totalDeaths: 27,
        newDeaths: 0,
        totalRecoveredCases: 1988,
        newlyRecoveredCases: 5,
      },
      {
        location: {
          long: 19.699,
          countryOrRegion: "Slovakia",
          provinceOrState: null,
          county: null,
          isoCode: "SK",
          lat: 48.669,
        },
        totalConfirmedCases: 300775,
        newlyConfirmedCases: 2438,
        totalDeaths: 6859,
        newDeaths: 84,
        totalRecoveredCases: 255300,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 14.9955,
          countryOrRegion: "Slovenia",
          provinceOrState: null,
          county: null,
          isoCode: "SI",
          lat: 46.1512,
        },
        totalConfirmedCases: 187762,
        newlyConfirmedCases: 757,
        totalDeaths: 3809,
        newDeaths: 7,
        totalRecoveredCases: 171905,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 46.1996,
          countryOrRegion: "Somalia",
          provinceOrState: null,
          county: null,
          isoCode: "SO",
          lat: 5.1521,
        },
        totalConfirmedCases: 6687,
        newlyConfirmedCases: 138,
        totalDeaths: 223,
        newDeaths: 5,
        totalRecoveredCases: 3784,
        newlyRecoveredCases: 1,
      },
      {
        location: {
          long: 22.9375,
          countryOrRegion: "South Africa",
          provinceOrState: null,
          county: null,
          isoCode: "ZA",
          lat: -30.5595,
        },
        totalConfirmedCases: 1509124,
        newlyConfirmedCases: 1676,
        totalDeaths: 49667,
        newDeaths: 144,
        totalRecoveredCases: 1424401,
        newlyRecoveredCases: 1779,
      },
      {
        location: {
          long: 128.0,
          countryOrRegion: "South Korea",
          provinceOrState: null,
          county: null,
          isoCode: "KR",
          lat: 36.0,
        },
        totalConfirmedCases: 88922,
        newlyConfirmedCases: 406,
        totalDeaths: 1585,
        newDeaths: 4,
        totalRecoveredCases: 79880,
        newlyRecoveredCases: 393,
      },
      {
        location: {
          long: -4.0,
          countryOrRegion: "Spain",
          provinceOrState: null,
          county: null,
          isoCode: "ES",
          lat: 40.0,
        },
        totalConfirmedCases: 3180212,
        newlyConfirmedCases: 9568,
        totalDeaths: 68813,
        newDeaths: 345,
        totalRecoveredCases: 2617239,
        newlyRecoveredCases: 27243,
      },
      {
        location: {
          long: 81.0,
          countryOrRegion: "Sri Lanka",
          provinceOrState: null,
          county: null,
          isoCode: "LK",
          lat: 7.0,
        },
        totalConfirmedCases: 81933,
        newlyConfirmedCases: 466,
        totalDeaths: 459,
        newDeaths: 2,
        totalRecoveredCases: 76961,
        newlyRecoveredCases: 447,
      },
      {
        location: {
          long: 30.217636,
          countryOrRegion: "Sudan",
          provinceOrState: null,
          county: null,
          isoCode: "SD",
          lat: 12.862807,
        },
        totalConfirmedCases: 28270,
        newlyConfirmedCases: 60,
        totalDeaths: 1878,
        newDeaths: 2,
        totalRecoveredCases: 22844,
        newlyRecoveredCases: 21,
      },
      {
        location: {
          long: -56.027783,
          countryOrRegion: "Suriname",
          provinceOrState: null,
          county: null,
          isoCode: "SR",
          lat: 3.919305,
        },
        totalConfirmedCases: 8901,
        newlyConfirmedCases: 9,
        totalDeaths: 170,
        newDeaths: 0,
        totalRecoveredCases: 8385,
        newlyRecoveredCases: 14,
      },
      {
        location: {
          long: 16.0,
          countryOrRegion: "Sweden",
          provinceOrState: null,
          county: null,
          isoCode: "SE",
          lat: 63.0,
        },
        totalConfirmedCases: 652465,
        newlyConfirmedCases: 4995,
        totalDeaths: 12798,
        newDeaths: 5,
        totalRecoveredCases: 4971,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 8.2275,
          countryOrRegion: "Switzerland",
          provinceOrState: null,
          county: null,
          isoCode: "CH",
          lat: 46.8182,
        },
        totalConfirmedCases: 553867,
        newlyConfirmedCases: 1169,
        totalDeaths: 9954,
        newDeaths: 12,
        totalRecoveredCases: 505666,
        newlyRecoveredCases: 1859,
      },
      {
        location: {
          long: 38.996815,
          countryOrRegion: "Syria",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 34.802075,
        },
        totalConfirmedCases: 15405,
        newlyConfirmedCases: 62,
        totalDeaths: 1014,
        newDeaths: 6,
        totalRecoveredCases: 9553,
        newlyRecoveredCases: 85,
      },
      {
        location: {
          long: 121.0,
          countryOrRegion: "Taiwan",
          provinceOrState: null,
          county: null,
          isoCode: "TW",
          lat: 23.7,
        },
        totalConfirmedCases: 951,
        newlyConfirmedCases: 0,
        totalDeaths: 9,
        newDeaths: 0,
        totalRecoveredCases: 906,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 34.888822,
          countryOrRegion: "Tanzania",
          provinceOrState: null,
          county: null,
          isoCode: "TZ",
          lat: -6.369028,
        },
        totalConfirmedCases: 509,
        newlyConfirmedCases: 0,
        totalDeaths: 21,
        newDeaths: 0,
        totalRecoveredCases: 183,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 101.0,
          countryOrRegion: "Thailand",
          provinceOrState: null,
          county: null,
          isoCode: "TH",
          lat: 15.0,
        },
        totalConfirmedCases: 25809,
        newlyConfirmedCases: 45,
        totalDeaths: 83,
        newDeaths: 0,
        totalRecoveredCases: 24952,
        newlyRecoveredCases: 218,
      },
      {
        location: {
          long: -77.39628,
          countryOrRegion: "The Bahamas",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 25.03428,
        },
        totalConfirmedCases: 8496,
        newlyConfirmedCases: 0,
        totalDeaths: 179,
        newDeaths: 0,
        totalRecoveredCases: 7274,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -15.3101,
          countryOrRegion: "The Gambia",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 13.4432,
        },
        totalConfirmedCases: 4671,
        newlyConfirmedCases: 31,
        totalDeaths: 147,
        newDeaths: 0,
        totalRecoveredCases: 4089,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 125.727539,
          countryOrRegion: "Timor-Leste",
          provinceOrState: null,
          county: null,
          isoCode: "TL",
          lat: -8.874217,
        },
        totalConfirmedCases: 110,
        newlyConfirmedCases: 1,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 89,
        newlyRecoveredCases: 1,
      },
      {
        location: {
          long: 0.8248,
          countryOrRegion: "Togo",
          provinceOrState: null,
          county: null,
          isoCode: "TG",
          lat: 8.6195,
        },
        totalConfirmedCases: 6637,
        newlyConfirmedCases: 89,
        totalDeaths: 82,
        newDeaths: 0,
        totalRecoveredCases: 5489,
        newlyRecoveredCases: 42,
      },
      {
        location: {
          long: -61.222503,
          countryOrRegion: "Trinidad and Tobago",
          provinceOrState: null,
          county: null,
          isoCode: "TT",
          lat: 10.691803,
        },
        totalConfirmedCases: 7697,
        newlyConfirmedCases: 7,
        totalDeaths: 139,
        newDeaths: 0,
        totalRecoveredCases: 7436,
        newlyRecoveredCases: 5,
      },
      {
        location: {
          long: 9.0,
          countryOrRegion: "Tunisia",
          provinceOrState: null,
          county: null,
          isoCode: "TN",
          lat: 34.0,
        },
        totalConfirmedCases: 231298,
        newlyConfirmedCases: 855,
        totalDeaths: 7911,
        newDeaths: 42,
        totalRecoveredCases: 195739,
        newlyRecoveredCases: 3457,
      },
      {
        location: {
          long: 35.2433,
          countryOrRegion: "Turkey",
          provinceOrState: null,
          county: null,
          isoCode: "TR",
          lat: 38.9637,
        },
        totalConfirmedCases: 2674766,
        newlyConfirmedCases: 9572,
        totalDeaths: 28358,
        newDeaths: 73,
        totalRecoveredCases: 2546503,
        newlyRecoveredCases: 6210,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Turks and Caicos",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: null,
        },
        totalConfirmedCases: 2070,
        newlyConfirmedCases: 19,
        totalDeaths: 14,
        newDeaths: 0,
        totalRecoveredCases: 1819,
        newlyRecoveredCases: 23,
      },
      {
        location: {
          long: -71.7979,
          countryOrRegion: "Turks and Caicos Islands",
          provinceOrState: null,
          county: null,
          isoCode: "TC",
          lat: 21.694,
        },
        totalConfirmedCases: 12,
        newlyConfirmedCases: 0,
        totalDeaths: 1,
        newDeaths: 0,
        totalRecoveredCases: 10,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 32.290275,
          countryOrRegion: "Uganda",
          provinceOrState: null,
          county: null,
          isoCode: "UG",
          lat: 1.373333,
        },
        totalConfirmedCases: 40300,
        newlyConfirmedCases: 39,
        totalDeaths: 334,
        newDeaths: 0,
        totalRecoveredCases: 14616,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 31.1656,
          countryOrRegion: "Ukraine",
          provinceOrState: null,
          county: null,
          isoCode: "UA",
          lat: 48.3794,
        },
        totalConfirmedCases: 1325841,
        newlyConfirmedCases: 0,
        totalDeaths: 25596,
        newDeaths: 0,
        totalRecoveredCases: 1159311,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 54.0,
          countryOrRegion: "United Arab Emirates",
          provinceOrState: null,
          county: null,
          isoCode: "AE",
          lat: 24.0,
        },
        totalConfirmedCases: 381662,
        newlyConfirmedCases: 3025,
        totalDeaths: 1182,
        newDeaths: 18,
        totalRecoveredCases: 375059,
        newlyRecoveredCases: 4678,
      },
      {
        location: {
          long: -3.0,
          countryOrRegion: "United Kingdom",
          provinceOrState: null,
          county: null,
          isoCode: "GB",
          lat: 55.0,
        },
        totalConfirmedCases: 4154562,
        newlyConfirmedCases: 9985,
        totalDeaths: 122070,
        newDeaths: 323,
        totalRecoveredCases: 2727466,
        newlyRecoveredCases: 61000,
      },
      {
        location: {
          long: -55.765835,
          countryOrRegion: "Uruguay",
          provinceOrState: null,
          county: null,
          isoCode: "UY",
          lat: -32.522779,
        },
        totalConfirmedCases: 55695,
        newlyConfirmedCases: 821,
        totalDeaths: 595,
        newDeaths: 4,
        totalRecoveredCases: 48496,
        newlyRecoveredCases: 461,
      },
      {
        location: {
          long: 64.585262,
          countryOrRegion: "Uzbekistan",
          provinceOrState: null,
          county: null,
          isoCode: "UZ",
          lat: 41.377491,
        },
        totalConfirmedCases: 79804,
        newlyConfirmedCases: 31,
        totalDeaths: 622,
        newDeaths: 0,
        totalRecoveredCases: 78333,
        newlyRecoveredCases: 43,
      },
      {
        location: {
          long: -66.58973,
          countryOrRegion: "Venezuela",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 6.42375,
        },
        totalConfirmedCases: 137871,
        newlyConfirmedCases: 426,
        totalDeaths: 1334,
        newDeaths: 3,
        totalRecoveredCases: 129927,
        newlyRecoveredCases: 440,
      },
      {
        location: {
          long: 108.0,
          countryOrRegion: "Vietnam",
          provinceOrState: null,
          county: null,
          isoCode: "VN",
          lat: 16.0,
        },
        totalConfirmedCases: 2421,
        newlyConfirmedCases: 9,
        totalDeaths: 35,
        newDeaths: 0,
        totalRecoveredCases: 1804,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 35.2332,
          countryOrRegion: "West Bank and Gaza",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 31.9522,
        },
        totalConfirmedCases: 495,
        newlyConfirmedCases: 0,
        totalDeaths: 4,
        newDeaths: 0,
        totalRecoveredCases: 316,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 28.2833,
          countryOrRegion: "Zambia",
          provinceOrState: null,
          county: null,
          isoCode: "ZM",
          lat: -15.4167,
        },
        totalConfirmedCases: 77171,
        newlyConfirmedCases: 687,
        totalDeaths: 1059,
        newDeaths: 8,
        totalRecoveredCases: 70800,
        newlyRecoveredCases: 997,
      },
      {
        location: {
          long: 29.154857,
          countryOrRegion: "Zimbabwe",
          provinceOrState: null,
          county: null,
          isoCode: "ZW",
          lat: -19.015438,
        },
        totalConfirmedCases: 35994,
        newlyConfirmedCases: 34,
        totalDeaths: 1458,
        newDeaths: 2,
        totalRecoveredCases: 32455,
        newlyRecoveredCases: 45,
      },
      {
        location: {
          long: -11.779889,
          countryOrRegion: "Sierra Leone",
          provinceOrState: null,
          county: null,
          isoCode: "SL",
          lat: 8.460555,
        },
        totalConfirmedCases: 3884,
        newlyConfirmedCases: 4,
        totalDeaths: 79,
        newDeaths: 0,
        totalRecoveredCases: 2612,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 29.918886,
          countryOrRegion: "Burundi",
          provinceOrState: null,
          county: null,
          isoCode: "BI",
          lat: -3.373056,
        },
        totalConfirmedCases: 2106,
        newlyConfirmedCases: 37,
        totalDeaths: 3,
        newDeaths: 0,
        totalRecoveredCases: 773,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Caribbean Netherlands",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: null,
        },
        totalConfirmedCases: 429,
        newlyConfirmedCases: 0,
        totalDeaths: 4,
        newDeaths: 0,
        totalRecoveredCases: 402,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 34.301525,
          countryOrRegion: "Malawi",
          provinceOrState: null,
          county: null,
          isoCode: "MW",
          lat: -13.254308,
        },
        totalConfirmedCases: 31502,
        newlyConfirmedCases: 207,
        totalDeaths: 1033,
        newDeaths: 4,
        totalRecoveredCases: 18045,
        newlyRecoveredCases: 475,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Falkland Islands",
          provinceOrState: null,
          county: null,
          isoCode: "FK",
          lat: null,
        },
        totalConfirmedCases: 54,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 46,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -12.885834,
          countryOrRegion: "Western Sahara",
          provinceOrState: null,
          county: null,
          isoCode: "EH",
          lat: 24.215527,
        },
        totalConfirmedCases: 10,
        newlyConfirmedCases: 0,
        totalDeaths: 1,
        newDeaths: 0,
        totalRecoveredCases: 8,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Saint Pierre Miquelon",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: null,
        },
        totalConfirmedCases: 24,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 16,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: null,
          countryOrRegion: "South Sudan",
          provinceOrState: null,
          county: null,
          isoCode: "SS",
          lat: null,
        },
        totalConfirmedCases: 7349,
        newlyConfirmedCases: 125,
        totalDeaths: 87,
        newDeaths: 0,
        totalRecoveredCases: 4107,
        newlyRecoveredCases: 93,
      },
      {
        location: {
          long: null,
          countryOrRegion: "Sao Tome and Principe",
          provinceOrState: null,
          county: null,
          isoCode: "ST",
          lat: null,
        },
        totalConfirmedCases: 1719,
        newlyConfirmedCases: 47,
        totalDeaths: 27,
        newDeaths: 0,
        totalRecoveredCases: 1315,
        newlyRecoveredCases: 27,
      },
      {
        location: {
          long: 48.516388,
          countryOrRegion: "Yemen",
          provinceOrState: null,
          county: null,
          isoCode: "YE",
          lat: 15.552727,
        },
        totalConfirmedCases: 2436,
        newlyConfirmedCases: 0,
        totalDeaths: 660,
        newDeaths: 0,
        totalRecoveredCases: 1580,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -59.5236,
          countryOrRegion: "Falkland Islands (Malvinas)",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: -51.7963,
        },
        totalConfirmedCases: 13,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 13,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -56.3159,
          countryOrRegion: "Saint Pierre and Miquelon",
          provinceOrState: null,
          county: null,
          isoCode: "PM",
          lat: 46.8852,
        },
        totalConfirmedCases: 1,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 1,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 71.276093,
          countryOrRegion: "Tajikistan",
          provinceOrState: null,
          county: null,
          isoCode: "TJ",
          lat: 38.861034,
        },
        totalConfirmedCases: 13308,
        newlyConfirmedCases: 0,
        totalDeaths: 90,
        newDeaths: 0,
        totalRecoveredCases: 13218,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 43.872219,
          countryOrRegion: "Comoros",
          provinceOrState: null,
          county: null,
          isoCode: "KM",
          lat: -11.875001,
        },
        totalConfirmedCases: 3552,
        newlyConfirmedCases: 13,
        totalDeaths: 144,
        newDeaths: 0,
        totalRecoveredCases: 3203,
        newlyRecoveredCases: 13,
      },
      {
        location: {
          long: 28.233608,
          countryOrRegion: "Lesotho",
          provinceOrState: null,
          county: null,
          isoCode: "LS",
          lat: -29.609988,
        },
        totalConfirmedCases: 10468,
        newlyConfirmedCases: 1,
        totalDeaths: 292,
        newDeaths: 1,
        totalRecoveredCases: 3577,
        newlyRecoveredCases: 159,
      },
      {
        location: {
          long: 160.156194,
          countryOrRegion: "Solomon Islands",
          provinceOrState: null,
          county: null,
          isoCode: "SB",
          lat: -9.64571,
        },
        totalConfirmedCases: 18,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 14,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -177.156097,
          countryOrRegion: "Wallis and Futuna",
          provinceOrState: null,
          county: null,
          isoCode: "WF",
          lat: -13.768752,
        },
        totalConfirmedCases: 9,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 6,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 171.184478,
          countryOrRegion: "Marshall Islands",
          provinceOrState: null,
          county: null,
          isoCode: "MH",
          lat: 7.131474,
        },
        totalConfirmedCases: 4,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 4,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 166.959158,
          countryOrRegion: "Vanuatu",
          provinceOrState: null,
          county: null,
          isoCode: "VU",
          lat: -15.376706,
        },
        totalConfirmedCases: 1,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 1,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: -172.104629,
          countryOrRegion: "Samoa",
          provinceOrState: null,
          county: null,
          isoCode: "WS",
          lat: -13.759029,
        },
        totalConfirmedCases: 3,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 2,
        newlyRecoveredCases: 0,
      },
      {
        location: {
          long: 150.550812,
          countryOrRegion: "Micronesia",
          provinceOrState: null,
          county: null,
          isoCode: null,
          lat: 7.425554,
        },
        totalConfirmedCases: 1,
        newlyConfirmedCases: 0,
        totalDeaths: 0,
        newDeaths: 0,
        totalRecoveredCases: 1,
        newlyRecoveredCases: 0,
      },
    ],
  },
};
